var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllInclusive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.001 135.858L5.55664 151.01L90.1526 200L200.001 136.616V135.858Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.405 86.8682L5.55664 150.252L90.1526 199.242L200.001 135.858L115.405 86.8682Z",
    fill: "#E8E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1526 199.243V200L5.55664 151.01V150.253L90.1526 199.243Z",
    fill: "#868686"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9587 148.232L11.6152 153.283L19.191 157.576L22.7263 157.071L23.989 148.232H20.9587Z",
    fill: "#918B86"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7266 157.07L30.8074 152.525V151.515L22.7266 156.313V157.07Z",
    fill: "#CACACA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7264 157.071L15.9082 153.283V152.273L22.7264 156.313V157.071Z",
    fill: "#8B8B8B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.989 147.475L15.9082 152.273L22.7264 156.313L30.8072 151.515L23.989 147.475Z",
    fill: "#EFEFEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1816 152.273L23.9897 148.99L28.5352 151.515L22.7271 155.05L18.1816 152.273Z",
    fill: "#FF816F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27275 153.284C2.02023 153.536 2.27275 153.536 2.27275 153.284C2.02023 153.536 3.03033 154.294 3.53538 154.294L3.78788 154.546C3.78788 155.051 4.798 155.809 4.798 155.809C4.798 155.809 4.79798 155.809 5.05051 155.556C5.05051 155.556 6.06061 155.556 6.31313 155.556V155.304C6.56566 155.809 7.07071 156.314 7.07071 156.314C7.07071 156.314 7.57577 155.809 7.8283 155.556C8.08082 155.809 9.34343 155.809 9.34343 155.809C9.34343 155.809 9.34345 155.556 9.09092 155.304H9.34343C9.59595 155.556 9.84851 156.062 9.84851 156.062C9.84851 156.062 10.6061 155.809 10.6061 155.304H10.8586C11.1111 155.556 11.3636 156.062 11.3636 156.062C11.3636 156.062 11.6162 155.809 11.8687 155.556H12.1212C12.1212 155.556 12.1212 155.809 12.3738 155.809L12.6263 156.062C12.6263 156.062 13.1313 155.809 13.3838 155.304C13.3838 155.304 13.3839 155.304 13.6364 155.556C13.8889 155.809 14.899 155.809 14.899 155.809C14.899 155.809 14.899 155.556 14.6465 155.304H14.899C15.1515 155.304 15.1515 155.304 15.1515 155.304C15.1515 155.304 15.1515 155.304 15.1515 155.051C15.404 155.051 15.404 154.799 15.6566 154.546C15.9091 154.294 15.9091 154.294 16.1616 154.041C16.1616 153.789 16.1616 153.536 16.4141 153.284C16.4141 153.031 16.6667 153.031 16.9192 152.779C17.1717 152.526 17.4243 152.526 17.9293 152.274C18.1818 152.274 18.4344 152.021 18.6869 152.021C19.1919 152.021 19.697 152.021 20.4546 152.021C20.9596 152.021 21.2121 152.021 21.7172 152.021C21.9697 152.021 22.2222 152.021 22.4748 152.021H22.7273C22.9798 152.274 23.2323 152.274 23.4849 152.274V152.021C23.4849 151.769 23.4849 151.516 23.4849 151.516C23.4849 151.264 23.2323 151.264 22.9798 151.264H22.7273C22.4747 151.264 22.2222 151.264 22.2222 151.516C21.9697 151.516 21.7172 151.516 21.4646 151.516C20.9596 151.516 20.4546 151.516 19.9495 151.516C19.1919 151.516 18.4343 151.516 17.6768 151.516C17.4242 151.516 17.4242 151.516 17.1717 151.516C16.6667 151.264 16.4142 151.264 15.9091 151.011C15.6566 150.758 15.404 150.759 15.1515 150.506C14.899 150.253 14.899 150.253 14.6465 150.001L14.3939 149.748H14.1414C14.1414 149.748 14.1414 149.748 13.8889 149.748C13.6364 149.496 13.6364 149.243 13.6364 149.243C13.6364 149.243 13.3838 149.243 13.1313 149.496C13.1313 149.243 12.8788 148.738 12.8788 148.738C12.8788 148.738 11.8687 148.738 11.6162 148.991C11.6162 148.991 11.6162 148.991 11.6162 149.243C11.3637 148.991 10.3536 148.486 10.3536 148.486V148.738V148.991C10.3536 148.991 10.3535 148.991 10.101 148.991C10.101 148.991 10.101 148.991 9.84851 148.991C9.84851 148.991 9.84849 148.991 9.59597 148.991C9.34344 148.738 8.83838 148.486 8.83838 148.486C8.83838 148.486 8.33334 147.981 8.33334 148.233H8.0808C7.82828 147.981 6.81817 147.476 6.81817 147.476C6.81817 147.476 6.81817 147.981 6.81817 148.233H6.56567C6.56567 147.981 6.31313 147.728 6.31313 147.728C6.31313 147.728 5.30303 147.728 5.05051 147.981C4.79798 147.728 3.78788 147.223 3.78788 147.223C3.78788 147.223 3.53538 147.728 3.53538 148.233C3.53538 147.981 3.28284 147.981 3.28284 147.728C3.03031 147.476 2.27274 147.476 2.02021 147.476H1.76767C1.76767 147.476 1.0101 147.981 1.26263 148.486C1.26263 148.486 1.26264 148.738 1.51517 148.738V148.991C1.26264 148.991 1.01012 148.991 1.01012 148.991C1.01012 148.991 1.0101 149.496 1.26263 150.001H1.01012C0.757599 150.253 0.505043 151.011 0.505043 151.011C0.505043 151.011 0.505058 151.011 0.757583 151.011C0.252533 151.011 0 151.264 0 151.264C0 151.264 0.505074 151.769 1.01012 152.021C0.757599 152.021 0.757583 152.274 0.757583 152.274C0.757583 152.274 1.7677 153.284 2.27275 153.284ZM14.899 151.011C15.1515 151.011 15.404 151.264 15.9091 151.516C15.9091 151.516 16.1616 151.516 16.4141 151.769C16.1616 151.769 15.9091 151.769 15.6566 151.769H15.4041C15.4041 151.769 15.404 151.769 15.1515 151.769C14.899 151.516 14.6465 151.264 14.3939 151.264C14.3939 151.264 14.394 151.264 14.1414 151.264C14.1414 151.264 14.1414 151.011 14.3939 151.011C14.6465 150.758 14.899 150.758 14.899 151.011ZM17.4243 152.021C17.1717 152.021 17.1717 152.274 16.9192 152.274L16.6667 152.526C16.4142 152.779 15.9091 153.031 15.4041 153.284L15.1515 153.031C15.1515 153.031 15.1515 153.031 15.4041 153.031C15.6566 153.031 15.6566 152.526 15.9091 152.274C16.1616 152.021 16.6667 152.021 17.4243 152.021ZM14.1414 149.748C14.1414 149.748 14.394 150.001 14.1414 150.001C13.8889 150.001 13.8889 149.748 13.6364 149.748V149.496C13.8889 149.748 13.8889 149.748 14.1414 149.748ZM15.1515 154.546C15.1515 154.294 15.1515 154.041 14.899 153.789C15.1515 153.789 15.6566 153.536 15.6566 153.536C15.6566 153.536 15.6566 153.536 15.4041 153.284C15.6566 153.284 15.9091 153.284 15.9091 153.536V153.789C15.9091 154.041 15.6566 154.294 15.6566 154.294C15.6566 154.546 15.404 154.546 15.1515 154.546Z",
    fill: "#918B86"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2602 141.922H26.0077C25.5026 141.922 26.0077 140.912 26.0077 140.66C26.0077 140.407 26.0077 140.154 26.2602 139.902C26.2602 139.649 26.5127 139.397 26.5127 138.892C26.5127 138.892 26.5127 139.144 26.2602 139.144C26.2602 139.397 26.0077 139.397 26.0077 139.649C26.0077 139.902 25.7551 140.154 25.7551 140.66C25.5026 141.417 24.9976 142.175 24.4925 142.932C24.4925 143.185 24.24 143.185 24.24 143.437C23.9875 143.69 23.735 144.195 23.735 144.447C23.735 144.7 23.735 144.952 23.735 145.205C23.735 145.458 23.735 145.458 23.735 145.71C23.735 146.215 23.7349 146.72 23.4824 147.225C23.4824 146.973 23.735 146.72 23.735 146.468C23.9875 145.963 23.9875 145.458 24.24 144.7C24.4925 144.195 24.4925 143.69 24.9976 143.185C25.2501 142.932 25.5026 142.68 25.5026 142.427C25.7552 142.175 26.2602 142.175 26.5127 141.922C26.7652 141.67 27.2703 141.417 27.2703 141.165C27.7754 140.66 28.2804 139.902 28.5329 139.144C28.7855 138.892 28.7855 138.387 28.7855 138.134C28.5329 138.639 28.2804 139.144 28.0279 139.649C27.7754 140.154 27.5228 140.66 27.2703 141.165C27.0178 141.417 26.7653 141.67 26.2602 141.922Z",
    fill: "#91651F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7356 146.215C23.7356 145.963 23.7356 145.71 23.7356 145.458C23.7356 145.205 23.7356 144.953 23.7356 144.7C23.7356 144.448 23.9881 143.943 24.2406 143.69C24.2406 143.438 24.4931 143.438 24.4931 143.185C24.9981 142.427 25.5032 141.67 25.7557 140.912C25.7557 140.66 26.0083 140.407 26.0083 139.902V139.65C26.0083 139.397 26.2608 139.145 26.2608 138.892C26.2608 138.892 26.2608 139.145 26.0083 139.145C26.0083 139.397 25.7557 139.397 25.7557 139.65C25.7557 139.902 25.5032 140.155 25.5032 140.66C25.2507 141.417 24.7456 142.175 24.2406 142.932C24.2406 143.185 23.9881 143.185 23.9881 143.438C23.7355 143.69 23.483 144.195 23.483 144.448C23.483 144.7 23.483 144.953 23.483 145.205C23.483 145.458 23.483 145.458 23.483 145.71C23.483 146.215 23.483 146.72 23.2305 147.225C23.483 146.973 23.483 146.72 23.7356 146.215C23.7356 146.468 23.7356 146.468 23.7356 146.215Z",
    fill: "#AA7723"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7071 140.912C20.9596 140.912 20.9597 141.165 21.2122 140.912C21.2122 140.912 21.4647 140.66 21.2122 140.407V140.154C21.2122 139.649 20.9597 139.144 20.9597 138.639C20.7071 137.882 20.7071 137.124 20.7071 136.619C20.9596 137.124 20.9597 137.629 20.9597 138.387C20.9597 138.639 20.9597 139.144 21.2122 139.397C21.2122 139.649 21.2122 139.649 21.4647 139.902C21.4647 140.155 21.4647 140.154 21.4647 140.407C21.4647 140.66 21.7172 140.912 21.7172 141.165C21.7172 141.417 21.9697 141.67 21.9697 141.922C22.2223 142.175 22.2223 142.68 22.4748 142.932C22.7274 143.185 22.9799 143.69 22.9799 143.942C22.9799 144.195 22.9799 144.447 22.9799 144.7C22.9799 144.952 22.9799 144.952 22.9799 145.205C22.9799 145.71 22.9798 146.215 23.2324 146.72C23.2324 146.468 22.9799 146.215 22.9799 145.963C22.7273 145.458 22.7274 144.952 22.4748 144.195C22.2223 143.69 22.2223 143.185 21.7172 142.68C21.4647 142.427 21.2122 142.175 21.2122 141.922C20.9597 141.67 20.7071 141.67 20.4546 141.417C20.2021 141.165 19.9496 141.165 19.9496 140.912C19.4445 140.407 18.9395 139.649 18.9395 138.892C18.9395 139.144 19.192 139.397 19.192 139.397C19.4445 139.649 19.4445 139.902 19.697 140.154C19.9496 140.154 20.2021 140.66 20.7071 140.912Z",
    fill: "#91651F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9609 138.387C20.9609 138.639 20.9609 139.144 21.2134 139.397C21.2134 139.65 21.2134 139.65 21.4659 139.902C21.4659 140.155 21.4659 140.155 21.4659 140.407C21.4659 140.66 21.7185 140.912 21.7185 141.165C21.7185 141.417 21.971 141.67 21.971 141.922C22.2235 142.175 22.2235 142.68 22.476 142.932C22.7286 143.185 22.9811 143.69 22.9811 143.942C22.9811 144.195 22.9811 144.447 22.9811 144.7C22.9811 144.7 22.9811 144.7 22.9811 144.953C22.9811 145.205 23.2336 145.458 23.2336 145.71C23.2336 145.963 23.4861 146.215 23.4861 146.468C23.4861 145.963 23.2336 145.458 23.2336 144.953C23.2336 144.7 23.2336 144.7 23.2336 144.448C23.2336 144.195 23.2336 143.942 23.2336 143.69C23.2336 143.437 22.9811 142.932 22.7285 142.68C22.476 142.427 22.2235 141.922 22.2235 141.67C22.2235 141.417 21.971 141.165 21.971 140.912C21.971 140.66 21.7185 140.407 21.7185 140.155C21.7185 139.902 21.7185 139.902 21.7185 139.65C21.7185 139.397 21.7184 139.397 21.4659 139.144C21.4659 138.892 21.2134 138.387 21.2134 138.134C21.2134 137.629 20.9609 137.124 20.9609 136.367C20.9609 136.619 20.9609 136.619 20.9609 136.872C20.7084 137.377 20.7084 137.882 20.9609 138.387Z",
    fill: "#AA7723"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.697 140.407L19.9496 140.659C19.9496 140.659 19.9496 140.912 20.2021 140.912L20.4546 141.164C20.7071 141.164 20.7071 141.417 20.9597 141.164V140.912C20.7071 140.912 20.7071 140.912 20.4546 140.912C20.2021 140.659 19.697 140.154 19.697 139.902C19.4445 139.649 19.4445 139.397 19.192 139.144C19.192 139.144 18.9395 138.892 18.9395 138.639C18.9395 138.892 18.9395 139.144 19.192 139.649C19.4445 139.902 19.697 140.154 19.697 140.407Z",
    fill: "#AA7723"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9878 151.77C23.7353 152.023 23.4827 152.275 23.2302 152.275C22.9777 152.275 22.4727 152.023 22.4727 152.023C22.4727 152.023 22.4727 152.023 22.4727 151.77C22.4727 151.517 22.7252 151.265 22.7252 150.76C22.7252 150.507 22.7252 150.002 22.7252 149.75C22.7252 148.992 22.7252 148.235 22.7252 147.73C22.7252 145.962 22.7252 144.194 22.7252 142.427C22.7252 142.174 22.7252 142.174 22.7252 141.922C22.7252 141.416 22.7252 141.164 22.7252 140.659C22.7252 140.154 22.7252 139.901 22.7252 139.396V139.144V138.891V138.639V138.386V138.134V137.881C22.7252 137.629 22.7252 137.629 22.7252 137.376C22.7252 137.376 22.7252 137.376 22.7252 137.124C22.7252 138.639 22.7252 139.901 22.7252 141.416C22.7252 142.427 22.7252 143.184 22.7252 144.194C22.7252 144.699 22.7252 145.204 22.7252 145.709C22.7252 146.467 22.7252 147.225 22.7252 147.982C22.7252 148.487 22.7252 149.245 22.7252 149.75C22.7252 150.002 22.7252 150.507 22.7252 150.76C22.7252 150.76 22.7252 150.76 22.7252 151.012V151.265C23.7353 151.517 23.7353 151.517 23.9878 151.77Z",
    fill: "#91651F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7367 137.123C23.4842 137.628 23.4841 138.133 23.4841 138.638C23.2316 139.901 23.2316 140.911 23.2316 142.174C23.2316 143.941 22.9791 145.709 23.2316 147.477C23.2316 148.234 23.2316 148.992 23.2316 149.497C23.2316 149.749 23.2316 150.254 23.2316 150.507C23.2316 150.759 23.2316 151.012 22.9791 151.517C22.9791 151.77 22.7266 151.77 22.7266 152.022C22.7266 152.022 22.7266 152.022 22.7266 151.77C22.7266 151.517 22.9791 151.264 22.9791 150.759C22.9791 150.507 22.9791 150.002 22.9791 149.749C22.9791 148.992 22.9791 148.234 22.9791 147.729C22.9791 145.961 22.9791 144.194 22.9791 142.426C22.9791 142.174 22.9791 142.174 22.9791 141.921C22.9791 141.416 22.9791 141.163 22.9791 140.658C22.9791 140.153 22.9791 139.901 22.9791 139.396V139.143V138.891V138.638V138.386V138.133V137.881C23.4842 137.628 23.4842 137.376 23.7367 137.123Z",
    fill: "#855107"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9881 151.771C23.9881 152.023 23.9881 152.023 23.9881 151.771C23.7355 151.771 23.7356 151.771 23.7356 151.771C23.7356 151.771 23.483 151.771 23.483 151.518C23.2305 151.266 23.2305 151.013 23.2305 150.761C23.2305 150.508 23.2305 150.003 23.2305 149.75C23.2305 149.245 23.2305 148.488 23.2305 147.983C23.2305 147.225 23.2305 146.468 23.2305 145.71C23.2305 145.205 23.2305 144.7 23.2305 144.195C23.2305 143.185 23.2305 142.427 23.2305 141.417C23.2305 140.407 23.2305 139.397 23.2305 138.387C23.2305 138.134 23.2305 137.882 23.2305 137.377C23.2305 137.124 23.2305 137.124 23.2305 136.872C23.2305 136.872 23.2305 136.872 23.2305 136.619C23.2305 138.134 23.2305 139.397 23.2305 140.912C23.2305 141.922 23.2305 142.68 23.2305 143.69C23.2305 144.195 23.2305 144.7 23.2305 145.205C23.2305 145.963 23.2305 146.72 23.2305 147.478C23.2305 147.983 23.2305 148.74 23.2305 149.245C23.2305 149.498 23.2305 150.003 23.2305 150.256C23.2305 150.256 23.2305 150.256 23.2305 150.508V150.761C23.7355 151.518 23.7355 151.518 23.9881 151.771Z",
    fill: "#AA7723"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1811 133.84C17.6761 133.587 17.1711 132.325 17.1711 132.325C17.1711 132.325 17.6761 132.072 18.1811 131.819V131.567C17.6761 131.567 17.1711 131.567 17.1711 131.567C17.1711 131.567 17.1711 130.304 17.6761 129.799C17.1711 129.547 16.666 128.537 16.666 128.537C16.666 128.537 17.4236 128.032 18.1811 127.779C17.9286 127.779 17.6761 127.527 17.6761 127.527C17.4236 127.022 17.4236 125.759 17.4236 125.759C17.4236 125.759 17.9286 125.759 18.1811 125.759V125.506L18.6862 125.759H18.9387C19.4438 125.506 20.4539 125.506 20.4539 125.506C20.4539 125.506 20.4539 125.759 20.4539 126.011C20.7064 126.011 21.2115 126.516 21.464 126.769C21.969 126.516 22.2216 126.264 22.2216 126.264C22.2216 126.264 22.4741 126.516 22.4741 127.021H22.7266L22.9791 126.769C23.2317 126.769 23.2317 126.516 23.4842 126.769C23.4842 127.021 23.4842 127.274 23.4842 127.527C23.4842 127.527 23.4842 127.527 23.7367 127.527H23.9892C23.9892 127.527 24.4943 128.789 24.2418 129.294C24.2418 129.294 24.2418 129.547 23.9892 129.547C23.9892 129.799 23.9893 130.304 23.7367 130.557C24.2418 130.809 24.4943 131.062 24.4943 131.062C24.4943 131.062 23.9893 131.567 23.7367 131.819C23.9893 132.072 24.2418 133.082 23.9892 133.335V133.587C24.4943 133.84 24.7468 135.102 24.7468 135.102C24.7468 135.102 24.4943 135.102 24.2418 135.355V135.607C24.2418 135.86 24.4943 135.86 24.4943 135.86C24.4943 136.112 24.2418 136.112 23.9892 136.365L23.7367 136.617C23.4842 136.87 23.9892 136.87 24.2418 136.87C24.2418 136.87 23.9893 138.133 23.7367 138.385V139.143C23.7367 139.395 23.7367 139.648 23.7367 139.648V140.405H23.4842C23.4842 140.658 23.2316 140.91 23.2316 140.91C23.2316 140.91 21.969 140.405 21.7165 139.9V139.648C21.464 139.9 20.9589 140.153 20.9589 140.153C20.9589 140.153 20.4539 139.648 20.4539 139.143C20.4539 139.143 20.4539 139.143 20.2014 139.143C19.6963 139.395 18.4337 139.143 18.4337 139.143C18.4337 139.143 18.4337 138.638 18.6862 138.385C18.1812 138.638 17.4236 138.638 17.4236 138.638C17.4236 138.638 17.4236 137.375 17.6761 136.87C17.6761 136.87 17.9286 136.87 17.9286 136.617C17.4236 136.365 16.9185 135.355 16.9185 135.355L17.1711 135.102H17.4236L17.6761 134.85V134.597C17.6761 134.597 17.6761 134.597 17.4236 134.345C17.1711 134.092 16.666 133.335 16.666 133.335C16.666 133.335 17.1711 133.082 17.6761 132.83L18.1811 133.84Z",
    fill: "#567601"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0383 133.84C29.5433 133.587 30.0484 132.325 30.0484 132.325C30.0484 132.325 29.5433 132.072 29.0383 131.819V131.567C29.5433 131.567 30.0484 131.567 30.0484 131.567C30.0484 131.567 30.0484 130.304 29.5433 129.799C30.0484 129.547 30.5535 128.537 30.5535 128.537C30.5535 128.537 29.7959 128.032 29.0383 127.779C29.2908 127.779 29.5433 127.527 29.5433 127.527C29.7959 127.022 29.7959 125.759 29.7959 125.759C29.7959 125.759 29.2908 125.759 29.0383 125.759V125.506L28.5332 125.759H28.2807C27.7757 125.506 26.7656 125.506 26.7656 125.506C26.7656 125.506 26.7656 125.759 26.7656 126.011C26.5131 126.011 26.008 126.516 25.7555 126.769C25.2504 126.516 24.9979 126.264 24.9979 126.264C24.9979 126.264 24.7454 126.516 24.7454 127.021H24.4928L24.2403 126.769C23.9878 126.769 23.9878 126.516 23.7353 126.769C23.7353 127.021 23.7353 127.274 23.7353 127.527C23.7353 127.527 23.7353 127.527 23.4827 127.527H23.2302C23.2302 127.527 22.7252 128.789 22.9777 129.294C22.9777 129.294 22.9777 129.547 23.2302 129.547C23.2302 129.799 23.2302 130.304 23.4827 130.557C22.9777 130.809 22.7252 131.062 22.7252 131.062C22.7252 131.062 23.2302 131.567 23.4827 131.819C23.2302 132.072 22.9777 133.082 23.2302 133.335V133.587C22.7252 133.84 22.4727 135.102 22.4727 135.102C22.4727 135.102 22.7252 135.102 22.9777 135.355V135.607C22.9777 135.86 22.7252 135.86 22.7252 135.86C22.7252 136.112 22.9777 136.112 23.2302 136.365L23.4827 136.617C23.7353 136.87 23.2302 136.87 22.9777 136.87C22.9777 136.87 23.2302 138.133 23.4827 138.385V139.143C23.4827 139.395 23.4827 139.648 23.4827 139.648V140.405H23.7353C23.7353 140.658 23.9878 140.91 23.9878 140.91C23.9878 140.91 25.2504 140.405 25.503 139.9V139.648C25.7555 139.9 26.2605 140.153 26.2605 140.153C26.2605 140.153 26.7656 139.648 26.7656 139.143C26.7656 139.143 26.7656 139.143 27.0181 139.143C27.5231 139.395 28.7858 139.143 28.7858 139.143C28.7858 139.143 28.7858 138.638 28.5332 138.385C29.0383 138.638 29.7959 138.638 29.7959 138.638C29.7959 138.638 29.7959 137.375 29.5433 136.87C29.5433 136.87 29.2908 136.87 29.2908 136.617C29.7959 136.365 30.3009 135.355 30.3009 135.355L30.0484 135.102H29.7959L29.5433 134.85V134.597C29.5433 134.597 29.5433 134.597 29.7959 134.345C30.0484 134.092 30.5535 133.335 30.5535 133.335C30.5535 133.335 30.0484 133.082 29.5433 132.83L29.0383 133.84Z",
    fill: "#638800"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2799 125.254L27.7748 125.002C27.7748 124.496 26.5122 123.486 26.5122 123.486C26.5122 123.486 26.5122 123.739 26.2597 123.739C26.0072 123.234 24.9971 122.476 24.9971 122.476C24.9971 122.476 24.9971 122.729 24.7445 122.981C24.2395 122.476 23.4819 121.971 23.4819 121.971C23.4819 121.971 23.2294 122.476 22.9769 123.234C22.9769 122.981 22.7243 122.981 22.7243 122.981C22.7243 122.981 21.4617 123.486 21.2092 123.991C21.2092 123.991 21.2092 124.244 21.2092 124.496C20.7042 124.496 19.694 124.496 19.694 124.496C19.694 124.496 19.6941 124.749 19.9466 125.254L19.694 125.507C19.4415 125.507 19.4415 125.507 19.189 125.507C18.6839 125.507 17.6738 126.769 17.6738 126.769C17.6738 126.769 18.6839 127.779 19.4415 127.779H19.694C19.694 128.284 20.9567 129.042 20.9567 129.042C20.9567 129.042 21.2092 128.789 21.4617 128.537H21.7142C21.9668 129.042 22.7243 129.799 22.7243 129.799C22.7243 129.799 22.9769 129.547 23.2294 129.294H23.4819C23.4819 129.294 23.4819 129.294 23.4819 129.547C23.7344 129.799 23.987 129.799 24.2395 129.799C24.7446 129.799 25.2496 129.799 25.2496 129.799C25.2496 129.799 25.2496 129.547 25.2496 129.042C25.5021 129.294 26.0072 129.547 26.0072 129.547C26.0072 129.547 26.7648 128.789 26.7648 128.032H27.0173C27.2698 128.284 27.7748 128.789 27.7748 128.789C27.7748 128.789 28.5324 127.779 28.5324 127.274C28.7849 127.274 28.7849 127.274 29.0375 127.274C29.5425 127.274 30.5526 126.012 30.5526 126.012C30.5526 126.012 28.7849 125.002 28.2799 125.254Z",
    fill: "#769C11"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9994 114.394L0.251953 153.788L41.161 177.272L85.6055 173.484L93.9388 156.313L74.9994 114.394Z",
    fill: "#918B86"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M140.91 108.586L152.021 102.272V133.586L140.91 140.151V108.586Z",
    fill: "url(#paint0_linear_337_9182)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M141.92 115.656V139.646L149.748 135.1V109.595C149.748 108.838 149.496 108.08 148.738 107.575C147.981 107.323 147.223 107.323 146.465 107.828C144.95 108.585 143.94 109.848 143.183 111.11C142.425 112.373 141.92 113.888 141.92 115.656Z",
    fill: "#3C354E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M149.243 109.595V134.595L142.678 138.383V115.656C142.678 114.141 143.183 112.626 143.94 111.363C144.193 110.858 144.445 110.353 144.95 110.1C145.708 109.343 146.466 108.838 147.223 108.333C147.476 108.08 147.981 108.08 148.233 108.08H148.486H148.738C148.991 108.333 149.243 108.838 149.243 109.595Z",
    fill: "url(#paint1_linear_337_9182)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M148.233 107.827L146.213 135.605L142.678 137.625L144.698 109.847C145.455 109.09 146.213 108.585 146.971 108.08C147.223 107.827 147.728 107.827 147.981 107.827H148.233Z",
    fill: "url(#paint2_linear_337_9182)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M148.738 134.343V109.343C148.738 108.838 148.486 108.333 148.233 108.08H148.486C148.991 108.585 149.243 109.09 149.243 109.595V134.595L142.678 138.383V137.878L148.738 134.343Z",
    fill: "#666175"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.76 110.605L155.558 107.827V132.827L150.76 135.605V110.605Z",
    fill: "#D48C5D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M149.748 109.848L150.758 110.606V135.606L149.748 135.101V109.848Z",
    fill: "#746A8A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M154.548 88.1304V107.322L150.76 110.605L149.75 110.1V109.595C149.75 107.322 147.477 106.06 145.457 107.07C142.679 108.837 140.911 111.868 140.911 115.151L137.123 118.433L136.113 117.928V98.7364L154.548 88.1304Z",
    fill: "#746A8A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 118.434L141.919 115.656V140.908L137.121 143.686V118.434Z",
    fill: "#D48C5D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M136.113 117.928L137.123 118.433V143.686L136.113 142.928V117.928Z",
    fill: "#746A8A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M137.627 141.414L142.425 138.636V141.161L137.627 143.939V141.414Z",
    fill: "#C5A397"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 141.161L137.626 141.413V143.938L137.121 143.686V141.161Z",
    fill: "#3C354E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M141.919 138.383L142.424 138.635L137.626 141.413L137.121 141.161L141.919 138.383Z",
    fill: "#DDCAC3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M151.266 133.585L156.064 130.808V133.08L151.266 135.858V133.585Z",
    fill: "#C5A397"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M150.76 133.08L151.265 133.585V135.858L150.76 135.605V133.08Z",
    fill: "#3C354E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M155.558 130.302L156.063 130.807L151.265 133.585L150.76 133.08L155.558 130.302Z",
    fill: "#DDCAC3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M137.627 121.717L142.425 118.939V121.212L137.627 123.99V121.717Z",
    fill: "#C5A397"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 121.212L137.626 121.717V123.99L137.121 123.737V121.212Z",
    fill: "#746A8A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M141.919 118.434L142.424 118.939L137.626 121.717L137.121 121.212L141.919 118.434Z",
    fill: "#DDCAC3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M151.266 113.636L156.064 110.858V113.383L151.266 116.161V113.636Z",
    fill: "#C5A397"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M150.76 113.383L151.265 113.635V116.161L150.76 115.908V113.383Z",
    fill: "#746A8A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M155.558 110.605L156.063 110.858L151.265 113.635L150.76 113.383L155.558 110.605Z",
    fill: "#DDCAC3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M155.555 88.6362V107.828L150.757 110.606V110.101C150.757 107.828 148.485 106.566 146.465 107.576C143.687 109.343 141.919 112.374 141.919 115.656L137.121 118.434V99.2423L155.555 88.6362Z",
    fill: "#D48C5D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M145.71 136.615L145.457 136.362V109.089L145.71 108.837V136.615Z",
    fill: "#666175"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M138.133 99.9987L156.567 89.1401V91.6654L138.133 102.271V99.9987Z",
    fill: "#D6BAB0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 99.2412L138.131 99.9988V102.272L137.121 101.766V99.2412Z",
    fill: "#746A8A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M154.548 88.1304L156.568 89.1405L138.133 99.9991L136.113 98.7364L154.548 88.1304Z",
    fill: "#DDCAC3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M145.709 106.313L148.234 104.798L147.477 107.576L145.962 108.586L145.709 106.313Z",
    fill: "#DAC8C1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M145.203 106.061L145.708 106.313L145.961 108.586L145.456 108.081L145.203 106.061Z",
    fill: "#938C9F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M147.728 104.545L148.233 104.797L145.708 106.313L145.203 106.06L147.728 104.545Z",
    fill: "#F2F2F2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M140.912 136.868L142.427 136.11V138.636L140.912 139.393V136.868Z",
    fill: "#DAC8C1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M140.406 136.615L140.911 136.867V139.393L140.406 139.14V136.615Z",
    fill: "#938C9F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M141.921 135.858L142.426 136.11L140.911 136.868L140.406 136.615L141.921 135.858Z",
    fill: "#F2F2F2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M151.266 131.059L152.781 130.302V132.827L151.266 133.585V131.059Z",
    fill: "#DAC8C1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M150.76 130.806L151.265 131.059V133.584L150.76 133.079V130.806Z",
    fill: "#938C9F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M152.275 130.049L152.78 130.301L151.265 131.059L150.76 130.806L152.275 130.049Z",
    fill: "#F2F2F2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M140.912 127.02L142.427 126.263V128.788L140.912 129.546V127.02Z",
    fill: "#DAC8C1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M140.406 126.767L140.911 127.02V129.545L140.406 129.292V126.767Z",
    fill: "#938C9F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M141.921 126.01L142.426 126.262L140.911 127.02L140.406 126.767L141.921 126.01Z",
    fill: "#F2F2F2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M151.266 121.211L152.781 120.453V122.978L151.266 123.736V121.211Z",
    fill: "#DAC8C1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M150.76 120.958L151.265 121.21V123.735L150.76 123.23V120.958Z",
    fill: "#938C9F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M152.275 120.201L152.78 120.453L151.265 121.211L150.76 120.958L152.275 120.201Z",
    fill: "#F2F2F2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M142.426 117.677L149.496 113.636V116.161L142.426 120.202V117.677Z",
    fill: "#746A8A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M142.426 118.181L149.496 114.14V116.665L142.426 120.453V118.181Z",
    fill: "#3C354E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M145.709 137.12L146.214 136.868V108.333L145.709 108.585V137.12Z",
    fill: "#3C354E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M145.708 116.162L145.455 115.909V114.899H145.708V116.162Z",
    fill: "#666175"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 74.2419L155.555 63.3833V88.6358L137.121 99.2419V74.2419Z",
    fill: "#FFC9B0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M141.924 91.4149L150.762 86.3644V69.6978L141.924 75.0008V91.4149Z",
    fill: "#C7C1B6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 70.4553V85.3543L150.763 86.3644V69.6978L149.5 70.4553Z",
    fill: "#ABA396"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 85.355L150.762 86.3651L141.924 91.4156V89.9004L149.5 85.355Z",
    fill: "#EEEEEE"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M149.502 85.3526L141.926 89.8981V74.9991L149.502 70.4536V85.3526Z",
    fill: "#3C354E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M149.248 70.9595V85.3534L146.723 86.8686L143.945 88.3837L142.178 89.3938V74.9999L144.703 73.4847L147.733 71.9696L149.248 70.9595Z",
    fill: "url(#paint3_linear_337_9182)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M147.733 71.9692L146.723 86.8682L143.945 88.3834L144.703 73.4844L147.733 71.9692Z",
    fill: "url(#paint4_linear_337_9182)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M149.248 77.5255L148.996 77.2729L142.178 81.3133V81.5659L149.248 77.5255Z",
    fill: "#666175"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M148.996 71.212V85.1009L142.178 88.8888V89.3938L149.248 85.3534V70.9595L148.996 71.212Z",
    fill: "#666175"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M143.69 88.3852H143.438V74.2437L143.69 73.9912V88.3852Z",
    fill: "#666175"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M143.689 88.8898L143.942 88.6373V73.7383L143.689 73.9908V88.8898Z",
    fill: "#3C354E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M147.984 86.1122L147.479 85.8597V71.9708L147.984 71.7183V86.1122Z",
    fill: "#666175"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M147.984 86.3643H148.237V71.4653H147.984V86.3643Z",
    fill: "#3C354E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M149.498 77.2729V78.5356L141.922 83.081V81.5659L149.498 77.2729Z",
    fill: "#3C354E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M137.627 97.2224L156.061 86.3638V88.889L137.627 99.4951V97.2224Z",
    fill: "#D6BAB0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 96.7173L137.626 97.2223V99.4951L137.121 99.2425V96.7173Z",
    fill: "#746A8A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M155.555 86.1108L156.06 86.3634L137.626 97.222L137.121 96.7169L155.555 86.1108Z",
    fill: "#DDCAC3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M137.627 74.4954L138.89 73.7378V96.2125L137.627 97.2227V74.4954Z",
    fill: "#DAC8C1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 74.2422L137.626 74.4947V97.222L137.121 96.7169V74.2422Z",
    fill: "#938C9F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M138.384 73.2324L138.889 73.7375L137.626 74.495L137.121 74.2425L138.384 73.2324Z",
    fill: "#F2F2F2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M154.801 64.6463L156.063 63.6362V86.3635L154.801 87.1211V64.6463Z",
    fill: "#E0CAC1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M154.295 64.1406L154.8 64.6457V87.1204L154.295 86.8679V64.1406Z",
    fill: "#938C9F"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M155.558 63.3833L156.063 63.6358L154.8 64.6459L154.295 64.1409L155.558 63.3833Z",
    fill: "#F2F2F2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M142.428 91.6677L151.266 86.6172V87.6273L142.428 92.9303V91.6677Z",
    fill: "#DAC8C1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M141.922 91.415L142.427 91.6676V92.9302L141.922 92.4251V91.415Z",
    fill: "#938C9F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M150.76 86.3643L151.265 86.6168L142.427 91.6673L141.922 91.4148L150.76 86.3643Z",
    fill: "#F2F2F2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M142.428 74.243L151.266 68.9399V69.95L142.428 75.2531V74.243Z",
    fill: "#DAC8C1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M141.922 73.7378L142.427 74.2428V75.253L141.922 75.0004V73.7378Z",
    fill: "#938C9F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M150.76 68.687L151.265 68.9395L142.427 74.2426L141.922 73.7375L150.76 68.687Z",
    fill: "#F2F2F2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 48.9894L155.555 38.3833V63.3833L137.121 74.2419V48.9894Z",
    fill: "#FFC9B0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M129.799 25.505L148.233 14.8989L155.556 35.8585L137.122 46.4646L129.799 25.505Z",
    fill: "#007285"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M103.537 10.6061L122.224 0L148.234 14.899L129.8 25.5051L103.537 10.6061Z",
    fill: "#02A1AC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M141.924 66.4149L150.762 61.1119V44.6978L141.924 49.7483V66.4149Z",
    fill: "#C7C1B6"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 45.2028V60.3543L150.763 61.1119V44.6978L149.5 45.2028Z",
    fill: "#ABA396"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 60.354L150.762 61.1116L141.924 66.4146V64.8995L149.5 60.354Z",
    fill: "#EEEEEE"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M149.502 60.3551L141.926 64.9006V49.7491L149.502 45.2036V60.3551Z",
    fill: "#3C354E"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M149.248 45.709V60.1029L146.723 61.6181L143.945 63.3858L142.178 64.1433V49.7494L144.703 48.2342L147.733 46.7191L149.248 45.709Z",
    fill: "url(#paint5_linear_337_9182)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M147.733 46.7188L146.723 61.6177L143.945 63.3854L144.703 48.2339L147.733 46.7188Z",
    fill: "url(#paint6_linear_337_9182)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M149.248 52.2754H148.996L142.178 56.0633V56.5683L149.248 52.2754Z",
    fill: "#666175"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M148.996 45.9615V59.8504L142.178 63.8908V64.1433L149.248 60.1029V45.709L148.996 45.9615Z",
    fill: "#666175"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M143.69 63.3847L143.438 63.1321V49.2433L143.69 48.9907V63.3847Z",
    fill: "#666175"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M143.689 63.6369H143.942V48.4854L143.689 48.7379V63.6369Z",
    fill: "#3C354E"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M147.984 60.8602H147.479V46.7188H147.984V60.8602Z",
    fill: "#666175"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M147.984 61.3644L148.237 61.1119V46.2129L147.984 46.4654V61.3644Z",
    fill: "#3C354E"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M149.498 52.2729V53.5356L141.922 57.8285V56.5659L149.498 52.2729Z",
    fill: "#3C354E"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M137.627 71.9693L156.061 61.3633V63.636L137.627 74.4946V71.9693Z",
    fill: "#D6BAB0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 71.7163L137.626 71.9688V74.4941L137.121 74.2416V71.7163Z",
    fill: "#746A8A"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M155.555 60.8579L156.06 61.363L137.626 71.969L137.121 71.7165L155.555 60.8579Z",
    fill: "#DDCAC3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M137.627 49.2429L138.89 48.4854V71.2126L137.627 71.9702V49.2429Z",
    fill: "#DAC8C1"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 48.9897L137.626 49.2423V71.9695L137.121 71.717V48.9897Z",
    fill: "#938C9F"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M138.384 48.2324L138.889 48.4849L137.626 49.2425L137.121 48.99L138.384 48.2324Z",
    fill: "#F2F2F2"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M154.801 39.3938L156.063 38.6362V61.3635L154.801 62.1211V39.3938Z",
    fill: "#E0CAC1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M154.295 39.1406L154.8 39.3931V62.1204L154.295 61.6154V39.1406Z",
    fill: "#938C9F"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M155.558 38.3833L156.063 38.6358L154.8 39.3934L154.295 39.1409L155.558 38.3833Z",
    fill: "#F2F2F2"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M142.428 66.6668L151.266 61.3638V62.6264L142.428 67.6769V66.6668Z",
    fill: "#DAC8C1"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M141.922 66.4141L142.427 66.6666V67.6767L141.922 67.4242V66.4141Z",
    fill: "#938C9F"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M150.76 61.1108L151.265 61.3634L142.427 66.6664L141.922 66.4139L150.76 61.1108Z",
    fill: "#F2F2F2"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M142.428 48.9904L151.266 43.9399V44.95L142.428 50.0006V48.9904Z",
    fill: "#DAC8C1"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M141.922 48.7378L142.427 48.9903V50.0004L141.922 49.7479V48.7378Z",
    fill: "#938C9F"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M150.76 43.4346L151.265 43.9396L142.427 48.9901L141.922 48.7376L150.76 43.4346Z",
    fill: "#F2F2F2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M139.141 47.7267L157.575 37.1206V39.3933L139.141 50.2519V47.7267Z",
    fill: "#D6BAB0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M137.121 46.4644L139.141 47.727V50.2522L137.121 48.9896V46.4644Z",
    fill: "#746A8A"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M155.555 35.8579L157.576 37.1205L139.141 47.7266L137.121 46.464L155.555 35.8579Z",
    fill: "#DDCAC3"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M145.455 28.535C146.718 27.7774 148.486 28.535 148.991 30.0501L149.496 33.0804L140.152 38.3835L140.657 35.3532C141.162 32.3229 142.93 29.7976 145.455 28.535Z",
    fill: "#3C354E"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M140.405 35.8591C140.91 33.3339 142.426 30.8086 144.698 29.546C144.951 29.2935 145.203 29.2935 145.456 29.2935C146.213 29.2935 146.971 29.7985 147.224 30.5561L147.729 33.0813L139.9 37.6268L140.405 35.8591Z",
    fill: "url(#paint7_linear_337_9182)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M147.475 30.5561C147.223 29.7985 146.717 29.546 146.212 29.2935C146.717 29.546 146.97 29.7985 146.97 30.3036L147.475 32.8288L140.404 36.8692V37.3743L148.233 32.8288L147.475 30.5561Z",
    fill: "#666175"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M143.689 29.7993V35.3549L143.942 35.6074V29.7993C143.942 29.7993 143.942 29.7993 143.689 29.7993Z",
    fill: "#4E475F"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M143.941 29.5465V35.6071L144.194 35.3546V29.2939C144.194 29.5465 144.194 29.5465 143.941 29.5465Z",
    fill: "#3C354E"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M148.74 30.5553C148.235 28.7876 146.467 28.0301 144.952 28.7876L144.447 29.0402C144.447 29.0402 144.7 29.2927 144.7 29.5452H144.952C146.215 28.7876 147.983 29.5452 148.235 31.0604L148.993 33.8381L149.75 34.3432L148.74 30.5553Z",
    fill: "#004547"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M145.202 25.5045C144.192 24.2419 142.677 23.2318 141.414 23.7368C140.151 24.4944 139.141 25.5045 138.384 27.0197C138.131 27.7772 137.879 28.5348 137.626 29.2924L137.121 32.3227L137.626 33.3328L140.151 39.3934L142.172 31.3126L145.202 28.7873L146.97 28.2823L148.99 29.0399L145.202 25.5045Z",
    fill: "url(#paint8_linear_337_9182)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M149.496 33.8388L150.001 33.5863L149.243 30.0509C148.738 28.2832 146.97 27.5257 145.455 28.2832L144.698 28.7883C142.678 30.0509 141.415 31.8186 140.91 34.0913L140.152 39.1418L140.657 38.8893L141.415 34.0913C141.667 31.8186 142.93 30.0509 144.95 29.0408L145.203 28.7883C146.465 28.0307 148.233 28.7883 148.486 30.3034L149.496 33.8388Z",
    fill: "#006578"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M123.738 118.687L134.849 112.122V143.687L123.738 150V118.687Z",
    fill: "url(#paint9_linear_337_9182)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M124.748 125.505V149.495L132.576 144.949V119.444C132.576 118.687 132.324 117.929 131.566 117.424C130.809 117.172 130.051 117.172 129.293 117.677C127.778 118.434 126.768 119.697 126.011 120.96C125.253 122.222 124.748 123.99 124.748 125.505Z",
    fill: "#3C354E"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M132.072 119.444V144.444L125.506 148.232V125.505C125.506 123.99 126.011 122.475 126.768 121.212C127.021 120.707 127.274 120.202 127.779 119.949C128.536 119.192 129.294 118.687 130.051 118.182C130.304 117.929 130.809 117.929 131.061 117.929H131.314H131.566C131.819 118.182 132.072 118.939 132.072 119.444Z",
    fill: "url(#paint10_linear_337_9182)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M131.061 117.929L129.041 145.707L125.506 147.727L127.526 119.949C128.284 119.192 129.041 118.687 129.799 118.182C130.051 117.929 130.556 117.929 130.809 117.929C130.809 117.677 131.061 117.677 131.061 117.929Z",
    fill: "url(#paint11_linear_337_9182)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M131.566 144.192V119.192C131.566 118.687 131.314 118.182 131.061 117.929H131.314C131.819 118.434 132.072 118.939 132.072 119.444V144.444L125.506 148.232V147.727L131.566 144.192Z",
    fill: "#666175"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M133.588 120.454L138.386 117.676V142.929L133.588 145.707V120.454Z",
    fill: "#D48C5D"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M132.576 119.949L133.586 120.454V145.706L132.576 144.949V119.949Z",
    fill: "#746A8A"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M137.376 97.9795V117.171L133.588 120.454L132.578 119.949V119.444C132.578 117.171 130.305 115.909 128.285 116.919C125.507 118.687 123.739 121.717 123.739 125L119.952 128.283L118.941 127.777V108.586L137.376 97.9795Z",
    fill: "#746A8A"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M119.949 128.283L124.747 125.505V150.757L119.949 153.535V128.283Z",
    fill: "#D48C5D"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M118.941 127.777L119.952 128.282V153.535L118.941 153.03V127.777Z",
    fill: "#746A8A"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M120.455 151.263L125.253 148.485V151.01L120.455 153.788V151.263Z",
    fill: "#C5A397"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M119.949 151.01L120.454 151.262V153.788L119.949 153.535V151.01Z",
    fill: "#3C354E"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M124.747 148.232L125.252 148.484L120.454 151.262L119.949 151.01L124.747 148.232Z",
    fill: "#DDCAC3"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M134.094 143.435L138.892 140.657V143.182L134.094 145.96V143.435Z",
    fill: "#C5A397"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M133.588 143.182L134.093 143.434V145.959L133.588 145.707V143.182Z",
    fill: "#3C354E"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M138.386 140.404L138.891 140.656L134.093 143.434L133.588 143.182L138.386 140.404Z",
    fill: "#DDCAC3"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M120.455 131.566L125.253 128.789V131.314L120.455 134.092V131.566Z",
    fill: "#C5A397"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M119.949 131.314L120.454 131.566V134.092L119.949 133.839V131.314Z",
    fill: "#746A8A"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M124.747 128.536L125.252 128.788L120.454 131.566L119.949 131.313L124.747 128.536Z",
    fill: "#DDCAC3"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M134.094 123.737L138.892 120.959V123.232L134.094 126.01V123.737Z",
    fill: "#C5A397"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M133.588 123.232L134.093 123.737V126.01L133.588 125.757V123.232Z",
    fill: "#746A8A"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M138.386 120.454L138.891 120.959L134.093 123.737L133.588 123.232L138.386 120.454Z",
    fill: "#DDCAC3"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M138.384 98.4854V117.677L133.586 120.455V119.95C133.586 117.677 131.313 116.415 129.293 117.425C126.515 119.192 124.747 122.223 124.747 125.506L119.949 128.283V109.091L138.384 98.4854Z",
    fill: "#D48C5D"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M128.538 146.464L128.285 146.212V119.191L128.538 118.939V146.464Z",
    fill: "#666175"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M120.961 109.848L139.395 99.2422V101.515L120.961 112.374V109.848Z",
    fill: "#D6BAB0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M119.949 109.343L120.959 109.848V112.374L119.949 111.616V109.343Z",
    fill: "#746A8A"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M137.376 97.9795L139.396 99.2421L120.962 109.848L118.941 108.586L137.376 97.9795Z",
    fill: "#DDCAC3"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M128.537 116.162L131.062 114.647L130.557 117.425L128.79 118.435L128.537 116.162Z",
    fill: "#DAC8C1"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M128.031 115.91L128.536 116.162L128.789 118.435L128.536 118.182L128.031 115.91Z",
    fill: "#938C9F"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M130.557 114.394L131.062 114.647L128.536 116.162L128.031 115.909L130.557 114.394Z",
    fill: "#F2F2F2"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M123.992 146.97L125.255 146.212V148.485L123.992 149.495V146.97Z",
    fill: "#DAC8C1"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M123.486 146.717L123.991 146.969V149.495L123.486 148.99V146.717Z",
    fill: "#938C9F"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M124.749 145.707L125.254 146.212L123.991 146.97L123.486 146.717L124.749 145.707Z",
    fill: "#F2F2F2"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M134.094 140.909L135.609 140.152V142.677L134.094 143.435V140.909Z",
    fill: "#DAC8C1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M133.588 140.656L134.093 140.909V143.434L133.588 143.182V140.656Z",
    fill: "#938C9F"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M135.103 139.899L135.608 140.151L134.093 140.909L133.588 140.656L135.103 139.899Z",
    fill: "#F2F2F2"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M123.992 137.122L125.255 136.364V138.637L123.992 139.647V137.122Z",
    fill: "#DAC8C1"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M123.486 136.869L123.991 137.121V139.646L123.486 139.141V136.869Z",
    fill: "#938C9F"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M124.749 135.859L125.254 136.364L123.991 137.122L123.486 136.869L124.749 135.859Z",
    fill: "#F2F2F2"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M134.094 131.06L135.609 130.303V132.828L134.094 133.586V131.06Z",
    fill: "#DAC8C1"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M133.588 130.807L134.093 131.06V133.585L133.588 133.332V130.807Z",
    fill: "#938C9F"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M135.103 130.05L135.608 130.302L134.093 131.06L133.588 130.807L135.103 130.05Z",
    fill: "#F2F2F2"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M125.506 127.526L132.324 123.485V126.011L125.506 130.051V127.526Z",
    fill: "#746A8A"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M125.506 128.03L132.324 123.99V126.515L125.506 130.555V128.03Z",
    fill: "#3C354E"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M128.537 146.97L129.042 146.717V118.435L128.537 118.687V146.97Z",
    fill: "#3C354E"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M128.536 126.01H128.283V125H128.536V126.01Z",
    fill: "#666175"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M119.951 84.0904L138.385 73.4844V98.4844L119.951 109.343V84.0904Z",
    fill: "#FFC9B0"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M124.748 101.515L133.586 96.2115V79.7974L124.748 84.8479V101.515Z",
    fill: "#C7C1B6"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M132.576 80.3024V95.4539L133.586 96.2115V79.7974L132.576 80.3024Z",
    fill: "#ABA396"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M132.576 95.4536L133.586 96.2112L124.748 101.514V99.7465L132.576 95.4536Z",
    fill: "#EEEEEE"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M132.572 95.4528L124.744 99.7457V84.8467L132.572 80.3013V95.4528Z",
    fill: "#3C354E"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M132.067 80.8066V95.2006L129.542 96.7157L126.764 98.4834L124.996 99.241V84.847L127.774 83.3319L130.552 81.8167L132.067 80.8066Z",
    fill: "url(#paint12_linear_337_9182)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M130.554 81.8169L129.543 96.7159L126.766 98.4836L127.776 83.3321L130.554 81.8169Z",
    fill: "url(#paint13_linear_337_9182)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M132.067 87.373H131.814L124.996 91.1609V91.4134L132.067 87.373Z",
    fill: "#666175"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M131.814 81.0592V94.9481L124.996 98.9885V99.241L132.067 95.2006V80.8066L131.814 81.0592Z",
    fill: "#666175"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M126.514 98.4848L126.262 98.2322V84.0908H126.514V98.4848Z",
    fill: "#666175"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M126.514 98.737H126.766V83.5854L126.514 83.838V98.737Z",
    fill: "#3C354E"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M130.807 95.9594H130.555V81.818L130.807 81.5654V95.9594Z",
    fill: "#666175"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M130.807 96.464L131.059 96.2115V81.3125L130.807 81.565V96.464Z",
    fill: "#3C354E"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M132.325 87.3735V88.6362L125.002 92.9291V91.6665L132.325 87.3735Z",
    fill: "#3C354E"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M120.457 107.071L138.891 96.2124V98.7377L120.457 109.596V107.071Z",
    fill: "#D6BAB0"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M119.951 106.818L120.456 107.07V109.596L119.951 109.343V106.818Z",
    fill: "#746A8A"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M138.385 95.9595L138.891 96.212L120.456 107.071L119.951 106.818L138.385 95.9595Z",
    fill: "#DDCAC3"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M120.457 84.343L121.72 83.5854V106.313L120.457 107.07V84.343Z",
    fill: "#DAC8C1"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M119.951 84.0894L120.456 84.3419V107.069L119.951 106.817V84.0894Z",
    fill: "#938C9F"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M121.214 83.3325L121.719 83.585L120.456 84.3426L119.951 84.0901L121.214 83.3325Z",
    fill: "#F2F2F2"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M137.629 74.4949L138.892 73.7373V96.2121L137.629 97.2222V74.4949Z",
    fill: "#E0CAC1"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M137.123 74.2417L137.628 74.4942V97.2215L137.123 96.7164V74.2417Z",
    fill: "#938C9F"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M138.386 73.2319L138.891 73.737L137.628 74.4946L137.123 74.242L138.386 73.2319Z",
    fill: "#F2F2F2"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M125.254 101.768L134.092 96.4648V97.7275L125.254 102.778V101.768Z",
    fill: "#DAC8C1"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M124.748 101.515L125.253 101.768V102.778L124.748 102.525V101.515Z",
    fill: "#938C9F"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M133.586 96.2119L134.091 96.4644L125.253 101.767L124.748 101.515L133.586 96.2119Z",
    fill: "#F2F2F2"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M125.254 84.0911L134.092 78.7881V80.0507L125.254 85.1012V84.0911Z",
    fill: "#DAC8C1"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M124.748 83.8384L125.253 84.0909V85.101L124.748 84.8485V83.8384Z",
    fill: "#938C9F"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M133.586 78.5352L134.091 78.7877L125.253 84.0907L124.748 83.8382L133.586 78.5352Z",
    fill: "#F2F2F2"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M119.951 58.8375L138.385 48.2314V73.484L119.951 84.09V58.8375Z",
    fill: "#FFC9B0"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M112.625 35.6057L131.312 24.7471L138.383 45.7067L119.948 56.5652L112.625 35.6057Z",
    fill: "#007285"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6172 20.7067L105.052 9.84814L131.314 24.7471L112.627 35.6057L86.6172 20.7067Z",
    fill: "#02A1AC"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M124.748 76.2626L133.586 71.2121V54.5454L124.748 59.5959V76.2626Z",
    fill: "#C7C1B6"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M132.576 55.303V70.202L133.586 71.2121V54.5454L132.576 55.303Z",
    fill: "#ABA396"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M132.576 70.2026L133.586 71.2127L124.748 76.2632V74.7481L132.576 70.2026Z",
    fill: "#EEEEEE"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M132.572 70.2032L124.744 74.7486V59.5971L132.572 55.3042V70.2032Z",
    fill: "#3C354E"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M132.067 55.8096V70.2035L129.542 71.7187L126.764 73.2338L124.996 74.2439V59.85L127.774 58.3348L130.552 56.5671L132.067 55.8096Z",
    fill: "url(#paint14_linear_337_9182)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M130.554 56.5669L129.543 71.7184L126.766 73.2336L127.776 58.3346L130.554 56.5669Z",
    fill: "url(#paint15_linear_337_9182)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M132.067 62.3756L131.814 62.123L124.996 66.1634V66.416L132.067 62.3756Z",
    fill: "#666175"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M131.814 56.0621V69.951L124.996 73.7389V74.2439L132.067 70.2035V55.8096L131.814 56.0621Z",
    fill: "#666175"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M126.514 73.2323H126.262V59.0909L126.514 58.8384V73.2323Z",
    fill: "#666175"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M126.514 73.7375L126.766 73.4849V58.5859H126.514V73.7375Z",
    fill: "#3C354E"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M130.807 70.9599L130.555 70.7073V56.8184L130.807 56.5659V70.9599Z",
    fill: "#666175"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M130.807 71.2121L131.059 70.9595V56.0605L130.807 56.3131V71.2121Z",
    fill: "#3C354E"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M132.325 62.1211V63.3837L125.002 67.6767V66.414L132.325 62.1211Z",
    fill: "#3C354E"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M120.457 81.8185L138.891 71.2124V73.7377L120.457 84.3437V81.8185Z",
    fill: "#D6BAB0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M119.951 81.5659L120.456 81.8184V84.3437L119.951 84.0912V81.5659Z",
    fill: "#746A8A"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M138.385 70.9595L138.891 71.212L120.456 81.8181L119.951 81.5655L138.385 70.9595Z",
    fill: "#DDCAC3"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M120.457 59.3431L121.72 58.333V81.0603L120.457 81.8179V59.3431Z",
    fill: "#DAC8C1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M119.951 58.8374L120.456 59.3425V81.8172L119.951 81.5647V58.8374Z",
    fill: "#938C9F"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M121.214 58.0801L121.719 58.3326L120.456 59.3427L119.951 58.8377L121.214 58.0801Z",
    fill: "#F2F2F2"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M137.629 49.2424L138.892 48.4849V71.2121L137.629 71.9697V49.2424Z",
    fill: "#E0CAC1"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M137.123 48.9893L137.628 49.2418V71.9691L137.123 71.7165V48.9893Z",
    fill: "#938C9F"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M138.386 48.2319L138.891 48.4845L137.628 49.242L137.123 48.9895L138.386 48.2319Z",
    fill: "#F2F2F2"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M125.254 76.5153L134.092 71.4648V72.4749L125.254 77.5254V76.5153Z",
    fill: "#DAC8C1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M124.748 76.2627L125.253 76.5152V77.5253L124.748 77.2728V76.2627Z",
    fill: "#938C9F"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M133.586 71.2119L134.091 71.4644L125.253 76.515L124.748 76.2624L133.586 71.2119Z",
    fill: "#F2F2F2"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M125.254 58.8386L134.092 53.7881V54.7982L125.254 60.1012V58.8386Z",
    fill: "#DAC8C1"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M124.748 58.5859L125.253 58.8385V60.1011L124.748 59.596V58.5859Z",
    fill: "#938C9F"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M133.586 53.5352L134.091 53.7877L125.253 58.8382L124.748 58.5857L133.586 53.5352Z",
    fill: "#F2F2F2"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M121.971 57.5748L140.405 46.9688V49.494L121.971 60.1001V57.5748Z",
    fill: "#D6BAB0"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M119.951 56.5645L121.971 57.5746V60.0998L119.951 58.8372V56.5645Z",
    fill: "#746A8A"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M138.385 45.7061L140.406 46.9687L121.971 57.5747L119.951 56.5646L138.385 45.7061Z",
    fill: "#DDCAC3"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M128.284 38.3841C129.546 37.6265 131.314 38.3841 131.819 39.8993L132.324 42.9296L122.98 48.2326L123.486 45.2023C124.243 42.4245 125.758 39.8993 128.284 38.3841Z",
    fill: "#3C354E"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M123.232 45.7073C123.737 43.182 125.252 40.6567 127.525 39.3941C127.777 39.1416 128.03 39.1416 128.282 39.1416C129.04 39.1416 129.797 39.6467 130.05 40.4042L130.555 42.9295L122.727 47.4749L123.232 45.7073Z",
    fill: "url(#paint16_linear_337_9182)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M130.303 40.4042C130.051 39.6467 129.546 39.3941 129.04 39.1416C129.546 39.3941 129.798 39.6466 129.798 40.1517L130.303 42.6769L123.232 46.7174V47.2224L131.061 42.6769L130.303 40.4042Z",
    fill: "#666175"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M126.518 39.646V45.2016L126.77 45.4541V39.646C126.77 39.646 126.77 39.646 126.518 39.646Z",
    fill: "#4E475F"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M127.023 39.6456V45.7062L127.276 45.4537V39.3931C127.023 39.3931 127.023 39.6456 127.023 39.6456Z",
    fill: "#3C354E"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M131.566 40.4035C131.061 38.6358 129.294 37.8782 127.778 38.6358L127.273 38.8883C127.273 38.8883 127.526 39.1408 127.526 39.3934H127.778C129.041 38.6358 130.809 39.3934 131.061 40.9085L131.819 43.6863L132.576 44.1913L131.566 40.4035Z",
    fill: "#004547"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M128.032 35.6056C127.022 34.3429 125.507 33.3328 124.244 33.8379C122.981 34.5955 121.971 35.6056 121.214 37.1207C120.961 37.8783 120.709 38.6359 120.456 39.3935L119.951 42.4238L120.456 43.4339L122.981 49.4945L125.002 41.4137L128.032 38.8884L129.8 38.3833L131.82 39.1409L128.032 35.6056Z",
    fill: "url(#paint17_linear_337_9182)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M132.576 43.9394L133.081 43.6869L132.323 40.1515C131.818 38.3838 130.051 37.6263 128.535 38.3838L127.778 38.8889C125.758 40.1515 124.495 41.9192 123.99 44.1919L123.232 49.2424L123.738 48.9899L124.495 44.1919C124.748 41.9192 126.01 40.1515 128.03 39.1414L128.283 38.8889C129.546 38.1313 131.313 38.8889 131.566 40.404L132.576 43.9394Z",
    fill: "#006578"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M106.566 128.537L117.678 122.224V153.537L106.566 160.103V128.537Z",
    fill: "url(#paint18_linear_337_9182)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M107.576 135.607V159.597L115.404 155.052V129.294C115.404 128.536 115.152 127.779 114.394 127.274C113.637 127.021 112.879 127.021 112.122 127.526C110.606 128.284 109.596 129.546 108.839 130.809C108.081 132.324 107.576 133.839 107.576 135.607Z",
    fill: "#3C354E"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M114.902 129.294V154.294L108.336 158.082V135.355C108.336 133.839 108.841 132.324 109.599 131.062C109.851 130.557 110.104 130.052 110.609 129.799C111.366 129.041 112.124 128.536 112.881 128.031C113.134 127.779 113.639 127.779 113.891 127.779H114.144H114.397C114.649 128.284 114.902 128.789 114.902 129.294Z",
    fill: "url(#paint19_linear_337_9182)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M113.891 127.779L111.871 155.557L108.336 157.577L110.356 129.799C111.114 129.041 111.871 128.536 112.629 128.031C112.881 127.779 113.386 127.779 113.639 127.779C113.891 127.779 113.891 127.779 113.891 127.779Z",
    fill: "url(#paint20_linear_337_9182)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M114.397 154.041V129.041C114.397 128.536 114.144 128.031 113.891 127.779H114.144C114.649 128.284 114.902 128.789 114.902 129.294V154.294L108.336 158.082V157.577L114.397 154.041Z",
    fill: "#666175"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M116.414 130.304L121.465 127.526V152.779L116.414 155.557V130.304Z",
    fill: "#D48C5D"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M115.658 129.799L116.416 130.304V155.556L115.658 155.051V129.799Z",
    fill: "#746A8A"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M120.456 107.83V127.022L116.668 130.304L115.658 129.799V129.294C115.658 127.022 113.385 125.759 111.365 126.769C108.587 128.537 106.819 131.567 106.819 134.85L103.032 138.133L102.021 137.628V118.436L120.456 107.83Z",
    fill: "#746A8A"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 138.385L107.577 135.607V160.607L102.779 163.385V138.385Z",
    fill: "#D48C5D"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M101.768 137.627L102.778 138.385V163.385L101.768 162.88V137.627Z",
    fill: "#746A8A"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M103.285 161.366L108.083 158.588V160.861L103.285 163.639V161.366Z",
    fill: "#C5A397"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 161.113L103.284 161.366V163.639L102.779 163.386V161.113Z",
    fill: "#3C354E"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M107.577 158.335L108.082 158.588L103.284 161.366L102.779 161.113L107.577 158.335Z",
    fill: "#DDCAC3"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M116.92 153.284L121.97 150.506V153.032L116.92 155.809V153.284Z",
    fill: "#C5A397"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M116.414 153.031L116.919 153.284V155.809L116.414 155.557V153.031Z",
    fill: "#3C354E"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M121.465 150.253L121.97 150.506L116.919 153.284L116.414 153.031L121.465 150.253Z",
    fill: "#DDCAC3"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M103.285 141.416L108.083 138.639V141.164L103.285 143.942V141.416Z",
    fill: "#C5A397"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 141.164L103.284 141.416V143.941L102.779 143.689V141.164Z",
    fill: "#746A8A"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M107.577 138.386L108.082 138.638L103.284 141.416L102.779 141.164L107.577 138.386Z",
    fill: "#DDCAC3"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M116.92 133.588L121.97 130.811V133.336L116.92 136.114V133.588Z",
    fill: "#C5A397"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M116.414 133.335L116.919 133.588V136.113L116.414 135.861V133.335Z",
    fill: "#746A8A"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M121.465 130.558L121.97 130.81L116.919 133.588L116.414 133.335L121.465 130.558Z",
    fill: "#DDCAC3"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M121.466 108.587V127.779L116.668 130.557V130.052C116.668 127.779 114.395 126.516 112.375 127.526C109.597 129.294 107.829 132.324 107.829 135.607L103.031 138.385V119.193L121.466 108.587Z",
    fill: "#D48C5D"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M111.616 156.314L111.363 156.062V129.042L111.616 128.789V156.314Z",
    fill: "#666175"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M103.787 119.699L122.474 109.093V111.618L103.787 122.224V119.699Z",
    fill: "#D6BAB0"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 119.194L103.789 119.699V122.224L102.779 121.719V119.194Z",
    fill: "#746A8A"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M120.454 107.83L122.475 109.093L103.788 119.699L101.768 118.689L120.454 107.83Z",
    fill: "#DDCAC3"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M111.367 126.264L113.892 124.749L113.387 127.527L111.872 128.284L111.367 126.264Z",
    fill: "#DAC8C1"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M110.861 125.759L111.366 126.264L111.871 128.284L111.366 128.032L110.861 125.759Z",
    fill: "#938C9F"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M113.387 124.496L113.892 124.749L111.366 126.264L110.861 125.759L113.387 124.496Z",
    fill: "#F2F2F2"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M106.818 156.821L108.081 156.063V158.588L106.818 159.346V156.821Z",
    fill: "#DAC8C1"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M106.312 156.567L106.818 156.82V159.345L106.312 159.093V156.567Z",
    fill: "#938C9F"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M107.575 155.81L108.08 156.063L106.818 156.82L106.312 156.568L107.575 155.81Z",
    fill: "#F2F2F2"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M116.92 151.012L118.435 150.001V152.527L116.92 153.284V151.012Z",
    fill: "#DAC8C1"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M116.414 150.506L116.919 151.011V153.284L116.414 153.031V150.506Z",
    fill: "#938C9F"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M117.929 149.749L118.434 150.001L116.919 151.011L116.414 150.506L117.929 149.749Z",
    fill: "#F2F2F2"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M106.818 146.971L108.081 146.214V148.739L106.818 149.497V146.971Z",
    fill: "#DAC8C1"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M106.312 146.718L106.818 146.971V149.496L106.312 149.244V146.718Z",
    fill: "#938C9F"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M107.575 145.961L108.08 146.213L106.818 146.971L106.312 146.719L107.575 145.961Z",
    fill: "#F2F2F2"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M116.92 141.163L118.435 140.153V142.679L116.92 143.436V141.163Z",
    fill: "#DAC8C1"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M116.414 140.658L116.919 141.163V143.435L116.414 143.183V140.658Z",
    fill: "#938C9F"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M117.929 139.9L118.434 140.153L116.919 141.163L116.414 140.658L117.929 139.9Z",
    fill: "#F2F2F2"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M108.336 137.627L115.154 133.587V136.112L108.336 140.153V137.627Z",
    fill: "#746A8A"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M108.336 137.88L115.154 133.839V136.365L108.336 140.405V137.88Z",
    fill: "#3C354E"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M111.617 156.82L111.87 156.568V128.285L111.617 128.537V156.82Z",
    fill: "#3C354E"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M111.618 136.112L111.113 135.859V134.849H111.618V136.112Z",
    fill: "#666175"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 93.9391L121.466 83.333V108.586L102.779 119.192V93.9391Z",
    fill: "#FFC9B0"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M107.576 111.363L116.667 106.06V89.6455L107.576 94.696V111.363Z",
    fill: "#C7C1B6"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M115.404 90.4031V105.302L116.667 106.06V89.6455L115.404 90.4031Z",
    fill: "#ABA396"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M115.404 105.303L116.667 106.06L107.576 111.363V109.848L115.404 105.303Z",
    fill: "#EEEEEE"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M115.402 105.301L107.574 109.847V94.6953L115.402 90.4023V105.301Z",
    fill: "#3C354E"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M115.151 90.9072V105.301L112.374 106.816L109.596 108.331L107.828 109.342V94.9476L110.606 93.4325L113.384 91.6648L115.151 90.9072Z",
    fill: "url(#paint21_linear_337_9182)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M113.386 91.6646L112.375 106.816L109.598 108.331L110.608 93.4322L113.386 91.6646Z",
    fill: "url(#paint22_linear_337_9182)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M114.899 97.4732L114.646 97.2207L107.828 101.009V101.514L114.899 97.4732Z",
    fill: "#666175"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M114.646 90.9072V105.049L107.828 108.837V109.342L115.151 105.301V90.9072H114.646Z",
    fill: "#666175"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M109.599 108.334H109.094V94.1925L109.599 93.9399V108.334Z",
    fill: "#666175"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M109.6 108.839L109.852 108.586V93.687H109.6V108.839Z",
    fill: "#3C354E"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M113.637 106.061L113.385 105.808V91.667H113.637V106.061Z",
    fill: "#666175"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M113.637 106.313L113.889 106.061V91.1616L113.637 91.4141V106.313Z",
    fill: "#3C354E"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M115.404 97.2222V98.4848L107.828 102.778V101.515L115.404 97.2222Z",
    fill: "#3C354E"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M103.285 116.92L121.719 106.313V108.839L103.285 119.445V116.92Z",
    fill: "#D6BAB0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 116.667L103.284 116.92V119.445L102.779 119.192V116.667Z",
    fill: "#746A8A"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M121.214 106.061L121.719 106.313L103.284 116.919L102.779 116.667L121.214 106.061Z",
    fill: "#DDCAC3"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M103.285 94.4442L104.8 93.4341V116.161L103.285 116.919V94.4442Z",
    fill: "#DAC8C1"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 93.9385L103.284 94.4435V116.918L102.779 116.666V93.9385Z",
    fill: "#938C9F"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M104.294 93.1812L104.8 93.4337L103.284 94.4438L102.779 93.9387L104.294 93.1812Z",
    fill: "#F2F2F2"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M120.457 84.3435L121.72 83.5859V106.313L120.457 107.071V84.3435Z",
    fill: "#E0CAC1"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M119.951 84.0898L120.456 84.3424V107.07L119.951 106.817V84.0898Z",
    fill: "#938C9F"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M121.214 83.333L121.719 83.5855L120.456 84.3431L119.951 84.0906L121.214 83.333Z",
    fill: "#F2F2F2"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M108.082 111.616L117.173 106.566V107.576L108.082 112.627V111.616Z",
    fill: "#DAC8C1"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M107.576 111.364L108.081 111.616V112.626L107.576 112.374V111.364Z",
    fill: "#938C9F"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 106.061L117.172 106.566L108.081 111.616L107.576 111.364L116.667 106.061Z",
    fill: "#F2F2F2"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M108.082 93.9397L117.173 88.8892V89.8993L108.082 95.2023V93.9397Z",
    fill: "#DAC8C1"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M107.576 93.687L108.081 93.9395V95.2022L107.576 94.6971V93.687Z",
    fill: "#938C9F"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 88.6362L117.172 88.8888L108.081 93.9393L107.576 93.6867L116.667 88.6362Z",
    fill: "#F2F2F2"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 68.9401L121.466 58.0815V83.3341L102.779 93.9401V68.9401Z",
    fill: "#FFC9B0"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4531 45.4547L114.14 34.8486L121.463 55.8082L102.776 66.4143L95.4531 45.4547Z",
    fill: "#007285"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4453 30.5558L87.8797 19.9497L114.142 34.8487L95.4554 45.4548L69.4453 30.5558Z",
    fill: "#02A1AC"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M107.576 86.1102L116.667 81.0597V64.3931L107.576 69.6961V86.1102Z",
    fill: "#C7C1B6"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M115.404 65.1506V80.3022L116.667 81.0597V64.3931L115.404 65.1506Z",
    fill: "#ABA396"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M115.404 80.3018L116.667 81.0593L107.576 86.1098V84.5947L115.404 80.3018Z",
    fill: "#EEEEEE"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M115.402 80.3024L107.574 84.5953V69.6963L115.402 65.1509V80.3024Z",
    fill: "#3C354E"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M115.151 65.6562V80.0502L112.374 81.5653L109.596 83.0805L107.828 84.0906V69.6967L110.606 68.1815L113.384 66.6663L115.151 65.6562Z",
    fill: "url(#paint23_linear_337_9182)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M113.386 66.666L112.375 81.565L109.598 83.0802L110.608 68.1812L113.386 66.666Z",
    fill: "url(#paint24_linear_337_9182)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M114.899 72.2222L114.646 71.9697L107.828 76.0101V76.2626L114.899 72.2222Z",
    fill: "#666175"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M114.646 65.9088V79.7977L107.828 83.5855V84.0906L115.151 80.0502V65.6562L114.646 65.9088Z",
    fill: "#666175"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M109.599 83.3339L109.094 83.0814V68.9399H109.599V83.3339Z",
    fill: "#666175"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M109.6 83.5861L109.852 83.3336V68.4346L109.6 68.6871V83.5861Z",
    fill: "#3C354E"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M113.637 80.8085H113.385V66.6671L113.637 66.4146V80.8085Z",
    fill: "#666175"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M113.637 81.0606H113.889V66.1616H113.637V81.0606Z",
    fill: "#3C354E"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M115.404 71.9692V73.2319L107.828 77.7773V76.5147L115.404 71.9692Z",
    fill: "#3C354E"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M103.285 91.9196L121.719 81.061V83.5863L103.285 94.4449V91.9196Z",
    fill: "#D6BAB0"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 91.6665L103.284 91.919V94.4443L102.779 93.9392V91.6665Z",
    fill: "#746A8A"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M121.214 80.8081L121.719 81.0606L103.284 91.9192L102.779 91.6667L121.214 80.8081Z",
    fill: "#DDCAC3"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M103.285 69.1917L104.8 68.4341V91.1614L103.285 91.9189V69.1917Z",
    fill: "#DAC8C1"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 68.9385L103.284 69.191V91.9183L102.779 91.6658V68.9385Z",
    fill: "#938C9F"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M104.294 68.1812L104.8 68.4337L103.284 69.1912L102.779 68.9387L104.294 68.1812Z",
    fill: "#F2F2F2"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M120.457 59.3451L121.72 58.335V81.0622L120.457 81.8198V59.3451Z",
    fill: "#E0CAC1"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M119.951 59.0918L120.456 59.3443V81.8191L119.951 81.5665V59.0918Z",
    fill: "#938C9F"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M121.214 58.082L121.719 58.3346L120.456 59.3447L119.951 59.0921L121.214 58.082Z",
    fill: "#F2F2F2"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M108.082 86.6165L117.173 81.3135V82.3236L108.082 87.6266V86.6165Z",
    fill: "#DAC8C1"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M107.576 86.1113L108.081 86.6164V87.6265L107.576 87.374V86.1113Z",
    fill: "#938C9F"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 81.0605L117.172 81.3131L108.081 86.6161L107.576 86.1111L116.667 81.0605Z",
    fill: "#F2F2F2"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M108.082 68.9393L117.173 63.6362V64.8989L108.082 69.9494V68.9393Z",
    fill: "#DAC8C1"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M107.576 68.4341L108.081 68.9391V69.9492L107.576 69.6967V68.4341Z",
    fill: "#938C9F"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 63.3833L117.172 63.6358L108.081 68.9389L107.576 68.4338L116.667 63.3833Z",
    fill: "#F2F2F2"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M104.799 67.6765L123.486 56.8179V59.3431L104.799 69.9492V67.6765Z",
    fill: "#D6BAB0"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 66.4146L104.8 67.6772V69.9499L102.779 68.9398V66.4146Z",
    fill: "#746A8A"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M121.466 55.8081L123.486 56.8182L104.8 67.6768L102.779 66.4142L121.466 55.8081Z",
    fill: "#DDCAC3"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M111.364 48.4847C112.626 47.7271 114.394 48.4847 114.899 49.9999L115.404 53.0302L106.061 58.3332L106.566 55.3029C107.071 52.2726 108.838 49.7473 111.364 48.4847Z",
    fill: "#3C354E"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M106.06 55.5559C106.565 53.0306 108.08 50.5054 110.353 49.2428C110.605 48.9902 110.858 48.9902 111.11 48.9902C111.868 48.9902 112.625 49.4953 112.878 50.2529L113.383 52.7781L105.555 57.3236L106.06 55.5559Z",
    fill: "url(#paint25_linear_337_9182)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M113.131 50.5058C112.879 49.7482 112.374 49.4957 111.869 49.2432C112.374 49.4957 112.626 49.7482 112.626 50.2533L113.131 52.7785L106.061 56.8189V57.324L113.889 52.7785L113.131 50.5058Z",
    fill: "#666175"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M109.598 49.7481V55.3037L109.85 55.5562V49.4956C109.598 49.4956 109.598 49.4956 109.598 49.7481Z",
    fill: "#4E475F"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M109.85 49.4952V55.5558L110.102 55.3033V49.2427C109.85 49.4952 109.85 49.4952 109.85 49.4952Z",
    fill: "#3C354E"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M114.394 50.2531C113.889 48.4854 112.122 47.7278 110.607 48.4854L110.102 48.7379C110.102 48.7379 110.354 48.9905 110.354 49.243H110.607C111.869 48.4854 113.637 49.243 113.889 50.7581L114.647 53.5359L115.405 54.0409L114.394 50.2531Z",
    fill: "#004547"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M110.86 45.4542C109.85 44.1916 108.335 43.1815 107.072 43.6865C105.81 44.4441 104.799 45.4542 104.042 46.9694C103.789 47.7269 103.537 48.4845 103.284 49.2421L102.779 52.2724L103.284 53.2825L105.81 59.3431L107.83 51.2623L110.86 48.737L112.628 48.232L114.648 48.9896L110.86 45.4542Z",
    fill: "url(#paint26_linear_337_9182)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M115.404 53.7885L115.909 53.536L115.151 50.0006C114.646 48.233 112.879 47.4754 111.364 48.233L110.606 48.738C108.586 50.0006 107.323 51.7683 106.818 54.041L106.061 59.0915L106.566 58.839L107.323 54.041C107.576 51.7683 108.838 50.0006 110.859 48.9905L111.111 48.738C112.374 47.9804 114.141 48.738 114.394 50.2532L115.404 53.7885Z",
    fill: "#006578"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3926 138.383L100.504 132.07V163.635L89.3926 169.949V138.383Z",
    fill: "url(#paint27_linear_337_9182)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4023 145.453V169.443L98.2306 164.898V139.393C98.2306 138.635 97.9781 137.877 97.2205 137.372C96.4629 137.12 95.7054 137.12 94.9478 137.625C93.4327 138.383 92.4225 139.645 91.665 140.908C90.9074 142.17 90.4023 143.686 90.4023 145.453Z",
    fill: "#3C354E"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7258 139.393V164.393L91.1602 168.18V145.453C91.1602 143.938 91.6652 142.423 92.4228 141.16C92.6753 140.655 92.9278 140.15 93.4329 139.898C94.1904 139.14 94.948 138.635 95.7056 138.13C95.9581 137.877 96.4632 137.877 96.7157 137.877H96.9682H97.2207C97.4733 138.13 97.7258 138.635 97.7258 139.393Z",
    fill: "url(#paint28_linear_337_9182)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7157 137.625L94.6955 165.402L91.1602 167.422L93.1804 139.645C93.9379 138.887 94.6955 138.382 95.4531 137.877C95.7056 137.625 96.2106 137.625 96.4632 137.625C96.7157 137.625 96.7157 137.625 96.7157 137.625Z",
    fill: "url(#paint29_linear_337_9182)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2207 164.14V139.14C97.2207 138.635 96.9682 138.13 96.7157 137.877H96.9682C97.4733 138.382 97.7258 138.888 97.7258 139.393V164.393L91.1602 168.18V167.675L97.2207 164.14Z",
    fill: "#666175"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4941 140.402L104.292 137.625V162.625L99.4941 165.402V140.402Z",
    fill: "#D48C5D"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4844 139.646L99.4945 140.403V165.403L98.4844 164.898V139.646Z",
    fill: "#746A8A"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M103.282 117.928V137.12L99.4941 140.402L98.484 139.897V139.392C98.484 137.12 96.2113 135.857 94.1911 136.867C91.4133 138.635 89.6456 141.665 89.6456 144.948L85.8577 148.231L84.8477 147.726V128.534L103.282 117.928Z",
    fill: "#746A8A"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6035 148.231L90.4015 145.453V170.706L85.6035 173.483V148.231Z",
    fill: "#D48C5D"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5957 147.726L85.6058 148.231V173.483L84.5957 172.726V147.726Z",
    fill: "#746A8A"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1113 171.211L90.9093 168.433V170.958L86.1113 173.736V171.211Z",
    fill: "#C5A397"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6055 170.958L86.1105 171.211V173.736L85.6055 173.483V170.958Z",
    fill: "#3C354E"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4034 168.18L90.9085 168.433L86.1105 171.21L85.6055 170.958L90.4034 168.18Z",
    fill: "#DDCAC3"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M100 163.383L104.798 160.605V162.878L100 165.655V163.383Z",
    fill: "#C5A397"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4941 162.877L99.9992 163.382V165.655L99.4941 165.403V162.877Z",
    fill: "#3C354E"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M104.292 160.1L104.797 160.605L99.9992 163.382L99.4941 162.877L104.292 160.1Z",
    fill: "#DDCAC3"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1113 151.515L90.9093 148.737V151.263L86.1113 154.04V151.515Z",
    fill: "#C5A397"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6055 151.262L86.1105 151.515V154.04L85.6055 153.535V151.262Z",
    fill: "#746A8A"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4034 148.484L90.9085 148.737L86.1105 151.515L85.6055 151.262L90.4034 148.484Z",
    fill: "#DDCAC3"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M100 143.434L104.798 140.656V143.181L100 145.959V143.434Z",
    fill: "#C5A397"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4941 143.181L99.9992 143.433V145.958L99.4941 145.706V143.181Z",
    fill: "#746A8A"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M104.292 140.403L104.797 140.655L99.9992 143.433L99.4941 143.181L104.292 140.403Z",
    fill: "#DDCAC3"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M104.292 118.434V137.626L99.4938 140.403V139.898C99.4938 137.626 97.2211 136.363 95.2008 137.373C92.4231 139.141 90.6554 142.171 90.6554 145.454L85.8574 148.232V129.04L104.292 118.434Z",
    fill: "#D48C5D"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M156.061 91.9175V99.4932L86.1113 139.392V131.816L86.6164 132.069L156.061 91.9175Z",
    fill: "#8F0000"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6055 131.563V138.887L86.1105 139.392V131.816L85.6055 131.563Z",
    fill: "#2A5482"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1515 134.847H89.899C89.6465 134.594 89.6465 134.342 89.6465 134.089C89.6465 133.332 90.1516 132.574 90.6566 132.322L97.9798 128.029C98.2324 127.776 98.4849 127.776 98.7374 128.029C98.9899 128.281 98.9899 128.534 98.9899 128.786C98.9899 129.544 98.4849 130.301 97.9798 130.554L90.6566 134.847C90.4041 134.594 90.1515 134.847 90.1515 134.847Z",
    fill: "#D8D6D5"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4439 166.414L94.1914 166.161V138.888L94.4439 138.636V166.414Z",
    fill: "#666175"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6152 129.796L105.302 118.938V121.463L86.6152 132.069V129.796Z",
    fill: "#D6BAB0"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6035 129.039L86.6136 129.796V132.069L85.6035 131.564V129.039Z",
    fill: "#746A8A"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M103.283 117.928L105.303 118.938L86.6159 129.796L84.5957 128.534L103.283 117.928Z",
    fill: "#DDCAC3"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1914 136.11L96.7167 134.595L96.2116 137.373L94.6964 138.383L94.1914 136.11Z",
    fill: "#DAC8C1"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6855 135.858L94.1906 136.11L94.6956 138.383L94.1906 137.878L93.6855 135.858Z",
    fill: "#938C9F"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2108 134.342L96.7158 134.595L94.1906 136.11L93.6855 135.857L96.2108 134.342Z",
    fill: "#F2F2F2"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6465 166.665L90.9091 165.908V168.433L89.6465 169.191V166.665Z",
    fill: "#DAC8C1"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1406 166.412L89.6457 166.665V169.19L89.1406 168.937V166.412Z",
    fill: "#938C9F"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4033 165.655L90.9083 165.908L89.6457 166.665L89.1406 166.413L90.4033 165.655Z",
    fill: "#F2F2F2"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M100 160.858L101.263 160.101V162.626L100 163.383V160.858Z",
    fill: "#DAC8C1"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4941 160.605L99.9992 160.858V163.383L99.4941 162.878V160.605Z",
    fill: "#938C9F"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M100.757 159.848L101.262 160.1L99.9992 160.858L99.4941 160.605L100.757 159.848Z",
    fill: "#F2F2F2"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6465 157.07L90.9091 156.06V158.585L89.6465 159.343V157.07Z",
    fill: "#DAC8C1"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1406 156.564L89.6457 157.069V159.342L89.1406 159.09V156.564Z",
    fill: "#938C9F"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4033 155.807L90.9083 156.06L89.6457 157.07L89.1406 156.565L90.4033 155.807Z",
    fill: "#F2F2F2"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M100 151.01L101.263 150.252V152.778L100 153.535V151.01Z",
    fill: "#DAC8C1"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4941 150.757L99.9992 151.009V153.535L99.4941 153.282V150.757Z",
    fill: "#938C9F"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M100.757 150L101.262 150.252L99.9992 151.01L99.4941 150.757L100.757 150Z",
    fill: "#F2F2F2"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1602 147.474L97.9783 143.434V145.959L91.1602 149.999V147.474Z",
    fill: "#746A8A"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1602 147.978L97.9783 143.938V146.463L91.1602 150.251V147.978Z",
    fill: "#3C354E"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4434 166.918L94.6959 166.666V138.13L94.4434 138.383V166.918Z",
    fill: "#3C354E"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4445 145.959L93.9395 145.707V144.949H94.4445V145.959Z",
    fill: "#666175"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6074 104.04L104.294 93.1812V118.434L85.6074 129.04V104.04Z",
    fill: "#FFC9B0"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4062 121.213L99.4972 116.162V99.4956L90.4062 104.799V121.213Z",
    fill: "#C7C1B6"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2344 100.253V115.152L99.497 116.162V99.4956L98.2344 100.253Z",
    fill: "#ABA396"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2345 115.152L99.4972 116.162L90.4062 121.212V119.697L98.2345 115.152Z",
    fill: "#EEEEEE"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2345 115.15L90.4062 119.696V104.797L98.2345 100.251V115.15Z",
    fill: "#3C354E"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9828 100.757V115.151L95.205 116.666L92.4273 118.182L90.9121 119.192V104.798L93.4374 103.283L96.2152 101.767L97.9828 100.757Z",
    fill: "url(#paint30_linear_337_9182)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2137 101.767L95.2035 116.666L92.4258 118.181L93.4359 103.282L96.2137 101.767Z",
    fill: "url(#paint31_linear_337_9182)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9828 107.323L97.7303 107.07L90.9121 111.111V111.363L97.9828 107.323Z",
    fill: "#666175"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4778 101.01V114.899L90.9121 118.687V119.192L97.9828 115.151V100.757L97.4778 101.01Z",
    fill: "#666175"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4244 118.435L92.1719 118.183V104.042H92.4244V118.435Z",
    fill: "#666175"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4238 118.688L92.6763 118.435V103.536L92.4238 103.789V118.688Z",
    fill: "#3C354E"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4654 115.91H96.2129V101.769L96.4654 101.516V115.91Z",
    fill: "#666175"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4648 116.162H96.7174V101.263H96.4648V116.162Z",
    fill: "#3C354E"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M98.234 107.071V108.333L90.6582 112.879V111.616L98.234 107.071Z",
    fill: "#3C354E"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1133 127.02L104.8 116.161V118.686L86.1133 129.292V127.02Z",
    fill: "#D6BAB0"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6074 126.514L86.1125 127.019V129.291L85.6074 129.039V126.514Z",
    fill: "#746A8A"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M104.294 115.908L104.799 116.161L86.1125 127.019L85.6074 126.514L104.294 115.908Z",
    fill: "#DDCAC3"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1133 104.293L87.6284 103.536V126.263L86.1133 127.02V104.293Z",
    fill: "#E0CAC1"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6074 104.04L86.1125 104.293V127.02L85.6074 126.515V104.04Z",
    fill: "#938C9F"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1226 103.283L87.6276 103.535L86.1125 104.293L85.6074 104.04L87.1226 103.283Z",
    fill: "#F2F2F2"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M103.285 94.4442L104.8 93.4341V116.161L103.285 116.919V94.4442Z",
    fill: "#E0CAC1"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 94.1909L103.284 94.4434V116.918L102.779 116.666V94.1909Z",
    fill: "#938C9F"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M104.294 93.1812L104.8 93.4337L103.284 94.4438L102.779 94.1913L104.294 93.1812Z",
    fill: "#F2F2F2"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9121 121.466L100.003 116.415V117.425L90.9121 122.728V121.466Z",
    fill: "#DAC8C1"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4062 121.213L90.9113 121.465V122.728L90.4062 122.476V121.213Z",
    fill: "#938C9F"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4972 116.162L100.002 116.415L90.9113 121.465L90.4062 121.213L99.4972 116.162Z",
    fill: "#F2F2F2"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9121 104.041L100.003 98.7378V99.7479L90.9121 105.051V104.041Z",
    fill: "#DAC8C1"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4062 103.536L90.9113 104.041V105.051L90.4062 104.798V103.536Z",
    fill: "#938C9F"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4972 98.4849L100.002 98.7374L90.9113 104.04L90.4062 103.535L99.4972 98.4849Z",
    fill: "#F2F2F2"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6074 78.7872L104.294 68.1812V93.1811L85.6074 104.04V78.7872Z",
    fill: "#FFC9B0"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5352 55.3028L96.9695 44.6968L104.293 65.6564L85.6059 76.2624L78.5352 55.3028Z",
    fill: "#007285"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2734 40.4039L70.7078 29.7979L96.9704 44.6968L78.5361 55.3029L52.2734 40.4039Z",
    fill: "#1AAD6D"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4062 96.2128L99.4972 90.9097V74.4956L90.4062 79.5461V96.2128Z",
    fill: "#C7C1B6"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2344 75.0006V90.1522L99.497 90.9097V74.4956L98.2344 75.0006Z",
    fill: "#ABA396"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2345 90.1528L99.4972 90.9104L90.4062 96.2134V94.6983L98.2345 90.1528Z",
    fill: "#EEEEEE"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2345 90.1525L90.4062 94.698V79.5464L98.2345 75.001V90.1525Z",
    fill: "#3C354E"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9828 75.5063V89.9003L95.205 91.4154L92.4273 93.1831L90.9121 93.9407V79.5468L93.4374 78.2841L96.2152 76.5165L97.9828 75.5063Z",
    fill: "url(#paint32_linear_337_9182)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2137 76.5161L95.2035 91.4151L92.4258 93.1828L93.4359 78.2838L96.2137 76.5161Z",
    fill: "url(#paint33_linear_337_9182)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9828 82.0723H97.7303L90.9121 85.8601V86.3652L97.9828 82.0723Z",
    fill: "#666175"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4778 75.7589V89.6478L90.9121 93.6882V94.1932L97.9828 89.9003V75.5063L97.4778 75.7589Z",
    fill: "#666175"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4244 93.183L92.1719 92.9305V79.0416L92.4244 78.7891V93.183Z",
    fill: "#666175"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4238 93.4351H92.6763V78.5361H92.4238V93.4351Z",
    fill: "#3C354E"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4654 90.9105L96.2129 90.658V76.5166H96.4654V90.9105Z",
    fill: "#666175"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4648 91.1623L96.7174 90.9097V76.0107L96.4648 76.2633V91.1623Z",
    fill: "#3C354E"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M98.234 82.0708V83.3334L90.6582 87.6263V86.3637L98.234 82.0708Z",
    fill: "#3C354E"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1133 101.767L104.8 91.1611V93.4339L86.1133 104.292V101.767Z",
    fill: "#D6BAB0"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6074 101.514L86.1125 101.767V104.292L85.6074 104.039V101.514Z",
    fill: "#746A8A"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M104.294 90.6558L104.799 91.1608L86.1125 101.767L85.6074 101.514L104.294 90.6558Z",
    fill: "#DDCAC3"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1133 79.0408L87.6284 78.2832V101.01L86.1133 101.768V79.0408Z",
    fill: "#E0CAC1"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6074 78.7876L86.1125 79.0401V101.767L85.6074 101.515V78.7876Z",
    fill: "#938C9F"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1226 78.0303L87.6276 78.2828L86.1125 79.0404L85.6074 78.7878L87.1226 78.0303Z",
    fill: "#F2F2F2"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M103.285 69.1917L104.8 68.4341V91.1614L103.285 91.9189V69.1917Z",
    fill: "#E0CAC1"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 68.9385L103.284 69.191V91.9183L102.779 91.6658V68.9385Z",
    fill: "#938C9F"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M104.294 68.1812L104.8 68.4337L103.284 69.1912L102.779 68.9387L104.294 68.1812Z",
    fill: "#F2F2F2"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9121 96.4642L100.003 91.1611V92.4238L90.9121 97.4743V96.4642Z",
    fill: "#DAC8C1"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4062 96.2114L90.9113 96.4639V97.4741L90.4062 97.2215V96.2114Z",
    fill: "#938C9F"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4972 90.9082L100.002 91.1607L90.9113 96.4638L90.4062 96.2112L99.4972 90.9082Z",
    fill: "#F2F2F2"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9121 78.7883L100.003 73.7378V74.7479L90.9121 79.7984V78.7883Z",
    fill: "#DAC8C1"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4062 78.5356L90.9113 78.7882V79.7983L90.4062 79.5457V78.5356Z",
    fill: "#938C9F"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4972 73.2324L100.002 73.7375L90.9113 78.788L90.4062 78.5354L99.4972 73.2324Z",
    fill: "#F2F2F2"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M87.627 77.5245L106.314 66.9185V69.1912L87.627 80.0498V77.5245Z",
    fill: "#D6BAB0"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6074 76.2622L87.6276 77.5248V80.0501L85.6074 78.7875V76.2622Z",
    fill: "#746A8A"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M104.294 65.6558L106.314 66.9184L87.6276 77.5244L85.6074 76.2618L104.294 65.6558Z",
    fill: "#DDCAC3"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1917 58.3338C95.4543 57.5762 97.222 58.3338 97.7271 59.849L98.2321 62.8793L88.8887 68.1823L89.3938 65.152C89.8988 62.1217 91.6665 59.5964 94.1917 58.3338Z",
    fill: "#3C354E"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1418 65.657C89.6468 63.1317 91.162 60.6065 93.4347 59.3438C93.6872 59.0913 93.9397 59.0913 94.1923 59.0913C94.9498 59.0913 95.7074 59.5964 95.9599 60.3539L96.465 62.8792L88.6367 67.4246L89.1418 65.657Z",
    fill: "url(#paint34_linear_337_9182)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9594 60.3539C95.7069 59.5964 95.2018 59.3438 94.6968 59.0913C95.2018 59.3438 95.4543 59.5964 95.4543 60.1014L95.9594 62.6267L88.8887 66.6671V67.1721L96.717 62.6267L95.9594 60.3539Z",
    fill: "#666175"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4258 59.5972V65.1527L92.6783 65.4052V59.5972C92.4258 59.5972 92.4258 59.5972 92.4258 59.5972Z",
    fill: "#4E475F"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6777 59.3443V65.4049L92.9303 65.1524V59.0918C92.9303 59.3443 92.6777 59.3443 92.6777 59.3443Z",
    fill: "#3C354E"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2226 60.3532C96.7176 58.5855 94.9499 57.8279 93.4347 58.5855L92.9297 58.838C92.9297 58.838 93.1822 59.0905 93.1822 59.3431H93.4347C94.6974 58.5855 96.465 59.3431 96.7176 60.8582L97.4751 63.636L98.2327 64.141L97.2226 60.3532Z",
    fill: "#004547"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9382 55.5553C92.9281 54.2927 91.413 53.2826 90.1503 53.7876C88.8877 54.5452 87.8776 55.5553 87.12 57.0704C86.8675 57.828 86.615 58.5856 86.3625 59.3432L85.8574 62.3735L86.3625 63.3836L88.8877 69.4442L90.9079 61.3634L93.9382 58.8381L95.7059 58.3331L97.7261 59.0906L93.9382 55.5553Z",
    fill: "url(#paint35_linear_337_9182)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2321 63.8891L98.7372 63.6366L97.9796 60.1012C97.4745 58.3335 95.7069 57.576 94.1917 58.3335L93.4341 58.8386C91.4139 60.1012 90.1513 61.8689 89.6463 64.1416L88.8887 69.1921L89.3938 68.9396L90.1513 64.1416C90.4038 61.8689 91.6665 60.1012 93.6867 59.0911L93.9392 58.8386C95.2018 58.081 96.9695 58.8386 97.222 60.3537L98.2321 63.8891Z",
    fill: "#006578"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2537 128.537L39.1426 122.224V153.537L50.2537 160.103V128.537Z",
    fill: "url(#paint36_linear_337_9182)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2462 135.607V159.597L41.418 155.052V129.294C41.418 128.536 41.6705 127.779 42.4281 127.274C43.1856 127.021 43.9432 127.021 44.7008 127.526C46.2159 128.284 47.226 129.546 47.9836 130.809C48.7412 132.324 49.2462 133.839 49.2462 135.607Z",
    fill: "#3C354E"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9199 129.294V154.294L48.4856 158.082V135.355C48.4856 133.839 47.9805 132.324 47.2229 131.062C46.9704 130.557 46.7179 130.052 46.2128 129.799C45.4553 129.041 44.6977 128.536 43.9401 128.031C43.6876 127.779 43.1825 127.779 42.93 127.779H42.6775H42.425C42.1724 128.284 41.9199 128.789 41.9199 129.294Z",
    fill: "url(#paint37_linear_337_9182)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9316 127.779L44.9519 155.557L48.4872 157.577L46.467 129.799C45.7094 129.041 44.9518 128.536 44.1943 128.031C43.9417 127.779 43.4367 127.779 43.1842 127.779H42.9316Z",
    fill: "url(#paint38_linear_337_9182)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M42.425 154.041V129.041C42.425 128.536 42.6775 128.031 42.93 127.779H42.6775C42.1725 128.284 41.9199 128.789 41.9199 129.294V154.294L48.4856 158.082V157.577L42.425 154.041Z",
    fill: "#666175"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4073 130.304L35.6094 127.526V152.779L40.4073 155.557V130.304Z",
    fill: "#871F08"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4164 129.799L40.4062 130.304V155.556L41.4164 155.051V129.799Z",
    fill: "#746A8A"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6172 107.83V127.022L40.4051 130.304L41.4152 129.799V129.294C41.4152 127.022 43.6879 125.759 45.7081 126.769C48.4859 128.537 50.2536 131.567 50.2536 134.85L54.0415 138.133L55.0515 137.628V118.436L36.6172 107.83Z",
    fill: "#746A8A"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0421 138.385L49.2441 135.607V160.607L54.0421 163.385V138.385Z",
    fill: "#871F08"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M55.055 137.627L54.0449 138.385V163.385L55.055 162.88V137.627Z",
    fill: "#746A8A"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5382 161.366L48.7402 158.588V160.861L53.5382 163.638V161.366Z",
    fill: "#A6877B"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0441 161.113L53.5391 161.366V163.639L54.0441 163.386V161.113Z",
    fill: "#3C354E"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2453 158.335L48.7402 158.587L53.5382 161.365L54.0433 161.113L49.2453 158.335Z",
    fill: "#DDCAC3"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 153.284L35.1035 150.506V153.032L39.9015 155.809V153.284Z",
    fill: "#A6877B"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4054 153.031L39.9004 153.284V155.809L40.4054 155.557V153.031Z",
    fill: "#3C354E"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6086 150.253L35.1035 150.506L39.9015 153.284L40.4065 153.031L35.6086 150.253Z",
    fill: "#DDCAC3"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5382 141.416L48.7402 138.638V141.163L53.5382 143.941V141.416Z",
    fill: "#A6877B"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0441 141.164L53.5391 141.416V143.941L54.0441 143.689V141.164Z",
    fill: "#746A8A"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2453 138.386L48.7402 138.638L53.5382 141.416L54.0433 141.164L49.2453 138.386Z",
    fill: "#DDCAC3"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9015 133.588L35.1035 130.811V133.336L39.9015 136.114V133.588Z",
    fill: "#A6877B"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4054 133.335L39.9004 133.588V136.113L40.4054 135.861V133.335Z",
    fill: "#C5A397"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6086 130.558L35.1035 130.81L39.9015 133.588L40.4065 133.335L35.6086 130.558Z",
    fill: "#DDCAC3"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6094 108.587V127.779L40.4073 130.557V130.052C40.4073 127.779 42.6801 126.516 44.7003 127.526C47.478 129.294 49.2457 132.324 49.2457 135.607L54.0437 138.385V119.193L35.6094 108.587Z",
    fill: "#871F08"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5367 121.972L52.5266 129.042L35.6074 119.194V112.123L53.0316 122.224L53.5367 121.972Z",
    fill: "#690000"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0422 121.719V129.042L53.5371 129.295V121.971L54.0422 121.719Z",
    fill: "#366EA8"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9837 123.992L40.6605 119.699C40.1555 119.446 39.6504 118.688 39.6504 117.931C39.6504 117.426 39.9029 117.173 39.9029 117.173C40.1555 117.173 40.408 117.173 40.6605 117.173L47.9837 121.466C48.4888 121.719 48.9939 122.476 48.9939 123.234C48.9939 123.739 48.7413 123.992 48.7413 123.992H48.4888C48.2362 123.992 48.2363 123.992 47.9837 123.992Z",
    fill: "#8BA4A1"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2051 156.314L45.4576 156.062V129.042L45.2051 128.789V156.314Z",
    fill: "#666175"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M53.032 119.699L34.5977 109.093V111.618L53.032 122.224V119.699Z",
    fill: "#A6877B"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0433 119.194L53.0332 119.699V122.224L54.0433 121.719V119.194Z",
    fill: "#C5A397"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6179 107.83L34.5977 109.093L53.032 119.699L55.0522 118.689L36.6179 107.83Z",
    fill: "#DDCAC3"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4569 126.264L42.9316 124.749L43.4367 127.527L44.9519 128.284L45.4569 126.264Z",
    fill: "#BBA8A1"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9613 125.759L45.4562 126.264L44.9512 128.284L45.4562 128.032L45.9613 125.759Z",
    fill: "#DAC8C1"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4367 124.496L42.9316 124.749L45.4569 126.264L45.9619 125.759L43.4367 124.496Z",
    fill: "#F2F2F2"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0029 156.821L48.7402 156.063V158.588L50.0029 159.346V156.821Z",
    fill: "#BBA8A1"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5089 156.567L50.0039 156.82V159.345L50.5089 159.093V156.567Z",
    fill: "#DAC8C1"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2453 155.81L48.7402 156.063L50.0029 156.82L50.5079 156.568L49.2453 155.81Z",
    fill: "#F2F2F2"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9019 151.011L38.3867 150.001V152.526L39.9019 153.284V151.011Z",
    fill: "#BBA8A1"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4074 150.505L39.9023 151.01V153.283L40.4074 153.031V150.505Z",
    fill: "#DAC8C1"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8918 149.748L38.3867 150.001L39.9019 151.011L40.4069 150.506L38.8918 149.748Z",
    fill: "#F2F2F2"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0029 146.971L48.7402 146.214V148.739L50.0029 149.497V146.971Z",
    fill: "#BBA8A1"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5089 146.718L50.0039 146.971V149.496L50.5089 149.244V146.718Z",
    fill: "#DAC8C1"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2453 145.961L48.7402 146.213L50.0029 146.971L50.5079 146.719L49.2453 145.961Z",
    fill: "#F2F2F2"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9019 141.163L38.3867 140.153V142.679L39.9019 143.436V141.163Z",
    fill: "#BBA8A1"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4074 140.658L39.9023 141.163V143.435L40.4074 143.183V140.658Z",
    fill: "#DAC8C1"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8918 139.9L38.3867 140.153L39.9019 141.163L40.4069 140.658L38.8918 139.9Z",
    fill: "#F2F2F2"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4861 137.627L41.668 133.587V136.112L48.4861 140.153V137.627Z",
    fill: "#746A8A"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4861 137.88L41.668 133.839V136.365L48.4861 140.405V137.88Z",
    fill: "#3C354E"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2037 156.82L44.9512 156.568V128.285L45.2037 128.537V156.82Z",
    fill: "#3C354E"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2051 136.112L45.7101 135.859V134.849H45.2051V136.112Z",
    fill: "#666175"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0418 93.94L35.6074 83.334V108.587L54.0418 119.193V93.94Z",
    fill: "#B84F3C"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2466 111.362L40.4082 106.059V89.645L49.2466 94.6955V111.362Z",
    fill: "#C7C1B6"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4183 90.4026V105.302L40.4082 106.059V89.645L41.4183 90.4026Z",
    fill: "#ABA396"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4183 105.302L40.4082 106.06L49.2466 111.363V109.848L41.4183 105.302Z",
    fill: "#EEEEEE"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M41.416 105.301L49.2443 109.846V94.6948L41.416 90.4019V105.301Z",
    fill: "#3C354E"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9199 90.9067V105.301L44.4452 106.816L47.2229 108.331L48.9906 109.341V94.9471L46.2128 93.432L43.4351 91.6643L41.9199 90.9067Z",
    fill: "url(#paint39_linear_337_9182)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4375 91.6641L44.4476 106.816L47.2254 108.331L46.2153 93.4317L43.4375 91.6641Z",
    fill: "url(#paint40_linear_337_9182)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9199 97.4727L42.1724 97.2202L48.9906 101.008V101.513L41.9199 97.4727Z",
    fill: "#666175"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1724 90.9067V105.048L48.9906 108.836V109.341L41.9199 105.301V90.9067H42.1724Z",
    fill: "#666175"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4805 108.333H47.733V94.192L47.4805 93.9395V108.333Z",
    fill: "#666175"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4811 108.838L47.2285 108.586V93.6865H47.4811V108.838Z",
    fill: "#3C354E"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1855 106.06L43.438 105.808V91.6665H43.1855V106.06Z",
    fill: "#666175"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1861 106.313L42.9336 106.06V91.1611L43.1861 91.4137V106.313Z",
    fill: "#3C354E"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4199 97.2217V98.4843L48.9957 102.777V101.515L41.4199 97.2217Z",
    fill: "#3C354E"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5378 116.92L35.1035 106.313V108.839L53.5378 119.445V116.92Z",
    fill: "#A6877B"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0441 116.667L53.5391 116.92V119.445L54.0441 119.192V116.667Z",
    fill: "#746A8A"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6086 106.061L35.1035 106.313L53.5378 116.919L54.0429 116.667L35.6086 106.061Z",
    fill: "#DDCAC3"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5361 94.4452L52.2734 93.4351V116.162L53.5361 116.92V94.4452Z",
    fill: "#BBA8A1"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0422 93.9395L53.5371 94.4445V116.919L54.0422 116.667V93.9395Z",
    fill: "#938C9F"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7785 93.1821L52.2734 93.4347L53.5361 94.4448L54.0411 93.9397L52.7785 93.1821Z",
    fill: "#F2F2F2"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3661 84.345L35.1035 83.5874V106.315L36.3661 107.072V84.345Z",
    fill: "#BBA8A1"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8722 84.0918L36.3672 84.3443V107.072L36.8722 106.819V84.0918Z",
    fill: "#938C9F"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6086 83.3345L35.1035 83.587L36.3661 84.3446L36.8712 84.092L35.6086 83.3345Z",
    fill: "#F2F2F2"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7407 111.616L39.9023 106.566V107.576L48.7407 112.627V111.616Z",
    fill: "#BBA8A1"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2472 111.364L48.7422 111.616V112.626L49.2472 112.374V111.364Z",
    fill: "#DAC8C1"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4074 106.061L39.9023 106.566L48.7407 111.616L49.2458 111.364L40.4074 106.061Z",
    fill: "#F2F2F2"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7407 93.9392L39.9023 88.8887V89.8988L48.7407 95.2018V93.9392Z",
    fill: "#DAC8C1"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2472 93.6865L48.7422 93.939V95.2017L49.2472 94.6966V93.6865Z",
    fill: "#DAC8C1"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4074 88.6357L39.9023 88.8883L48.7407 93.9388L49.2458 93.6862L40.4074 88.6357Z",
    fill: "#F2F2F2"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0418 68.9401L35.6074 58.0815V83.3341L54.0418 93.9401V68.9401Z",
    fill: "#B84F3C"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M61.365 45.4554L46.2135 37.1221L35.6074 55.8089L54.0418 66.415L61.365 45.4554Z",
    fill: "#002C3E"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3751 30.5558L74.4963 23.2326L63.8902 22.7275L45.9609 32.8286L46.2135 37.1215L61.365 45.4548L87.3751 30.5558Z",
    fill: "#02A1AC"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2446 86.1117L40.4062 81.0612V64.3945L49.2446 69.6976V86.1117Z",
    fill: "#C7C1B6"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4164 65.1521V80.3036L40.4062 81.0612V64.3945L41.4164 65.1521Z",
    fill: "#ABA396"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4164 80.3032L40.4062 81.0608L49.2446 86.1113V84.5962L41.4164 80.3032Z",
    fill: "#EEEEEE"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M41.416 80.3043L49.2443 84.5973V69.6983L41.416 65.1528V80.3043Z",
    fill: "#3C354E"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9199 65.6582V80.0521L44.4452 81.5673L47.2229 83.0824L48.9906 84.0925V69.6986L46.2128 68.1835L43.4351 66.6683L41.9199 65.6582Z",
    fill: "url(#paint41_linear_337_9182)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4375 66.668L44.4476 81.567L47.2254 83.0821L46.2153 68.1831L43.4375 66.668Z",
    fill: "url(#paint42_linear_337_9182)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9199 72.2237L42.1724 71.9712L48.9906 76.0116V76.2641L41.9199 72.2237Z",
    fill: "#666175"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1724 65.9107V79.7996L48.9906 83.5875V84.0925L41.9199 80.0521V65.6582L42.1724 65.9107Z",
    fill: "#666175"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4785 83.3344L47.7311 83.0818V68.9404H47.4785V83.3344Z",
    fill: "#666175"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4791 83.5866L47.2266 83.3341V68.4351L47.4791 68.6876V83.5866Z",
    fill: "#3C354E"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1836 80.809H43.4361V66.6676L43.1836 66.415V80.809Z",
    fill: "#666175"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1842 81.0611H42.9316V66.1621H43.1842V81.0611Z",
    fill: "#3C354E"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M41.418 71.9702V73.2328L48.9937 77.7783V76.5157L41.418 71.9702Z",
    fill: "#3C354E"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5378 91.9206L35.1035 81.062V83.5873L53.5378 94.4458V91.9206Z",
    fill: "#A6877B"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0441 91.6675L53.5391 91.92V94.4453L54.0441 93.9402V91.6675Z",
    fill: "#746A8A"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6086 80.8091L35.1035 81.0616L53.5378 91.9202L54.0429 91.6677L35.6086 80.8091Z",
    fill: "#DDCAC3"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5361 69.1926L52.2734 68.4351V91.1623L53.5361 91.9199V69.1926Z",
    fill: "#BBA8A1"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0422 68.9395L53.5371 69.192V91.9192L54.0422 91.6667V68.9395Z",
    fill: "#938C9F"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7785 68.1821L52.2734 68.4347L53.5361 69.1922L54.0411 68.9397L52.7785 68.1821Z",
    fill: "#F2F2F2"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3661 59.3446L35.1035 58.3345V81.0617L36.3661 81.8193V59.3446Z",
    fill: "#BBA8A1"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8722 59.0913L36.3672 59.3438V81.8186L36.8722 81.5661V59.0913Z",
    fill: "#938C9F"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6086 58.0815L35.1035 58.3341L36.3661 59.3442L36.8712 59.0916L35.6086 58.0815Z",
    fill: "#F2F2F2"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7407 86.6165L39.9023 81.3135V82.3236L48.7407 87.6266V86.6165Z",
    fill: "#BBA8A1"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2472 86.1113L48.7422 86.6164V87.6265L49.2472 87.374V86.1113Z",
    fill: "#DAC8C1"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4074 81.0605L39.9023 81.3131L48.7407 86.6161L49.2458 86.1111L40.4074 81.0605Z",
    fill: "#F2F2F2"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7407 68.9393L39.9023 63.6362V64.8989L48.7407 69.9494V68.9393Z",
    fill: "#BBA8A1"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2472 68.4341L48.7422 68.9391V69.9492L49.2472 69.6967V68.4341Z",
    fill: "#DAC8C1"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4074 63.3833L39.9023 63.6358L48.7407 68.9389L49.2458 68.4338L40.4074 63.3833Z",
    fill: "#F2F2F2"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0222 67.6774L33.5879 56.8188V59.3441L52.0222 69.9502V67.6774Z",
    fill: "#A6877B"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0436 66.4155L52.0234 67.6782V69.9509L54.0436 68.9408V66.4155Z",
    fill: "#746A8A"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6081 55.8091L33.5879 56.8192L52.0222 67.6778L54.0425 66.4151L35.6081 55.8091Z",
    fill: "#DDCAC3"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7084 48.4857C44.4458 47.7281 42.6781 48.4857 42.173 50.0008L41.668 53.0311L51.0114 58.3342L50.5064 55.3039C49.7488 52.2736 48.2336 49.7483 45.7084 48.4857Z",
    fill: "#3C354E"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7588 55.5559C50.2538 53.0306 48.7386 50.5054 46.4659 49.2428C46.2134 48.9902 45.9608 48.9902 45.7083 48.9902C44.9507 48.9902 44.1932 49.4953 43.9406 50.2529L43.4355 52.7781L51.2638 57.3236L50.7588 55.5559Z",
    fill: "url(#paint43_linear_337_9182)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6892 50.5058C43.9417 49.7482 44.4468 49.4957 44.9519 49.2432C44.4468 49.4957 44.1943 49.7482 44.1943 50.2533L43.6892 52.7785L50.7599 56.8189V57.324L42.9316 52.7785L43.6892 50.5058Z",
    fill: "#666175"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4772 49.7481V55.3037L47.2246 55.5562V49.4956C47.2246 49.4956 47.2246 49.4956 47.4772 49.7481Z",
    fill: "#4E475F"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9713 49.4952V55.5558L46.7188 55.3033V49.2427C46.9713 49.4952 46.9713 49.4952 46.9713 49.4952Z",
    fill: "#3C354E"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4261 50.2531C42.9312 48.4854 44.6988 47.7278 46.214 48.4854L46.719 48.7379C46.719 48.7379 46.4665 48.9905 46.4665 49.243H46.214C44.9514 48.4854 43.1837 49.243 42.9311 50.7581L42.1736 53.5359L41.416 54.0409L42.4261 50.2531Z",
    fill: "#004547"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9617 45.4552C46.9718 44.1926 48.487 43.1825 49.7496 43.6875C51.0122 44.4451 52.0223 45.4552 52.7799 46.9703C53.0324 47.7279 53.2849 48.4855 53.5375 49.2431L54.0425 52.2734L53.5375 53.2835L51.0122 59.3441L48.992 51.2633L45.9617 48.738L44.194 48.233L42.1738 48.9905L45.9617 45.4552Z",
    fill: "url(#paint44_linear_337_9182)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4152 53.788L40.9102 53.5355L41.6677 50.0001C42.1728 48.2325 43.9405 47.4749 45.4556 48.2325L46.2132 48.7375C48.2334 50.0001 49.496 51.7678 50.0011 54.0405L50.7587 59.091L50.2536 58.8385L49.496 54.0405C49.2435 51.7678 47.9809 50.0001 45.9607 48.99L45.7082 48.7375C44.4455 47.9799 42.6778 48.7375 42.4253 50.2527L41.4152 53.788Z",
    fill: "#006578"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4275 138.383L56.3164 132.07V163.636L67.4275 169.949V138.383Z",
    fill: "url(#paint45_linear_337_9182)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4181 145.454V169.444L58.5898 164.898V139.393C58.5898 138.636 58.8424 137.878 59.6 137.373C60.3575 137.12 61.1151 137.12 61.8727 137.625C63.3878 138.383 64.3979 139.646 65.1555 140.908C65.9131 142.171 66.4181 143.686 66.4181 145.454Z",
    fill: "#3C354E"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0938 139.393V164.393L65.6594 168.181V145.454C65.6594 143.939 65.1543 142.423 64.3968 141.161C64.1442 140.656 63.8917 140.151 63.3867 139.898C62.6291 139.141 61.8715 138.636 61.1139 138.13C60.8614 137.878 60.3564 137.878 60.1038 137.878H59.8513H59.5988C59.3463 138.13 59.0938 138.636 59.0938 139.393Z",
    fill: "url(#paint46_linear_337_9182)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1035 137.625L62.1237 165.403L65.6591 167.423L63.6389 139.645C62.8813 138.888 62.1237 138.383 61.3661 137.878C61.1136 137.625 60.6086 137.625 60.3561 137.625C60.1035 137.625 60.1035 137.625 60.1035 137.625Z",
    fill: "url(#paint47_linear_337_9182)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5988 164.141V139.141C59.5988 138.636 59.8513 138.13 60.1038 137.878H59.8513C59.3462 138.383 59.0938 138.888 59.0938 139.393V164.393L65.6594 168.181V167.676L59.5988 164.141Z",
    fill: "#666175"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3273 140.403L52.5293 137.625V162.625L57.3273 165.403V140.403Z",
    fill: "#871F08"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3343 139.646L57.3242 140.404V165.404L58.3343 164.899V139.646Z",
    fill: "#746A8A"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5391 117.928V137.12L57.3269 140.403L58.3371 139.898V139.393C58.3371 137.12 60.6098 135.858 62.63 136.868C65.4078 138.635 67.1754 141.666 67.1754 144.948L70.9633 148.231L71.9734 147.726V128.534L53.5391 117.928Z",
    fill: "#746A8A"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2159 148.231L66.418 145.454V170.706L71.2159 173.484V148.231Z",
    fill: "#871F08"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M72.225 147.726L71.2148 148.231V173.484L72.225 172.726V147.726Z",
    fill: "#746A8A"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7101 171.211L65.9121 168.434V170.959L70.7101 173.737V171.211Z",
    fill: "#A6877B"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M71.214 170.958L70.709 171.211V173.736L71.214 173.484V170.958Z",
    fill: "#3C354E"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4172 168.181L65.9121 168.433L70.7101 171.211L71.2151 170.958L66.4172 168.181Z",
    fill: "#DDCAC3"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0759 163.383L52.0254 160.605V162.878L57.0759 165.656V163.383Z",
    fill: "#A6877B"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3287 162.878L57.0762 163.383V165.656L57.3287 165.403V162.878Z",
    fill: "#3C354E"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5304 160.1L52.0254 160.605L57.0759 163.383L57.3284 162.878L52.5304 160.1Z",
    fill: "#DDCAC3"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7101 151.515L65.9121 148.737V151.263L70.7101 154.04V151.515Z",
    fill: "#A6877B"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M71.214 151.263L70.709 151.515V154.04L71.214 153.535V151.263Z",
    fill: "#746A8A"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4172 148.484L65.9121 148.737L70.7101 151.515L71.2151 151.262L66.4172 148.484Z",
    fill: "#DDCAC3"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0759 143.434L52.0254 140.656V143.181L57.0759 145.959V143.434Z",
    fill: "#A6877B"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3287 143.181L57.0762 143.433V145.958L57.3287 145.706V143.181Z",
    fill: "#C5A397"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5304 140.403L52.0254 140.655L57.0759 143.433L57.3284 143.181L52.5304 140.403Z",
    fill: "#DDCAC3"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5293 118.434V137.626L57.3273 140.404V139.899C57.3273 137.626 59.6 136.363 61.6202 137.373C64.398 139.141 66.1656 142.171 66.1656 145.454L70.9636 148.232V129.04L52.5293 118.434Z",
    fill: "#871F08"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7111 131.819V139.394L52.5293 129.041V121.97L70.2061 132.071L70.7111 131.819Z",
    fill: "#690000"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M71.216 131.566V138.889L70.7109 139.394V131.818L71.216 131.566Z",
    fill: "#366EA8"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1576 133.839L57.8343 129.546C57.3293 129.293 56.8242 128.536 56.8242 127.778C56.8242 127.273 57.0768 127.021 57.0768 127.021C57.3293 127.021 57.5818 127.021 57.8343 127.021L65.1576 131.313C65.6626 131.566 66.1676 132.324 66.1676 133.081C66.1676 133.586 65.9151 133.839 65.9151 133.839H65.6626C65.4101 133.839 65.4101 133.839 65.1576 133.839Z",
    fill: "#8BA4A1"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M62.375 166.413L62.6275 166.16V138.887L62.375 138.635V166.413Z",
    fill: "#666175"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2064 129.797L51.5195 118.938V121.463L70.2064 132.069V129.797Z",
    fill: "#A6877B"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2152 129.039L70.2051 129.797V132.069L71.2152 131.564V129.039Z",
    fill: "#C5A397"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5397 117.928L51.5195 118.938L70.2064 129.797L72.2266 128.534L53.5397 117.928Z",
    fill: "#DDCAC3"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6288 136.111L60.1035 134.596L60.6086 137.373L62.1237 138.384L62.6288 136.111Z",
    fill: "#BBA8A1"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1331 135.858L62.6281 136.111L62.123 138.384L62.6281 137.879L63.1331 135.858Z",
    fill: "#DAC8C1"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6086 134.343L60.1035 134.595L62.6288 136.11L63.1338 135.858L60.6086 134.343Z",
    fill: "#F2F2F2"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1747 166.666L65.9121 165.908V168.433L67.1747 169.191V166.666Z",
    fill: "#BBA8A1"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6789 166.413L67.1738 166.665V169.19L67.6789 168.938V166.413Z",
    fill: "#DAC8C1"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4172 165.656L65.9121 165.908L67.1747 166.666L67.6798 166.413L66.4172 165.656Z",
    fill: "#F2F2F2"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0757 160.857L55.5605 160.1V162.625L57.0757 163.382V160.857Z",
    fill: "#BBA8A1"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3287 160.604L57.0762 160.857V163.382L57.3287 162.877V160.604Z",
    fill: "#DAC8C1"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0656 159.847L55.5605 160.099L57.0757 160.857L57.3282 160.604L56.0656 159.847Z",
    fill: "#F2F2F2"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1747 157.071L65.9121 156.061V158.586L67.1747 159.343V157.071Z",
    fill: "#BBA8A1"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6789 156.565L67.1738 157.07V159.343L67.6789 159.09V156.565Z",
    fill: "#DAC8C1"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4172 155.808L65.9121 156.06L67.1747 157.07L67.6798 156.565L66.4172 155.808Z",
    fill: "#F2F2F2"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0757 151.009L55.5605 150.251V152.776L57.0757 153.534V151.009Z",
    fill: "#BBA8A1"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3287 150.755L57.0762 151.008V153.533L57.3287 153.281V150.755Z",
    fill: "#DAC8C1"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0656 149.999L55.5605 150.251L57.0757 151.009L57.3282 150.756L56.0656 149.999Z",
    fill: "#F2F2F2"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M65.66 147.475L58.8418 143.434V145.959L65.66 150V147.475Z",
    fill: "#746A8A"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M65.66 147.979L58.8418 143.938V146.464L65.66 150.252V147.979Z",
    fill: "#3C354E"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3775 166.918L62.125 166.666V138.13L62.3775 138.383V166.918Z",
    fill: "#3C354E"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M62.375 145.958L62.8801 145.706V144.948H62.375V145.958Z",
    fill: "#666175"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2122 104.04L52.5254 93.1812V118.434L71.2122 129.04V104.04Z",
    fill: "#B84F3C"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4151 121.213L57.3242 116.162V99.4956L66.4151 104.799V121.213Z",
    fill: "#C7C1B6"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5868 100.253V115.152L57.3242 116.162V99.4956L58.5868 100.253Z",
    fill: "#ABA396"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5868 115.152L57.3242 116.162L66.4151 121.212V119.697L58.5868 115.152Z",
    fill: "#EEEEEE"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5859 115.15L66.4142 119.696V104.797L58.5859 100.251V115.15Z",
    fill: "#3C354E"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8379 100.757V115.151L61.6157 116.666L64.3934 118.182L66.1611 119.192V104.798L63.3834 103.283L60.6056 101.767L58.8379 100.757Z",
    fill: "url(#paint48_linear_337_9182)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6074 101.767L61.6175 116.666L64.3953 118.181L63.3852 103.282L60.6074 101.767Z",
    fill: "url(#paint49_linear_337_9182)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8379 107.323L59.3429 107.07L66.1611 111.111V111.363L58.8379 107.323Z",
    fill: "#666175"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3429 101.01V114.899L66.1611 118.687V119.192L58.8379 115.151V100.757L59.3429 101.01Z",
    fill: "#666175"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3984 118.435L64.9035 118.183V104.042H64.3984V118.435Z",
    fill: "#666175"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M64.399 118.688L64.1465 118.435V103.536L64.399 103.789V118.688Z",
    fill: "#3C354E"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3555 115.91H60.608V101.769L60.3555 101.516V115.91Z",
    fill: "#666175"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3561 116.162H60.1035V101.263H60.3561V116.162Z",
    fill: "#3C354E"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5898 107.071V108.333L66.1656 112.879V111.616L58.5898 107.071Z",
    fill: "#3C354E"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7097 127.02L52.2754 116.161V118.686L70.7097 129.292V127.02Z",
    fill: "#A6877B"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M71.214 126.514L70.709 127.019V129.291L71.214 129.039V126.514Z",
    fill: "#746A8A"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7805 115.908L52.2754 116.161L70.7097 127.019L71.2148 126.514L52.7805 115.908Z",
    fill: "#DDCAC3"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7065 104.293L69.1914 103.535V126.262L70.7065 127.02V104.293Z",
    fill: "#BBA8A1"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2101 104.04L70.7051 104.292V127.019L71.2101 126.514V104.04Z",
    fill: "#938C9F"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6964 103.282L69.1914 103.535L70.7065 104.292L71.2116 104.04L69.6964 103.282Z",
    fill: "#F2F2F2"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M53.538 94.4442L52.2754 93.4341V116.161L53.538 116.919V94.4442Z",
    fill: "#BBA8A1"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0441 94.1909L53.5391 94.4434V116.918L54.0441 116.666V94.1909Z",
    fill: "#938C9F"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7805 93.1812L52.2754 93.4337L53.538 94.4438L54.0431 94.1913L52.7805 93.1812Z",
    fill: "#F2F2F2"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9112 121.466L56.8203 116.415V117.425L65.9112 122.728V121.466Z",
    fill: "#BBA8A1"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4152 121.213L65.9102 121.465V122.728L66.4152 122.476V121.213Z",
    fill: "#DAC8C1"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3254 116.162L56.8203 116.415L65.9112 121.465L66.4163 121.213L57.3254 116.162Z",
    fill: "#F2F2F2"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9112 104.041L56.8203 98.7378V99.7479L65.9112 105.051V104.041Z",
    fill: "#DAC8C1"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4152 103.536L65.9102 104.041V105.051L66.4152 104.798V103.536Z",
    fill: "#DAC8C1"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3254 98.4849L56.8203 98.7374L65.9112 104.04L66.4163 103.535L57.3254 98.4849Z",
    fill: "#F2F2F2"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2122 78.7872L52.5254 68.1812V93.1811L71.2122 104.04V78.7872Z",
    fill: "#B84F3C"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5355 55.3028L59.8486 44.6968L52.5254 65.6564L71.2122 76.2624L78.5355 55.3028Z",
    fill: "#002C3E"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M104.296 40.4039L86.1142 29.7979L59.8516 44.6968L78.5385 55.3029L104.296 40.4039Z",
    fill: "#02A1AC"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4151 96.2128L57.3242 90.9097V74.4956L66.4151 79.5461V96.2128Z",
    fill: "#C7C1B6"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5868 75.0006V90.1522L57.3242 90.9097V74.4956L58.5868 75.0006Z",
    fill: "#ABA396"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5868 90.1528L57.3242 90.9104L66.4151 96.2134V94.6983L58.5868 90.1528Z",
    fill: "#EEEEEE"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5859 90.1525L66.4142 94.698V79.5464L58.5859 75.001V90.1525Z",
    fill: "#3C354E"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8379 75.5063V89.9003L61.6157 91.4154L64.3934 93.1831L66.1611 93.9407V79.5468L63.3834 78.2841L60.6056 76.5165L58.8379 75.5063Z",
    fill: "url(#paint50_linear_337_9182)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6074 76.5161L61.6175 91.4151L64.3953 93.1828L63.3852 78.2838L60.6074 76.5161Z",
    fill: "url(#paint51_linear_337_9182)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8379 82.0723H59.3429L66.1611 85.8601V86.3652L58.8379 82.0723Z",
    fill: "#666175"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3429 75.7589V89.6478L66.1611 93.6882V94.1932L58.8379 89.9003V75.5063L59.3429 75.7589Z",
    fill: "#666175"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3984 93.183L64.9035 92.9305V79.0416L64.3984 78.7891V93.183Z",
    fill: "#666175"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M64.399 93.4351H64.1465V78.5361H64.399V93.4351Z",
    fill: "#3C354E"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3555 90.9105L60.608 90.658V76.5166H60.3555V90.9105Z",
    fill: "#666175"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3561 91.1623L60.1035 90.9097V76.0107L60.3561 76.2633V91.1623Z",
    fill: "#3C354E"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5898 82.0708V83.3334L66.1656 87.6263V86.3637L58.5898 82.0708Z",
    fill: "#3C354E"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7097 101.767L52.2754 91.1611V93.4339L70.7097 104.292V101.767Z",
    fill: "#A6877B"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M71.214 101.514L70.709 101.767V104.292L71.214 104.039V101.514Z",
    fill: "#746A8A"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7805 90.6558L52.2754 91.1608L70.7097 101.767L71.2148 101.514L52.7805 90.6558Z",
    fill: "#DDCAC3"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7065 79.0408L69.1914 78.2832V101.01L70.7065 101.768V79.0408Z",
    fill: "#BBA8A1"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2101 78.7876L70.7051 79.0401V101.767L71.2101 101.515V78.7876Z",
    fill: "#938C9F"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6964 78.0303L69.1914 78.2828L70.7065 79.0404L71.2116 78.7878L69.6964 78.0303Z",
    fill: "#F2F2F2"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M53.538 69.1917L52.2754 68.4341V91.1614L53.538 91.9189V69.1917Z",
    fill: "#BBA8A1"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0441 68.9385L53.5391 69.191V91.9183L54.0441 91.6658V68.9385Z",
    fill: "#938C9F"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7805 68.1812L52.2754 68.4337L53.538 69.1912L54.0431 68.9387L52.7805 68.1812Z",
    fill: "#F2F2F2"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9112 96.4642L56.8203 91.1611V92.4238L65.9112 97.4743V96.4642Z",
    fill: "#BBA8A1"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4152 96.2114L65.9102 96.4639V97.4741L66.4152 97.2215V96.2114Z",
    fill: "#DAC8C1"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3254 90.9082L56.8203 91.1607L65.9112 96.4638L66.4163 96.2112L57.3254 90.9082Z",
    fill: "#F2F2F2"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9112 78.7883L56.8203 73.7378V74.7479L65.9112 79.7984V78.7883Z",
    fill: "#BBA8A1"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4152 78.5356L65.9102 78.7882V79.7983L66.4152 79.5457V78.5356Z",
    fill: "#DAC8C1"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3254 73.2324L56.8203 73.7375L65.9112 78.788L66.4163 78.5354L57.3254 73.2324Z",
    fill: "#F2F2F2"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1928 77.5245L50.5059 66.9185V69.1912L69.1928 80.0498V77.5245Z",
    fill: "#A6877B"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2116 76.2622L69.1914 77.5248V80.0501L71.2116 78.7875V76.2622Z",
    fill: "#746A8A"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5261 65.6558L50.5059 66.9184L69.1928 77.5244L71.2129 76.2618L52.5261 65.6558Z",
    fill: "#DDCAC3"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6283 58.3338C61.3657 57.5762 59.598 58.3338 59.093 59.849L58.5879 62.8793L67.9314 68.1823L67.4263 65.152C66.9212 62.1217 65.1536 59.5964 62.6283 58.3338Z",
    fill: "#3C354E"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9307 65.657C67.4256 63.1317 65.9104 60.6065 63.6377 59.3438C63.3852 59.0913 63.1327 59.0913 62.8802 59.0913C62.1226 59.0913 61.365 59.5964 61.1125 60.3539L60.6074 62.8792L68.4357 67.4246L67.9307 65.657Z",
    fill: "url(#paint52_linear_337_9182)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8591 60.3539C61.1117 59.5964 61.6167 59.3438 62.1218 59.0913C61.6167 59.3438 61.3642 59.5964 61.3642 60.1014L60.8591 62.6267L67.9299 66.6671V67.1721L60.1016 62.6267L60.8591 60.3539Z",
    fill: "#666175"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3931 59.5972V65.1527L64.1406 65.4052V59.5972C64.3932 59.5972 64.3931 59.5972 64.3931 59.5972Z",
    fill: "#4E475F"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1412 59.3443V65.4049L63.8887 65.1524V59.0918C64.1412 59.3443 64.1412 59.3443 64.1412 59.3443Z",
    fill: "#3C354E"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M59.598 60.3532C60.1031 58.5855 61.8707 57.8279 63.3859 58.5855L63.8909 58.838C63.8909 58.838 63.6384 59.0905 63.6384 59.3431H63.3859C62.1233 58.5855 60.3556 59.3431 60.1031 60.8582L59.3455 63.636L58.5879 64.141L59.598 60.3532Z",
    fill: "#004547"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1336 55.5553C64.1437 54.2927 65.6588 53.2826 66.9215 53.7876C68.1841 54.5452 69.1942 55.5553 69.9518 57.0704C70.2043 57.828 70.4568 58.5856 70.7093 59.3432L71.2144 62.3735L70.7093 63.3836L68.1841 69.4442L66.1639 61.3634L63.1336 58.8381L61.3659 58.3331L59.3457 59.0906L63.1336 55.5553Z",
    fill: "url(#paint53_linear_337_9182)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5871 63.8891L58.082 63.6366L58.8396 60.1012C59.3447 58.3335 61.1123 57.576 62.6275 58.3335L63.3851 58.8386C65.4053 60.1012 66.6679 61.8689 67.173 64.1416L67.9305 69.1921L67.4255 68.9396L66.6679 64.1416C66.4154 61.8689 65.1527 60.1012 63.1325 59.0911L62.88 58.8386C61.6174 58.081 59.8497 58.8386 59.5972 60.3537L58.5871 63.8891Z",
    fill: "#006578"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M149.243 103.536C149.495 101.01 150.506 98.2325 151.516 96.9699C152.526 95.9598 153.031 96.7174 153.031 98.7376L154.546 97.4749C154.546 97.4749 155.051 97.7275 155.051 97.98C155.051 98.2325 154.798 98.485 154.798 98.485L153.031 99.7477C152.778 102.02 151.768 104.798 150.758 105.808C149.495 107.071 148.99 106.061 149.243 103.536Z",
    fill: "#C9B6B0"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M162.373 102.779L154.545 98.2333C154.292 98.2333 154.292 97.7283 154.545 97.4758C154.797 97.2232 155.05 96.9707 155.05 97.2233L162.878 101.769L162.373 102.779Z",
    fill: "url(#paint54_linear_337_9182)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M162.373 102.778C162.12 102.778 162.12 102.273 162.373 102.021C162.626 101.768 162.878 101.516 162.878 101.768C163.131 101.768 163.131 102.273 162.878 102.526C162.626 102.778 162.373 103.031 162.373 102.778Z",
    fill: "#888888"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M162.879 105.808L158.334 96.9693L159.597 96.2118H159.849C160.354 95.9592 161.364 95.9592 162.122 96.4643C164.142 97.4744 165.657 100.252 165.657 102.525C165.657 103.535 165.405 104.293 164.9 104.545C164.9 104.545 164.9 104.545 164.647 104.545L162.879 105.808Z",
    fill: "url(#paint55_linear_337_9182)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M157.072 99.2414C157.072 101.514 158.587 104.292 160.608 105.302C162.628 106.312 164.143 105.555 164.143 103.282C164.143 101.009 162.628 98.2313 160.608 97.2212C158.587 96.2111 157.072 96.9687 157.072 99.2414Z",
    fill: "#960000"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6069 76.2628H71.2129L78.5361 55.3032L85.6069 76.2628Z",
    fill: "#003F4C"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1934 77.5253H87.6277L85.6075 76.2627H71.2135L69.1934 77.5253Z",
    fill: "#DDCAC3"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6277 77.5254H69.1934V80.0506H87.6277V77.5254Z",
    fill: "#B2968C"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6069 80.0508H71.2129V173.485H85.6069V80.0508Z",
    fill: "#B0412A"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6069 80.0508H71.2129V129.546H85.6069V80.0508Z",
    fill: "#D66F50"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1111 151.516H70.707V154.041H86.1111V151.516Z",
    fill: "#B08E83"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1111 171.212H70.707V173.737H86.1111V171.212Z",
    fill: "#B08E83"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2121 170.959H85.606L86.1111 171.212H70.707L71.2121 170.959Z",
    fill: "#DDCAC3"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2121 151.263H85.606L86.1111 151.515H70.707L71.2121 151.263Z",
    fill: "#DDCAC3"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1111 127.02H70.707V129.545H86.1111V127.02Z",
    fill: "#B08E83"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2121 126.516H85.606L86.1111 127.021H70.707L71.2121 126.516Z",
    fill: "#DDCAC3"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8679 129.798H70.2012V132.323H86.8679V129.798Z",
    fill: "#B08E83"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7062 129.293H86.1103L86.6153 129.799H70.2012L70.7062 129.293Z",
    fill: "#DDCAC3"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1111 101.768H70.707V104.293H86.1111V101.768Z",
    fill: "#B08E83"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2121 101.516H85.606L86.1111 101.768H70.707L71.2121 101.516Z",
    fill: "#DDCAC3"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M45.959 32.8286L35.6055 49.4953V55.8084L46.2115 37.1215L45.959 32.8286Z",
    fill: "#002F3C"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5859 49.2427L35.6061 49.4952V55.8083L33.5859 56.8184V49.2427Z",
    fill: "#DDCAC3"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3636 132.07H70.707V139.141H86.3636V132.07Z",
    fill: "#700100"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M118.943 169.696L109.6 174.494L117.175 179.04L120.711 178.535L122.226 169.696H118.943Z",
    fill: "#918B86"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M120.709 178.534L129.042 173.989V172.979L120.709 177.776V178.534Z",
    fill: "#CACACA"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M120.709 178.535L113.891 174.747V173.737L120.709 177.777V178.535Z",
    fill: "#8B8B8B"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M122.224 168.938L113.891 173.736L120.709 177.776L129.042 172.978L122.224 168.938Z",
    fill: "#EFEFEF"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M116.164 173.736L122.225 170.453L126.518 172.978L120.71 176.261L116.164 173.736Z",
    fill: "#FF816F"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M100.255 174.746C100.002 174.999 100.255 174.999 100.255 174.746C100.002 174.999 101.012 175.756 101.517 175.756L101.77 176.009C101.77 176.514 102.78 177.272 102.78 177.272C102.78 177.272 102.78 177.272 103.032 177.019C103.032 177.019 104.042 177.019 104.295 177.019V176.767C104.547 177.272 105.053 177.777 105.053 177.777C105.053 177.777 105.558 177.272 105.81 177.019C106.063 177.272 107.325 177.272 107.325 177.272C107.325 177.272 107.325 177.019 107.073 176.767H107.325C107.578 177.019 107.83 177.524 107.83 177.524C107.83 177.524 108.588 177.272 108.588 176.767H108.84C109.093 177.019 109.345 177.524 109.345 177.524C109.345 177.524 109.598 177.272 109.851 177.019H110.103C110.103 177.019 110.103 177.272 110.356 177.272L110.608 177.524C110.608 177.524 111.113 177.272 111.366 176.767C111.366 176.767 111.366 176.767 111.618 177.019C111.871 177.272 112.881 177.272 112.881 177.272C112.881 177.272 112.881 177.019 112.628 176.767H112.881C113.133 176.767 113.133 176.767 113.133 176.767C113.133 176.767 113.133 176.767 113.133 176.514C113.386 176.514 113.386 176.261 113.638 176.009C113.891 175.756 113.891 175.756 114.143 175.504C114.143 175.251 114.143 174.999 114.396 174.746C114.396 174.494 114.648 174.494 114.901 174.241C115.154 173.989 115.406 173.989 115.911 173.736C116.164 173.736 116.416 173.484 116.669 173.484C117.174 173.484 117.679 173.484 118.436 173.484C118.941 173.484 119.194 173.484 119.699 173.484C119.952 173.484 120.204 173.484 120.457 173.484H120.709C120.962 173.736 121.214 173.736 121.467 173.736V173.484C121.467 173.231 121.467 172.979 121.467 172.979C121.467 172.726 121.214 172.726 120.962 172.726H120.709C120.457 172.726 120.204 172.726 120.204 172.979C119.952 172.979 119.699 172.979 119.446 172.979C118.941 172.979 118.436 172.979 117.931 172.979C117.174 172.979 116.416 172.979 115.659 172.979C115.406 172.979 115.406 172.979 115.154 172.979C114.649 172.726 114.396 172.726 113.891 172.474C113.638 172.221 113.386 172.221 113.133 171.969C112.881 171.716 112.881 171.716 112.628 171.463L112.376 171.211H112.123C112.123 171.211 112.123 171.211 111.871 171.211C111.618 170.958 111.618 170.706 111.618 170.706C111.618 170.706 111.366 170.706 111.113 170.958C111.113 170.706 110.861 170.201 110.861 170.201C110.861 170.201 109.851 170.201 109.598 170.453C109.598 170.453 109.598 170.453 109.598 170.706C109.345 170.453 108.335 169.948 108.335 169.948V170.201V170.453C108.335 170.453 108.335 170.453 108.083 170.453C108.083 170.453 108.083 170.453 107.83 170.453C107.83 170.453 107.83 170.453 107.578 170.453C107.325 170.201 106.82 169.948 106.82 169.948C106.82 169.948 106.568 170.201 106.568 170.706H106.315C106.063 170.453 105.053 169.948 105.053 169.948C105.053 169.948 105.053 170.453 105.053 170.706H104.8C104.8 170.453 104.548 170.201 104.548 170.201C104.548 170.201 103.537 170.201 103.285 170.453C103.032 170.201 102.022 169.696 102.022 169.696C102.022 169.696 101.77 170.201 101.77 170.706C101.77 170.453 101.517 170.453 101.517 170.201C101.265 169.948 100.507 169.948 100.255 169.948H100.002C100.002 169.948 99.2445 170.453 99.497 170.958C99.497 170.958 99.497 171.211 99.7495 171.211V171.463C99.497 171.463 99.2445 171.463 99.2445 171.463C99.2445 171.463 99.2445 171.969 99.497 172.474H99.2445C98.9919 172.726 98.7394 173.484 98.7394 173.484C98.7394 173.484 98.7394 173.484 98.9919 173.484C98.4869 173.484 98.2344 173.736 98.2344 173.736C98.2344 173.736 98.7394 174.241 99.2445 174.494C98.9919 174.494 98.9919 174.746 98.9919 174.746C98.9919 174.746 99.7495 174.746 100.255 174.746ZM113.133 172.221C113.386 172.221 113.638 172.474 114.143 172.726C114.143 172.726 114.396 172.726 114.649 172.979C114.396 172.979 114.143 172.979 113.891 172.979H113.638C113.638 172.979 113.638 172.979 113.386 172.979C113.133 172.726 112.881 172.474 112.628 172.474C112.628 172.474 112.628 172.474 112.376 172.474C112.376 172.474 112.376 172.221 112.628 172.221C112.628 172.221 112.881 172.221 113.133 172.221ZM115.406 173.484C115.154 173.484 115.154 173.736 114.901 173.736L114.649 173.989C114.396 174.241 113.891 174.494 113.386 174.746L113.133 174.494C113.133 174.494 113.133 174.494 113.386 174.494C113.638 174.494 113.638 173.989 113.891 173.736C114.143 173.484 114.648 173.484 115.406 173.484ZM112.123 171.211C112.123 171.211 112.376 171.463 112.123 171.463C111.871 171.463 111.871 171.211 111.618 171.211V170.958C111.871 170.958 112.123 171.211 112.123 171.211ZM113.386 176.009C113.386 175.756 113.386 175.504 113.133 175.251C113.386 175.251 113.891 174.999 113.891 174.999C113.891 174.999 113.891 174.999 113.638 174.746C113.891 174.746 114.143 174.746 114.143 174.999V175.251C114.143 175.504 113.891 175.756 113.891 175.756C113.638 175.756 113.386 176.009 113.386 176.009Z",
    fill: "#918B86"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M124.245 163.129H123.992C123.487 163.129 123.992 162.119 123.992 161.867C123.992 161.614 123.992 161.362 124.245 161.109C124.245 160.856 124.497 160.604 124.497 160.099C124.497 160.099 124.497 160.351 124.245 160.351C124.245 160.604 123.992 160.604 123.992 160.856C123.992 161.109 123.74 161.362 123.74 161.867C123.487 162.624 122.982 163.382 122.477 164.139C122.477 164.392 122.224 164.392 122.224 164.644C121.972 164.897 121.719 165.402 121.719 165.654C121.719 165.907 121.719 166.159 121.719 166.412C121.719 166.665 121.719 166.665 121.719 166.917C121.719 167.422 121.719 167.927 121.467 168.432C121.467 168.18 121.719 167.927 121.719 167.675C121.972 167.17 121.972 166.665 122.224 165.907C122.477 165.402 122.477 164.897 122.982 164.392C123.234 164.139 123.487 163.887 123.487 163.634C123.74 163.382 124.245 163.382 124.497 163.129C124.75 162.877 125.255 162.624 125.255 162.372C125.76 161.867 126.265 161.109 126.517 160.351C126.77 160.099 126.77 159.594 126.77 159.341C126.517 159.846 126.265 160.351 126.012 160.856C125.76 161.362 125.507 161.867 125.255 162.372C125.002 162.624 124.75 163.129 124.245 163.129Z",
    fill: "#91651F"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M121.724 167.675C121.724 167.422 121.724 167.17 121.724 166.917C121.724 166.665 121.724 166.412 121.724 166.16C121.724 165.907 121.976 165.402 122.229 165.15C122.229 164.897 122.481 164.897 122.481 164.644C122.986 163.887 123.491 163.129 123.744 162.372C123.744 162.119 123.996 161.867 123.996 161.362V161.109C123.996 160.857 124.249 160.604 124.249 160.352C124.249 160.352 124.249 160.604 123.996 160.604C123.996 160.857 123.744 160.857 123.744 161.109C123.744 161.362 123.491 161.614 123.491 162.119C123.239 162.877 122.734 163.634 122.229 164.392C122.229 164.644 121.976 164.644 121.976 164.897C121.724 165.15 121.471 165.655 121.471 165.907C121.471 166.16 121.471 166.412 121.471 166.665C121.471 166.917 121.471 166.917 121.471 167.17C121.471 167.675 121.471 168.18 121.219 168.685C121.471 168.432 121.724 168.18 121.724 167.675Z",
    fill: "#AA7723"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M118.69 162.372C118.942 162.372 118.942 162.624 119.195 162.372C119.195 162.372 119.447 162.119 119.195 161.866V161.614C119.195 161.109 118.942 160.604 118.942 160.099C118.69 159.341 118.69 158.584 118.69 158.079C118.942 158.584 118.942 159.089 118.942 159.846C118.942 160.099 118.942 160.604 119.195 160.856C119.195 161.109 119.195 161.109 119.447 161.361C119.447 161.614 119.447 161.614 119.447 161.866C119.447 162.119 119.7 162.372 119.7 162.624C119.7 162.877 119.952 163.129 119.952 163.382C120.205 163.634 120.205 164.139 120.457 164.392C120.71 164.644 120.962 165.149 120.962 165.402C120.962 165.654 120.962 165.907 120.962 166.159C120.962 166.412 120.962 166.412 120.962 166.664C120.962 167.17 120.962 167.675 121.215 168.18C121.215 167.927 120.962 167.675 120.962 167.422C120.71 166.917 120.71 166.412 120.457 165.654C120.205 165.149 120.205 164.644 119.7 164.139C119.447 163.887 119.195 163.634 119.195 163.382C118.942 163.129 118.69 163.129 118.437 162.877C118.185 162.624 117.932 162.624 117.932 162.372C117.427 161.866 116.922 161.109 116.922 160.351C116.922 160.604 117.174 160.856 117.174 160.856C117.427 161.109 117.427 161.361 117.679 161.614C117.932 161.614 118.437 162.119 118.69 162.372Z",
    fill: "#91651F"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M118.94 159.846C118.94 160.099 118.94 160.604 119.193 160.856C119.193 161.109 119.193 161.109 119.445 161.362C119.445 161.614 119.445 161.614 119.445 161.867C119.445 162.119 119.698 162.372 119.698 162.624C119.698 162.877 119.951 163.129 119.951 163.382C120.203 163.634 120.203 164.139 120.456 164.392C120.708 164.644 120.961 165.149 120.961 165.402C120.961 165.654 120.961 165.907 120.961 166.159C120.961 166.159 120.961 166.16 120.961 166.412C120.961 166.665 121.213 166.917 121.213 167.17C121.213 167.422 121.466 167.675 121.466 167.927C121.466 167.422 121.213 166.917 121.213 166.412C121.213 166.16 121.213 166.159 121.213 165.907C121.213 165.654 121.213 165.402 121.213 165.149C121.213 164.897 120.961 164.392 120.708 164.139C120.456 163.887 120.203 163.382 120.203 163.129C120.203 162.877 119.951 162.624 119.951 162.372C119.951 162.119 119.698 161.867 119.698 161.614C119.698 161.362 119.698 161.362 119.698 161.109C119.698 160.856 119.698 160.856 119.445 160.604C119.445 160.351 119.193 159.846 119.193 159.594C119.193 159.089 118.94 158.584 118.94 157.826C118.94 158.079 118.94 158.079 118.94 158.331C118.688 158.836 118.94 159.341 118.94 159.846Z",
    fill: "#AA7723"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M117.679 161.866L117.932 162.119C117.932 162.119 117.932 162.371 118.185 162.371L118.437 162.624C118.69 162.624 118.69 162.876 118.942 162.624V162.371C118.69 162.371 118.69 162.371 118.437 162.371C118.185 162.119 117.679 161.614 117.679 161.361C117.427 161.109 117.427 160.856 117.174 160.604C117.174 160.604 116.922 160.351 116.922 160.099C116.922 160.351 116.922 160.604 117.174 161.109C117.427 161.361 117.679 161.614 117.679 161.866Z",
    fill: "#AA7723"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M121.972 173.229C121.972 173.481 121.972 173.481 121.972 173.229C121.72 173.481 121.467 173.734 121.215 173.734C120.962 173.734 120.457 173.481 120.457 173.481C120.457 173.481 120.457 173.481 120.457 173.229C120.457 172.976 120.71 172.723 120.71 172.218C120.71 171.966 120.71 171.461 120.71 171.208C120.71 170.451 120.71 169.693 120.71 169.188C120.71 167.42 120.71 165.653 120.71 163.885C120.71 163.633 120.71 163.633 120.71 163.38C120.71 162.875 120.71 162.622 120.71 162.117C120.71 161.612 120.71 161.36 120.71 160.855V160.602V160.35V160.097V159.845V159.592V159.34C120.71 159.087 120.71 159.087 120.71 158.835C120.71 158.835 120.71 158.835 120.71 158.582C120.71 160.097 120.71 161.36 120.71 162.875C120.71 163.885 120.71 164.643 120.71 165.653C120.71 166.158 120.71 166.663 120.71 167.168C120.71 167.925 120.71 168.683 120.71 169.441C120.71 169.946 120.71 170.703 120.71 171.208C120.71 171.461 120.71 171.966 120.71 172.218C120.71 172.218 120.71 172.218 120.71 172.471V172.723C121.972 172.976 121.972 172.976 121.972 173.229C121.972 172.976 121.972 172.976 121.972 173.229Z",
    fill: "#91651F"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M121.721 158.583C121.468 159.088 121.468 159.593 121.468 160.098C121.216 161.36 121.216 162.37 121.216 163.633C121.216 165.401 120.963 167.168 121.216 168.936C121.216 169.694 121.216 170.451 121.216 170.956C121.216 171.209 121.216 171.714 121.216 171.966C121.216 172.219 121.216 172.471 120.963 172.976C120.963 173.229 120.711 173.229 120.711 173.482C120.711 173.482 120.711 173.482 120.711 173.229C120.711 172.976 120.963 172.724 120.963 172.219C120.963 171.966 120.963 171.461 120.963 171.209C120.963 170.451 120.963 169.694 120.963 169.189C120.963 167.421 120.963 165.653 120.963 163.886C120.963 163.633 120.963 163.633 120.963 163.381C120.963 162.875 120.963 162.623 120.963 162.118C120.963 161.613 120.963 161.36 120.963 160.855V160.603V160.35V160.098V159.845V159.593V159.34C121.469 159.088 121.468 158.835 121.721 158.583C121.468 158.583 121.468 158.583 121.721 158.583Z",
    fill: "#855107"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M121.976 173.23C121.724 173.23 121.724 173.23 121.724 173.23C121.724 173.23 121.471 173.23 121.471 172.978C121.219 172.725 121.219 172.473 121.219 172.22C121.219 171.967 121.219 171.462 121.219 171.21C121.219 170.705 121.219 169.947 121.219 169.442C121.219 168.685 121.219 167.927 121.219 167.17C121.219 166.664 121.219 166.159 121.219 165.654C121.219 164.644 121.219 163.887 121.219 162.877C121.219 161.866 121.219 160.856 121.219 159.846C121.219 159.594 121.219 159.341 121.219 158.836C121.219 158.584 121.219 158.584 121.219 158.331C121.219 158.331 121.219 158.331 121.219 158.079C121.219 159.594 121.219 160.856 121.219 162.372C121.219 163.382 121.219 164.139 121.219 165.149C121.219 165.654 121.219 166.159 121.219 166.664C121.219 167.422 121.219 168.18 121.219 168.937C121.219 169.442 121.219 170.2 121.219 170.705C121.219 170.957 121.219 171.462 121.219 171.715C121.219 171.715 121.219 171.715 121.219 171.968V172.22C121.976 172.978 121.976 172.978 121.976 173.23C121.976 172.978 121.976 172.978 121.976 173.23Z",
    fill: "#AA7723"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M116.166 155.301C115.66 155.049 115.155 153.786 115.155 153.786C115.155 153.786 115.66 153.533 116.166 153.281V153.028C115.66 153.028 115.155 153.028 115.155 153.028C115.155 153.028 115.155 151.766 115.66 151.261C115.155 151.008 114.65 149.998 114.65 149.998C114.65 149.998 115.408 149.493 116.166 149.241C115.913 149.241 115.66 148.988 115.66 148.988C115.408 148.483 115.408 147.22 115.408 147.22C115.408 147.22 115.913 147.22 116.166 147.22V146.968L116.923 147.978H117.176C117.681 147.725 118.691 147.725 118.691 147.725C118.691 147.725 118.691 147.978 118.691 148.23C118.943 148.23 119.448 148.735 119.701 148.988C120.206 148.735 120.458 148.483 120.458 148.483C120.458 148.483 120.711 148.735 120.711 149.241H120.964L121.216 148.988C121.469 148.988 121.469 148.735 121.721 148.988C121.721 149.241 121.721 149.493 121.721 149.746C121.721 149.746 121.721 149.746 121.974 149.746H122.226C122.226 149.746 122.731 151.008 122.479 151.513C122.479 151.513 122.479 151.766 122.226 151.766C122.226 152.018 122.226 152.523 121.974 152.776C122.479 153.028 122.731 153.281 122.731 153.281C122.731 153.281 122.226 153.786 121.974 154.038C122.226 154.291 122.479 155.301 122.226 155.554V155.806C122.731 156.059 122.984 157.321 122.984 157.321C122.984 157.321 122.731 157.321 122.479 157.574V157.826C122.479 158.079 122.731 158.079 122.731 158.079C122.731 158.331 122.479 158.331 122.226 158.584L121.974 158.836C121.721 159.089 122.226 159.089 122.479 159.089C122.479 159.089 122.226 160.352 121.974 160.604V161.362C121.974 161.614 121.974 161.867 121.974 161.867V162.624H121.721C121.721 162.877 121.469 163.129 121.469 163.129C121.469 163.129 120.206 162.624 119.953 162.119V161.867C119.701 162.119 119.196 162.372 119.196 162.372C119.196 162.372 118.691 161.867 118.691 161.362C118.691 161.362 118.691 161.362 118.438 161.362C117.933 161.614 116.671 161.362 116.671 161.362C116.671 161.362 116.671 160.857 116.923 160.604C116.418 160.857 115.66 160.857 115.66 160.857C115.66 160.857 115.66 159.594 115.913 159.089C115.913 159.089 116.166 159.089 116.166 158.836C115.66 158.584 115.155 157.574 115.155 157.574L115.408 157.321H115.66L115.913 157.069V156.816C115.913 156.816 115.913 156.816 115.66 156.564C115.408 156.311 114.903 155.554 114.903 155.554C114.903 155.554 115.408 155.301 115.913 155.049L116.166 155.301C116.418 155.301 116.418 155.301 116.166 155.301Z",
    fill: "#567601"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M127.279 155.301C127.784 155.049 128.289 153.786 128.289 153.786C128.289 153.786 127.784 153.533 127.279 153.281V153.028C127.784 153.028 128.289 153.028 128.289 153.028C128.289 153.028 128.289 151.766 127.784 151.261C128.289 151.008 128.794 149.998 128.794 149.998C128.794 149.998 128.036 149.493 127.279 149.241C127.531 149.241 127.784 148.988 127.784 148.988C128.036 148.483 128.036 147.22 128.036 147.22C128.036 147.22 127.531 147.22 127.279 147.22V146.968L126.773 147.22H126.521C126.016 146.968 125.006 146.968 125.006 146.968C125.006 146.968 125.006 147.22 125.006 147.473C124.753 147.473 124.248 147.978 123.996 148.23C123.491 147.978 123.238 147.725 123.238 147.725C123.238 147.725 122.986 147.978 122.986 148.483H122.733L122.481 148.23C122.228 148.23 122.228 147.978 121.976 148.23C121.976 148.483 121.976 148.735 121.976 148.988C121.976 148.988 121.976 148.988 121.723 148.988H121.47C121.47 148.988 120.965 150.251 121.218 150.756C121.218 150.756 121.218 151.008 121.47 151.008C121.47 151.261 121.47 151.766 121.723 152.018C121.218 152.271 120.965 152.523 120.965 152.523C120.965 152.523 121.47 153.028 121.723 153.281C121.47 153.533 121.218 154.544 121.47 154.796V155.049C120.965 155.301 120.713 156.564 120.713 156.564C120.713 156.564 120.965 156.564 121.218 156.816V157.069C121.218 157.321 120.965 157.321 120.965 157.321C120.965 157.574 121.218 157.574 121.47 157.826L121.723 158.079C121.976 158.331 121.47 158.331 121.218 158.331C121.218 158.331 121.47 159.594 121.723 159.847V160.604C121.723 160.857 121.723 161.109 121.723 161.109V161.867H121.976C121.976 162.119 122.228 162.372 122.228 162.372C122.228 162.372 123.491 161.867 123.743 161.362V161.109C123.996 161.362 124.501 161.614 124.501 161.614C124.501 161.614 125.006 161.109 125.006 160.604C125.006 160.604 125.006 160.604 125.258 160.604C125.763 160.857 127.026 160.604 127.026 160.604C127.026 160.604 127.026 160.099 126.773 159.847C127.279 160.099 128.036 160.099 128.036 160.099C128.036 160.099 128.036 158.836 127.784 158.331C127.784 158.331 127.531 158.331 127.531 158.079C128.036 157.826 128.541 156.816 128.541 156.816L128.289 156.564H128.036L127.784 156.311V156.059C127.784 156.059 127.784 156.059 128.036 155.806C128.289 155.554 128.794 154.796 128.794 154.796C128.794 154.796 128.289 154.544 127.784 154.291L127.279 155.301C127.026 155.301 127.026 155.301 127.279 155.301Z",
    fill: "#638800"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M126.268 146.463C126.268 146.715 126.268 146.715 126.268 146.463L125.763 146.21C125.763 145.705 124.5 144.695 124.5 144.695C124.5 144.695 124.5 144.947 124.248 144.947C123.995 144.442 122.985 143.685 122.985 143.685C122.985 143.685 122.985 143.937 122.733 144.19C122.228 143.685 121.47 143.18 121.47 143.18C121.47 143.18 121.218 143.685 120.965 144.442C120.965 144.19 120.713 144.19 120.713 144.19C120.713 144.19 119.45 144.695 119.197 145.2C119.197 145.2 119.197 145.452 119.197 145.705C118.692 145.705 117.682 145.705 117.682 145.705C117.682 145.705 117.682 145.957 117.935 146.463L117.682 146.715C117.43 146.715 117.43 146.715 117.177 146.715C116.672 146.715 115.662 147.978 115.662 147.978C115.662 147.978 116.672 148.988 117.43 148.988H117.682C117.682 149.493 118.945 150.25 118.945 150.25C118.945 150.25 119.197 149.998 119.45 149.745H119.703C119.955 150.25 120.713 151.008 120.713 151.008C120.713 151.008 120.965 150.755 121.218 150.503H121.47C121.47 150.503 121.47 150.503 121.47 150.755C121.723 151.008 121.975 151.008 122.228 151.008C122.733 151.008 123.238 151.008 123.238 151.008C123.238 151.008 123.238 150.755 123.238 150.25C123.49 150.503 123.995 150.755 123.995 150.755C123.995 150.755 124.753 149.998 124.753 149.24H125.006C125.258 149.493 125.763 149.998 125.763 149.998C125.763 149.998 126.521 148.988 126.521 148.483C126.773 148.483 126.773 148.483 127.026 148.483C127.531 148.483 128.541 147.22 128.541 147.22C128.541 147.22 126.773 146.463 126.268 146.463Z",
    fill: "#769C11"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7282 176.768L63.3848 181.818L70.9605 186.111L74.4959 185.606L75.7585 176.768H72.7282Z",
    fill: "#918B86"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4941 185.605L82.5749 181.06V180.05L74.4941 184.848V185.605Z",
    fill: "#CACACA"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M74.494 185.606L67.6758 181.818V180.808L74.494 184.849V185.606Z",
    fill: "#8B8B8B"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7566 176.01L67.6758 180.808L74.494 184.849L82.5748 180.051L75.7566 176.01Z",
    fill: "#EFEFEF"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9492 180.808L75.7573 177.525L80.3028 180.05L74.4947 183.333L69.9492 180.808Z",
    fill: "#FF816F"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0397 181.818C53.7872 182.07 54.0397 182.07 54.0397 181.818C53.7872 182.07 54.7973 182.828 55.3024 182.828L55.5549 183.08C55.5549 183.585 56.565 184.343 56.565 184.343C56.565 184.343 56.565 184.343 56.8175 184.09C56.8175 184.09 57.8276 184.09 58.0801 184.09V183.838C58.3326 184.343 58.8377 184.848 58.8377 184.848C58.8377 184.848 59.3428 184.343 59.5953 184.09C59.8478 184.343 61.1104 184.343 61.1104 184.343C61.1104 184.343 61.1104 184.09 60.8579 183.838H61.1104C61.3629 184.09 61.6155 184.595 61.6155 184.595C61.6155 184.595 62.373 184.343 62.373 183.838H62.6256C62.8781 184.09 63.1306 184.595 63.1306 184.595C63.1306 184.595 63.3831 184.343 63.6357 184.09H63.8882C63.8882 184.09 63.8882 184.343 64.1408 184.343L64.3933 184.595C64.3933 184.595 64.8983 184.343 65.1508 183.838C65.1508 183.838 65.1509 183.838 65.4034 184.09C65.6559 184.343 66.666 184.343 66.666 184.343C66.666 184.343 66.666 184.09 66.4135 183.838H66.666C66.9185 183.838 66.9185 183.838 66.9185 183.838C66.9185 183.838 66.9185 183.838 66.9185 183.585C67.171 183.585 67.171 183.333 67.4235 183.08C67.6761 182.828 67.6761 182.828 67.9286 182.575C67.9286 182.323 67.9286 182.07 68.1811 181.818C68.1811 181.565 68.4336 181.565 68.6862 181.313C68.9387 181.06 69.1912 181.06 69.6963 180.807C69.9488 180.807 70.2014 180.555 70.4539 180.555C70.9589 180.555 71.464 180.555 72.2216 180.555C72.7266 180.555 72.9791 180.555 73.4842 180.555C73.7367 180.555 73.9892 180.555 74.2418 180.555H74.4943C74.7468 180.807 74.9993 180.807 75.2518 180.807V180.555C75.2518 180.302 75.2518 180.05 75.2518 180.05C75.2518 179.797 74.9993 179.797 74.7468 179.797H74.4943C74.2417 179.797 73.9892 179.797 73.9892 180.05C73.7367 180.05 73.4842 180.05 73.2316 180.05C72.7266 180.05 72.2216 180.05 71.7165 180.05C70.9589 180.05 70.2013 180.05 69.4438 180.05C69.1912 180.05 69.1912 180.05 68.9387 180.05C68.4337 179.797 68.1811 179.797 67.6761 179.545C67.4236 179.292 67.171 179.292 66.9185 179.04C66.666 178.787 66.666 178.787 66.4135 178.535L66.1609 178.282H65.9084C65.9084 178.282 65.9084 178.282 65.6559 178.282C65.4034 178.03 65.4034 177.777 65.4034 177.777C65.4034 177.777 65.1508 177.777 64.8983 178.03C64.8983 177.777 64.6458 177.272 64.6458 177.272C64.6458 177.272 63.6357 177.272 63.3832 177.525C63.3832 177.525 63.3832 177.525 63.3832 177.777C63.1306 177.525 62.1205 177.02 62.1205 177.02V177.272V177.525C62.1205 177.525 62.1205 177.525 61.868 177.525C61.868 177.525 61.868 177.525 61.6155 177.525C61.6155 177.525 61.6155 177.525 61.363 177.525C61.1104 177.272 60.6054 177.02 60.6054 177.02C60.6054 177.02 60.3529 177.272 60.3529 177.777H60.1003C59.8478 177.525 58.8377 177.02 58.8377 177.02C58.8377 177.02 58.8377 177.525 58.8377 177.777H58.5852C58.5852 177.525 58.3327 177.272 58.3327 177.272C58.3327 177.272 57.3226 177.272 57.07 177.525C56.8175 177.272 55.8074 176.767 55.8074 176.767C55.8074 176.767 55.5549 177.272 55.5549 177.777C55.5549 177.525 55.3024 177.525 55.3024 177.272C55.0498 177.02 54.2923 177.02 54.0397 177.02H53.7872C53.7872 177.02 53.0296 177.525 53.2822 178.03C53.2822 178.03 53.2821 178.282 53.5347 178.282V178.535C53.2821 178.535 53.0296 178.535 53.0296 178.535C53.0296 178.535 53.0296 179.04 53.2822 179.545H53.0296C52.7771 179.797 52.5246 180.555 52.5246 180.555C52.5246 180.555 52.5246 180.555 52.7771 180.555C52.2721 180.555 52.0195 180.807 52.0195 180.807C52.0195 180.807 52.5246 181.313 53.0296 181.565C52.7771 181.565 52.7771 181.818 52.7771 181.818C52.7771 181.818 53.5347 181.818 54.0397 181.818ZM66.666 179.292C66.9185 179.292 67.171 179.545 67.6761 179.797C67.6761 179.797 67.9286 179.797 68.1811 180.05C67.9286 180.05 67.6761 180.05 67.4235 180.05H67.171C67.171 180.05 67.171 180.05 66.9185 180.05C66.666 179.797 66.4134 179.545 66.1609 179.545C66.1609 179.545 66.1609 179.545 65.9084 179.545C65.9084 179.545 65.9084 179.292 66.1609 179.292C66.4134 179.292 66.666 179.292 66.666 179.292ZM69.1913 180.555C68.9387 180.555 68.9387 180.807 68.6862 180.807L68.4337 181.06C68.1811 181.313 67.6761 181.565 67.171 181.818L66.9185 181.565C66.9185 181.565 66.9185 181.565 67.171 181.565C67.4236 181.565 67.4236 181.06 67.6761 180.807C67.9286 180.555 68.4337 180.555 69.1913 180.555ZM65.9084 178.282C65.9084 178.282 66.1609 178.535 65.9084 178.535C65.6559 178.535 65.6559 178.282 65.4034 178.282V178.03C65.6559 178.03 65.6559 178.282 65.9084 178.282ZM66.9185 183.08C66.9185 182.828 66.9185 182.575 66.666 182.323C66.9185 182.323 67.4235 182.07 67.4235 182.07C67.4235 182.07 67.4236 182.07 67.171 181.818C67.4236 181.818 67.6761 181.818 67.6761 182.07V182.323C67.6761 182.575 67.4235 182.828 67.4235 182.828C67.4235 183.08 67.171 183.08 66.9185 183.08Z",
    fill: "#918B86"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0278 170.201H77.7753C77.2702 170.201 77.7753 169.191 77.7753 168.939C77.7753 168.686 77.7753 168.434 78.0278 168.181C78.0278 167.929 78.2803 167.676 78.2803 167.171C78.2803 167.171 78.2803 167.424 78.0278 167.424C78.0278 167.676 77.7753 167.676 77.7753 167.929C77.7753 168.181 77.5227 168.434 77.5227 168.939C77.2702 169.696 76.7651 170.454 76.2601 171.212C76.2601 171.464 76.0076 171.464 76.0076 171.717C75.7551 171.969 75.5025 172.474 75.5025 172.727C75.5025 172.979 75.5025 173.232 75.5025 173.484C75.5025 173.737 75.5025 173.737 75.5025 173.989C75.5025 174.494 75.5025 174.999 75.25 175.504C75.25 175.252 75.5025 174.999 75.5025 174.747C75.7551 174.242 75.7551 173.737 76.0076 172.979C76.2601 172.474 76.2601 171.969 76.7652 171.464C77.0177 171.212 77.2702 170.959 77.2702 170.706C77.5227 170.454 78.0278 170.454 78.2803 170.201C78.5328 169.949 79.0379 169.696 79.0379 169.444C79.5429 168.939 80.048 168.181 80.3005 167.424C80.553 167.171 80.553 166.666 80.553 166.414C80.3005 166.919 80.048 167.424 79.7955 167.929C79.5429 168.434 79.2904 168.939 79.0379 169.444C78.7854 169.949 78.5328 170.201 78.0278 170.201Z",
    fill: "#91651F"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5012 174.747C75.5012 174.495 75.5012 174.242 75.5012 173.99C75.5012 173.737 75.5012 173.484 75.5012 173.232C75.5012 172.979 75.7537 172.474 76.0062 172.222C76.0062 171.969 76.2587 171.969 76.2587 171.717C76.7638 170.959 77.2688 170.202 77.5213 169.444C77.5213 169.192 77.7739 168.939 77.7739 168.434V168.181C77.7739 167.929 78.0264 167.676 78.0264 167.424C78.0264 167.424 78.0264 167.676 77.7739 167.676C77.7739 167.929 77.5213 167.929 77.5213 168.181C77.5213 168.434 77.2688 168.686 77.2688 169.192C77.0163 169.949 76.5113 170.707 76.0062 171.464C76.0062 171.717 75.7537 171.717 75.7537 171.969C75.5012 172.222 75.2486 172.727 75.2486 172.979C75.2486 173.232 75.2486 173.484 75.2486 173.737C75.2486 173.989 75.2486 173.989 75.2486 174.242C75.2486 174.747 75.2486 175.252 74.9961 175.757C75.2486 175.505 75.2486 175.252 75.5012 174.747Z",
    fill: "#AA7723"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4727 169.444C72.7253 169.444 72.7253 169.696 72.9778 169.444C72.9778 169.444 73.2304 169.191 72.9778 168.939V168.686C72.9778 168.181 72.7253 167.676 72.7253 167.171C72.4728 166.413 72.4727 165.656 72.4727 165.151C72.7253 165.656 72.7253 166.161 72.7253 166.919C72.7253 167.171 72.7253 167.676 72.9778 167.929C72.9778 168.181 72.9778 168.181 73.2303 168.434C73.2303 168.686 73.2303 168.686 73.2303 168.939C73.2303 169.191 73.4829 169.444 73.4829 169.696C73.4829 169.949 73.7354 170.201 73.7354 170.454C73.9879 170.706 73.9879 171.211 74.2405 171.464C74.493 171.717 74.7455 172.222 74.7455 172.474C74.7455 172.727 74.7455 172.979 74.7455 173.232C74.7455 173.484 74.7455 173.484 74.7455 173.737C74.7455 174.242 74.7455 174.747 74.998 175.252C74.998 174.999 74.7455 174.747 74.7455 174.494C74.493 173.989 74.493 173.484 74.2405 172.727C73.9879 172.222 73.9879 171.717 73.4829 171.211C73.2303 170.959 72.9778 170.706 72.9778 170.454C72.7253 170.201 72.4728 170.201 72.2202 169.949C71.9677 169.696 71.7152 169.696 71.7152 169.444C71.2102 168.939 70.7051 168.181 70.7051 167.424C70.7051 167.676 70.9576 167.929 70.9576 167.929C71.2101 168.181 71.2101 168.434 71.4627 168.686C71.7152 168.686 71.9677 169.191 72.4727 169.444Z",
    fill: "#91651F"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7265 166.919C72.7265 167.171 72.7265 167.676 72.979 167.929C72.979 168.181 72.979 168.181 73.2315 168.434C73.2315 168.686 73.2315 168.686 73.2315 168.939C73.2315 169.191 73.4841 169.444 73.4841 169.696C73.4841 169.949 73.7366 170.201 73.7366 170.454C73.9891 170.707 73.9891 171.212 74.2417 171.464C74.4942 171.717 74.7467 172.222 74.7467 172.474C74.7467 172.727 74.7467 172.979 74.7467 173.232C74.7467 173.232 74.7467 173.232 74.7467 173.484C74.7467 173.737 74.9992 173.989 74.9992 174.242C74.9992 174.494 75.2518 174.747 75.2518 174.999C75.2518 174.494 74.9992 173.989 74.9992 173.484C74.9992 173.232 74.9992 173.232 74.9992 172.979C74.9992 172.727 74.9992 172.474 74.9992 172.222C74.9992 171.969 74.7467 171.464 74.4942 171.212C74.2416 170.959 73.9891 170.454 73.9891 170.201C73.9891 169.949 73.7366 169.696 73.7366 169.444C73.7366 169.191 73.4841 168.939 73.4841 168.686C73.4841 168.434 73.4841 168.434 73.4841 168.181C73.4841 167.929 73.4841 167.929 73.2315 167.676C73.2315 167.424 72.979 166.919 72.979 166.666C72.979 166.161 72.7265 165.656 72.7265 164.898C72.7265 165.151 72.7265 165.151 72.7265 165.403C72.474 165.909 72.474 166.414 72.7265 166.919Z",
    fill: "#AA7723"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4627 168.939L71.7152 169.191C71.7152 169.191 71.7152 169.444 71.9677 169.444L72.2202 169.696C72.4728 169.696 72.4728 169.949 72.7253 169.696V169.444C72.4728 169.444 72.4728 169.444 72.2202 169.444C71.9677 169.191 71.4627 168.686 71.4627 168.434C71.2101 168.181 71.2101 167.928 70.9576 167.676C70.9576 167.676 70.7051 167.423 70.7051 167.171C70.7051 167.423 70.7051 167.676 70.9576 168.181C71.2101 168.434 71.4627 168.686 71.4627 168.939Z",
    fill: "#AA7723"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7515 180.301C75.4989 180.553 75.2464 180.806 74.9939 180.806C74.7413 180.806 74.2363 180.553 74.2363 180.553C74.2363 180.553 74.2363 180.553 74.2363 180.301C74.2363 180.048 74.4888 179.796 74.4888 179.291C74.4888 179.038 74.4888 178.533 74.4888 178.281C74.4888 177.523 74.4888 176.765 74.4888 176.26C74.4888 174.493 74.4888 172.725 74.4888 170.957C74.4888 170.705 74.4888 170.705 74.4888 170.452C74.4888 169.947 74.4888 169.695 74.4888 169.19C74.4888 168.685 74.4888 168.432 74.4888 167.927V167.675V167.422V167.169V166.917V166.664V166.412C74.4888 166.159 74.4888 166.159 74.4888 165.907C74.4888 165.907 74.4888 165.907 74.4888 165.654C74.4888 167.169 74.4888 168.432 74.4888 169.947C74.4888 170.957 74.4888 171.715 74.4888 172.725C74.4888 173.23 74.4888 173.735 74.4888 174.24C74.4888 174.998 74.4888 175.755 74.4888 176.513C74.4888 177.018 74.4888 177.776 74.4888 178.281C74.4888 178.533 74.4888 179.038 74.4888 179.291C74.4888 179.291 74.4888 179.291 74.4888 179.543V179.796C75.4989 180.048 75.4989 180.048 75.7515 180.301Z",
    fill: "#91651F"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5023 165.655C75.2498 166.16 75.2498 166.665 75.2498 167.17C74.9972 168.433 74.9972 169.443 74.9972 170.706C74.9972 172.473 74.7447 174.241 74.9972 176.009C74.9972 176.766 74.9972 177.524 74.9972 178.029C74.9972 178.282 74.9972 178.787 74.9972 179.039C74.9972 179.292 74.9973 179.544 74.7447 180.049C74.7447 180.302 74.4922 180.302 74.4922 180.554C74.4922 180.554 74.4922 180.554 74.4922 180.302C74.4922 180.049 74.7447 179.797 74.7447 179.292C74.7447 179.039 74.7447 178.534 74.7447 178.282C74.7447 177.524 74.7447 176.766 74.7447 176.261C74.7447 174.494 74.7447 172.726 74.7447 170.958C74.7447 170.706 74.7447 170.706 74.7447 170.453C74.7447 169.948 74.7447 169.696 74.7447 169.191C74.7447 168.686 74.7447 168.433 74.7447 167.928V167.675V167.423V167.17V166.918V166.665V166.413C75.2498 166.16 75.2498 165.908 75.5023 165.655C75.2498 165.655 75.2498 165.655 75.5023 165.655Z",
    fill: "#855107"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7537 180.302C75.7537 180.555 75.7537 180.555 75.7537 180.302C75.5012 180.302 75.5012 180.302 75.5012 180.302C75.5012 180.302 75.2486 180.302 75.2486 180.05C74.9961 179.797 74.9961 179.545 74.9961 179.292C74.9961 179.04 74.9961 178.535 74.9961 178.282C74.9961 177.777 74.9961 177.02 74.9961 176.515C74.9961 175.757 74.9961 174.999 74.9961 174.242C74.9961 173.737 74.9961 173.232 74.9961 172.727C74.9961 171.717 74.9961 170.959 74.9961 169.949C74.9961 168.939 74.9961 167.929 74.9961 166.919C74.9961 166.666 74.9961 166.413 74.9961 165.908C74.9961 165.656 74.9961 165.656 74.9961 165.403C74.9961 165.403 74.9961 165.403 74.9961 165.151C74.9961 166.666 74.9961 167.929 74.9961 169.444C74.9961 170.454 74.9961 171.211 74.9961 172.222C74.9961 172.727 74.9961 173.232 74.9961 173.737C74.9961 174.494 74.9961 175.252 74.9961 176.009C74.9961 176.515 74.9961 177.272 74.9961 177.777C74.9961 178.03 74.9961 178.535 74.9961 178.787C74.9961 178.787 74.9961 178.787 74.9961 179.04V179.292C75.5011 180.05 75.5012 180.05 75.7537 180.302Z",
    fill: "#AA7723"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9468 162.372C69.4417 162.12 68.9367 160.857 68.9367 160.857C68.9367 160.857 69.4417 160.605 69.9468 160.352V160.1C69.4417 160.1 68.9367 160.1 68.9367 160.1C68.9367 160.1 68.9367 158.837 69.4417 158.332C68.9367 158.079 68.4316 157.069 68.4316 157.069C68.4316 157.069 69.1892 156.564 69.9468 156.312C69.6942 156.312 69.4417 156.059 69.4417 156.059C69.1892 155.554 69.1892 154.292 69.1892 154.292C69.1892 154.292 69.6942 154.292 69.9468 154.292V154.039L70.4519 154.292H70.7044C71.2094 154.039 72.2195 154.039 72.2195 154.039C72.2195 154.039 72.2195 154.292 72.2195 154.544C72.472 154.544 72.9771 155.049 73.2296 155.302C73.7347 155.049 73.9872 154.797 73.9872 154.797C73.9872 154.797 74.2397 155.049 74.2397 155.554H74.4922L74.7448 155.302C74.9973 155.302 74.9973 155.049 75.2498 155.302C75.2498 155.554 75.2498 155.807 75.2498 156.059C75.2498 156.059 75.2498 156.059 75.5024 156.059H75.7549C75.7549 156.059 76.2599 157.322 76.0074 157.827C76.0074 157.827 76.0074 158.079 75.7549 158.079C75.7549 158.332 75.7549 158.837 75.5024 159.09C76.0074 159.342 76.2599 159.595 76.2599 159.595C76.2599 159.595 75.7549 160.1 75.5024 160.352C75.7549 160.605 76.0074 161.615 75.7549 161.867V162.12C76.2599 162.372 76.5124 163.635 76.5124 163.635C76.5124 163.635 76.2599 163.635 76.0074 163.888V164.14C76.0074 164.393 76.2599 164.393 76.2599 164.393C76.2599 164.645 76.0074 164.645 75.7549 164.898L75.5024 165.15C75.2498 165.403 75.7549 165.403 76.0074 165.403C76.0074 165.403 75.7549 166.665 75.5024 166.918V167.675C75.5024 167.928 75.5024 168.18 75.5024 168.18V168.938H75.2498C75.2498 169.191 74.9973 169.443 74.9973 169.443C74.9973 169.443 73.7347 168.938 73.4821 168.433V168.18C73.2296 168.433 72.7246 168.686 72.7246 168.686C72.7246 168.686 72.2195 168.18 72.2195 167.675C72.2195 167.675 72.2195 167.675 71.967 167.675C71.4619 167.928 70.1993 167.675 70.1993 167.675C70.1993 167.675 70.1993 167.17 70.4519 166.918C69.9468 167.17 69.1892 167.17 69.1892 167.17C69.1892 167.17 69.1892 165.908 69.4417 165.403C69.4417 165.403 69.6943 165.403 69.6943 165.15C69.1892 164.898 68.6841 163.888 68.6841 163.888L68.9367 163.635H69.1892L69.4417 163.382V163.13C69.4417 163.13 69.4417 163.13 69.1892 162.877C68.9367 162.625 68.4316 161.867 68.4316 161.867C68.4316 161.867 68.9367 161.615 69.4417 161.362L69.9468 162.372Z",
    fill: "#567601"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8039 162.372C81.309 162.12 81.814 160.857 81.814 160.857C81.814 160.857 81.309 160.605 80.8039 160.352V160.1C81.309 160.1 81.814 160.1 81.814 160.1C81.814 160.1 81.814 158.837 81.309 158.332C81.814 158.079 82.3191 157.069 82.3191 157.069C82.3191 157.069 81.5615 156.564 80.8039 156.312C81.0564 156.312 81.309 156.059 81.309 156.059C81.5615 155.554 81.5615 154.292 81.5615 154.292C81.5615 154.292 81.0564 154.292 80.8039 154.292V154.039L80.2989 154.292H80.0463C79.5413 154.039 78.5312 154.039 78.5312 154.039C78.5312 154.039 78.5312 154.292 78.5312 154.544C78.2787 154.544 77.7736 155.049 77.5211 155.302C77.016 155.049 76.7635 154.797 76.7635 154.797C76.7635 154.797 76.511 155.049 76.511 155.554H76.2585L76.006 155.302C75.7534 155.302 75.7534 155.049 75.5009 155.302C75.5009 155.554 75.5009 155.807 75.5009 156.059C75.5009 156.059 75.5009 156.059 75.2484 156.059H74.9958C74.9958 156.059 74.4908 157.322 74.7433 157.827C74.7433 157.827 74.7433 158.079 74.9958 158.079C74.9958 158.332 74.9958 158.837 75.2484 159.09C74.7433 159.342 74.4908 159.595 74.4908 159.595C74.4908 159.595 74.9958 160.1 75.2484 160.352C74.9958 160.605 74.7433 161.615 74.9958 161.867V162.12C74.4908 162.372 74.2383 163.635 74.2383 163.635C74.2383 163.635 74.4908 163.635 74.7433 163.888V164.14C74.7433 164.393 74.4908 164.393 74.4908 164.393C74.4908 164.645 74.7433 164.645 74.9958 164.898L75.2484 165.15C75.5009 165.403 74.9958 165.403 74.7433 165.403C74.7433 165.403 74.9958 166.665 75.2484 166.918V167.675C75.2484 167.928 75.2484 168.18 75.2484 168.18V168.938H75.5009C75.5009 169.191 75.7534 169.443 75.7534 169.443C75.7534 169.443 77.0161 168.938 77.2686 168.433V168.18C77.5211 168.433 78.0262 168.686 78.0262 168.686C78.0262 168.686 78.5312 168.18 78.5312 167.675C78.5312 167.675 78.5312 167.675 78.7837 167.675C79.2888 167.928 80.5514 167.675 80.5514 167.675C80.5514 167.675 80.5514 167.17 80.2989 166.918C80.8039 167.17 81.5615 167.17 81.5615 167.17C81.5615 167.17 81.5615 165.908 81.309 165.403C81.309 165.403 81.0565 165.403 81.0565 165.15C81.5615 164.898 82.0665 163.888 82.0665 163.888L81.814 163.635H81.5615L81.309 163.382V163.13C81.309 163.13 81.309 163.13 81.5615 162.877C81.814 162.625 82.3191 161.867 82.3191 161.867C82.3191 161.867 81.814 161.615 81.309 161.362L80.8039 162.372Z",
    fill: "#638800"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0455 153.787L79.5405 153.534C79.5405 153.029 78.2778 152.019 78.2778 152.019C78.2778 152.019 78.2779 152.272 78.0253 152.272C77.7728 151.767 76.7627 151.009 76.7627 151.009C76.7627 151.009 76.7627 151.261 76.5102 151.514C76.0051 151.009 75.2475 150.504 75.2475 150.504C75.2475 150.504 74.995 151.009 74.7425 151.767C74.7425 151.514 74.49 151.514 74.49 151.514C74.49 151.514 73.2274 152.019 72.9748 152.524C72.9748 152.524 72.9748 152.777 72.9748 153.029C72.4698 153.029 71.4597 153.029 71.4597 153.029C71.4597 153.029 71.4597 153.282 71.7122 153.787L71.4597 154.039C71.2071 154.039 71.2071 154.039 70.9546 154.039C70.4496 154.039 69.4395 155.302 69.4395 155.302C69.4395 155.302 70.4495 156.312 71.2071 156.312H71.4597C71.4597 156.817 72.7223 157.575 72.7223 157.575C72.7223 157.575 72.9748 157.322 73.2273 157.07H73.4799C73.7324 157.575 74.49 158.332 74.49 158.332C74.49 158.332 74.7425 158.08 74.995 157.827H75.2475C75.2475 157.827 75.2475 157.827 75.2475 158.08C75.5001 158.332 75.5001 158.332 76.0051 158.332C76.5102 158.332 77.0152 158.332 77.0152 158.332C77.0152 158.332 77.0152 158.08 77.0152 157.575C77.2677 157.827 77.7728 158.08 77.7728 158.08C77.7728 158.08 78.5304 157.322 78.5304 156.565H78.7829C79.0354 156.817 79.5405 157.322 79.5405 157.322C79.5405 157.322 80.298 156.312 80.298 155.807C80.5506 155.807 80.5506 155.807 80.8031 155.807C81.3081 155.807 82.3183 154.544 82.3183 154.544C82.3183 154.544 80.5506 153.534 80.0455 153.787Z",
    fill: "#769C11"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M157.068 147.728L147.725 152.778L155.3 157.071L158.836 156.818L160.351 147.728H157.068Z",
    fill: "#918B86"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M158.836 156.818L167.169 152.02V151.01L158.836 155.808V156.818Z",
    fill: "#CACACA"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M158.838 156.819L152.02 152.778V151.768L158.838 155.808V156.819Z",
    fill: "#8B8B8B"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M160.1 147.222L152.02 151.768L158.838 155.808L167.171 151.01L160.1 147.222Z",
    fill: "#EFEFEF"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M154.291 151.767L160.099 148.484L164.645 151.01L158.837 154.545L154.291 151.767Z",
    fill: "#FF816F"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M138.381 153.031C138.129 153.283 139.139 154.041 139.644 154.041L139.897 154.294C139.897 154.799 140.907 155.556 140.907 155.556C140.907 155.556 140.907 155.556 141.159 155.304C141.159 155.304 142.169 155.304 142.422 155.304V155.051C142.674 155.556 143.179 156.061 143.179 156.061C143.179 156.061 143.685 155.556 143.937 155.304C144.19 155.556 145.452 155.556 145.452 155.556C145.452 155.556 145.452 155.304 145.2 155.051H145.452C145.705 155.304 145.957 155.809 145.957 155.809C145.957 155.809 146.715 155.556 146.715 155.051H146.967C147.22 155.304 147.472 155.809 147.472 155.809C147.472 155.809 147.725 155.556 147.977 155.304H148.23C148.23 155.304 148.23 155.556 148.483 155.556L148.735 155.809C148.735 155.809 149.24 155.556 149.493 155.051C149.493 155.051 149.493 155.051 149.745 155.304C149.998 155.556 151.008 155.556 151.008 155.556C151.008 155.556 151.008 155.304 150.755 155.051H151.008C151.26 155.051 151.26 155.051 151.26 155.051C151.26 155.051 151.26 155.051 151.26 154.799C151.513 154.799 151.513 154.546 151.765 154.294C152.018 154.041 152.018 154.041 152.27 153.789C152.27 153.536 152.27 153.283 152.523 153.031C152.523 152.778 152.775 152.778 153.028 152.526C153.28 152.273 153.533 152.273 154.038 152.021C154.291 152.021 154.543 151.768 154.796 151.768C155.301 151.768 155.806 151.768 156.563 151.768C157.068 151.768 157.321 151.768 157.826 151.768C158.079 151.768 158.331 151.768 158.584 151.768H158.836C159.089 152.021 159.341 152.021 159.594 152.021V151.768C159.594 151.516 159.594 151.263 159.594 151.263C159.594 151.011 159.341 151.011 159.089 151.011H158.836C158.584 151.011 158.331 151.011 158.331 151.263C158.078 151.263 157.826 151.263 157.573 151.263C157.068 151.263 156.563 151.263 156.058 151.263C155.301 151.263 154.543 151.263 153.786 151.263C153.533 151.263 153.533 151.263 153.28 151.263C152.775 151.011 152.523 151.011 152.018 150.758C151.765 150.506 151.513 150.506 151.26 150.253C151.008 150.001 151.008 150.001 150.755 149.748L150.503 149.496H150.25C150.25 149.496 150.25 149.496 149.998 149.496C149.745 149.243 149.745 148.991 149.745 148.991C149.745 148.991 149.493 148.991 149.24 149.243C149.24 148.991 148.988 148.486 148.988 148.486C148.988 148.486 147.977 148.486 147.725 148.738C147.725 148.738 147.725 148.738 147.725 148.991C147.472 148.738 146.462 148.233 146.462 148.233V148.486V148.738C146.462 148.738 146.462 148.738 146.21 148.738C146.21 148.738 146.21 148.738 145.957 148.738C145.957 148.738 145.957 148.738 145.705 148.738C145.452 148.486 144.947 148.233 144.947 148.233C144.947 148.233 144.695 148.486 144.695 148.991H144.442C144.19 148.738 143.179 148.233 143.179 148.233C143.179 148.233 143.179 148.738 143.179 148.991H142.927C142.927 148.738 142.674 148.486 142.674 148.486C142.674 148.486 141.664 148.486 141.412 148.738C141.159 148.486 140.149 147.98 140.149 147.98C140.149 147.98 139.897 148.486 139.897 148.991C139.897 148.738 139.644 148.738 139.644 148.486C139.392 148.233 138.634 148.233 138.381 148.233H138.129C138.129 148.233 137.371 148.738 137.624 149.243C137.624 149.243 137.624 149.496 137.876 149.496V149.748C137.624 149.748 137.371 149.748 137.371 149.748C137.371 149.748 137.371 150.253 137.624 150.758H137.371C137.119 151.011 136.866 151.768 136.866 151.768C136.866 151.768 136.866 151.768 137.119 151.768C136.614 151.768 136.361 152.021 136.361 152.021C136.361 152.021 136.866 152.526 137.371 152.778C137.119 152.778 137.119 153.031 137.119 153.031C137.119 153.031 137.876 152.778 138.381 153.031ZM151.26 150.506C151.513 150.506 151.765 150.758 152.27 151.011C152.27 151.011 152.523 151.011 152.775 151.263C152.523 151.263 152.27 151.263 152.018 151.263H151.765C151.765 151.263 151.765 151.263 151.513 151.263C151.26 151.011 151.008 150.758 150.755 150.758C150.755 150.758 150.755 150.758 150.503 150.758C150.503 150.758 150.503 150.506 150.755 150.506C150.755 150.253 151.008 150.253 151.26 150.506ZM153.533 151.516C153.28 151.516 153.28 151.768 153.028 151.768L152.775 152.021C152.523 152.273 152.018 152.526 151.513 152.778L151.26 152.526C151.26 152.526 151.26 152.526 151.513 152.526C151.765 152.526 151.765 152.021 152.018 151.768C152.27 151.516 152.775 151.516 153.533 151.516ZM150.25 149.243C150.25 149.243 150.503 149.496 150.25 149.496C149.998 149.496 149.998 149.243 149.745 149.243V148.991C149.998 149.243 149.998 149.243 150.25 149.243ZM151.513 154.041C151.513 153.789 151.513 153.536 151.26 153.283C151.513 153.283 152.018 153.031 152.018 153.031C152.018 153.031 152.018 153.031 151.765 152.778C152.018 152.778 152.27 152.778 152.27 153.031V153.283C152.27 153.536 152.018 153.789 152.018 153.789C151.765 154.041 151.513 154.041 151.513 154.041Z",
    fill: "#918B86"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M162.37 141.414H162.117C161.612 141.414 162.117 140.404 162.117 140.152C162.117 139.899 162.117 139.647 162.37 139.394C162.37 139.142 162.622 138.889 162.622 138.384C162.622 138.384 162.622 138.637 162.37 138.637C162.37 138.889 162.117 138.889 162.117 139.142C162.117 139.394 161.865 139.647 161.865 140.152C161.612 140.909 161.107 141.667 160.602 142.424C160.602 142.677 160.349 142.677 160.349 142.929C160.097 143.182 159.844 143.687 159.844 143.94C159.844 144.192 159.844 144.445 159.844 144.697C159.844 144.95 159.844 144.95 159.844 145.202C159.844 145.707 159.844 146.212 159.592 146.717C159.592 146.465 159.844 146.212 159.844 145.96C160.097 145.455 160.097 144.95 160.349 144.192C160.602 143.687 160.602 143.182 161.107 142.677C161.359 142.424 161.612 142.172 161.612 141.919C161.865 141.667 162.37 141.667 162.622 141.414C162.875 141.162 163.38 140.909 163.38 140.657C163.885 140.152 164.39 139.394 164.642 138.637C164.895 138.384 164.895 137.879 164.895 137.626C164.642 138.132 164.39 138.637 164.137 139.142C163.885 139.647 163.632 140.152 163.38 140.657C163.127 140.909 162.875 141.162 162.37 141.414Z",
    fill: "#91651F"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M159.845 145.959C159.845 145.706 159.845 145.706 159.845 145.959C159.845 145.706 159.845 145.454 159.845 145.201C159.845 144.949 159.845 144.696 159.845 144.444C159.845 144.191 160.097 143.686 160.35 143.434C160.35 143.181 160.602 143.181 160.602 142.929C161.108 142.171 161.613 141.414 161.865 140.656C161.865 140.403 162.118 140.151 162.118 139.646V139.393C162.118 139.141 162.37 138.888 162.37 138.636C162.37 138.636 162.37 138.888 162.118 138.888C162.118 139.141 161.865 139.141 161.865 139.393C161.865 139.646 161.613 139.898 161.613 140.403C161.36 141.161 160.855 141.919 160.35 142.676C160.35 142.929 160.097 142.929 160.097 143.181C159.845 143.434 159.592 143.939 159.592 144.191C159.592 144.444 159.592 144.696 159.592 144.949C159.592 145.201 159.592 145.201 159.592 145.454C159.592 145.959 159.592 146.464 159.34 146.969C159.592 146.464 159.845 146.211 159.845 145.959Z",
    fill: "#AA7723"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M156.815 140.403C157.067 140.403 157.067 140.656 157.32 140.403C157.32 140.403 157.572 140.151 157.32 139.898V139.646C157.32 139.141 157.067 138.636 157.067 138.131C156.815 137.373 156.815 136.615 156.815 136.11C157.067 136.615 157.067 137.12 157.067 137.878C157.067 138.131 157.067 138.636 157.32 138.888C157.32 139.141 157.32 139.141 157.572 139.393C157.572 139.646 157.572 139.646 157.572 139.898C157.572 140.151 157.825 140.403 157.825 140.656C157.825 140.908 158.077 141.161 158.077 141.413C158.33 141.666 158.33 142.171 158.582 142.423C158.835 142.676 159.087 143.181 159.087 143.434C159.087 143.686 159.087 143.939 159.087 144.191C159.087 144.444 159.087 144.444 159.087 144.696C159.087 145.201 159.087 145.706 159.34 146.211C159.34 145.959 159.087 145.706 159.087 145.454C158.835 144.949 158.835 144.444 158.582 143.686C158.33 143.181 158.33 142.676 157.825 142.171C157.572 141.918 157.32 141.666 157.32 141.413C157.067 141.161 156.815 141.161 156.562 140.908C156.31 140.656 156.057 140.656 156.057 140.403C155.552 139.898 155.047 139.141 155.047 138.383C155.047 138.636 155.299 138.888 155.299 138.888C155.552 139.141 155.552 139.393 155.804 139.646C156.057 139.646 156.562 140.403 156.815 140.403Z",
    fill: "#91651F"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M157.068 137.878C157.068 138.131 157.068 138.636 157.321 138.888C157.321 139.141 157.321 139.141 157.573 139.393C157.573 139.646 157.573 139.646 157.573 139.898C157.573 140.151 157.826 140.403 157.826 140.656C157.826 140.908 158.078 141.161 158.078 141.413C158.331 141.666 158.331 142.171 158.583 142.424C158.836 142.676 159.089 143.181 159.089 143.434C159.089 143.686 159.089 143.939 159.089 144.191C159.089 144.191 159.089 144.191 159.089 144.444C159.089 144.696 159.341 144.949 159.341 145.201C159.341 145.454 159.594 145.706 159.594 145.959C159.594 145.454 159.341 144.949 159.341 144.444C159.341 144.191 159.341 144.191 159.341 143.939C159.341 143.686 159.341 143.434 159.341 143.181C159.341 142.929 159.089 142.424 158.836 142.171C158.583 141.919 158.331 141.413 158.331 141.161C158.331 140.908 158.078 140.656 158.078 140.403C158.078 140.151 157.826 139.898 157.826 139.646C157.826 139.393 157.826 139.393 157.826 139.141C157.826 138.888 157.826 138.888 157.573 138.636C157.573 138.383 157.321 137.878 157.321 137.626C157.321 137.121 157.068 136.615 157.068 135.858C157.068 136.11 157.068 136.11 157.068 136.363C156.816 137.121 156.816 137.373 157.068 137.878Z",
    fill: "#AA7723"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M155.804 139.898L156.057 140.151C156.057 140.151 156.057 140.403 156.31 140.403L156.562 140.656C156.815 140.656 156.815 140.908 157.067 140.656V140.403C156.815 140.403 156.815 140.403 156.562 140.403C156.31 140.151 155.804 139.646 155.804 139.393C155.552 139.14 155.552 138.888 155.299 138.635C155.299 138.635 155.047 138.383 155.047 138.13C155.047 138.383 155.047 138.635 155.299 139.14C155.552 139.393 155.804 139.646 155.804 139.898Z",
    fill: "#AA7723"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M160.097 151.262C160.097 151.514 160.097 151.514 160.097 151.262C159.845 151.514 159.592 151.767 159.34 151.767C159.087 151.767 158.582 151.514 158.582 151.514C158.582 151.514 158.582 151.514 158.582 151.262C158.582 151.009 158.835 150.757 158.835 150.252C158.835 149.999 158.835 149.494 158.835 149.241C158.835 148.484 158.835 147.726 158.835 147.221C158.835 145.454 158.835 143.686 158.835 141.918C158.835 141.666 158.835 141.666 158.835 141.413C158.835 140.908 158.835 140.656 158.835 140.151C158.835 139.646 158.835 139.393 158.835 138.888V138.635V138.383V138.13V137.878V137.625V137.373C158.835 137.12 158.835 137.12 158.835 136.868C158.835 136.868 158.835 136.868 158.835 136.615C158.835 138.13 158.835 139.393 158.835 140.908C158.835 141.918 158.835 142.676 158.835 143.686C158.835 144.191 158.835 144.696 158.835 145.201C158.835 145.959 158.835 146.716 158.835 147.474C158.835 147.979 158.835 148.736 158.835 149.241C158.835 149.494 158.835 149.999 158.835 150.252C158.835 150.252 158.835 150.252 158.835 150.504V150.757C159.845 151.009 160.097 151.009 160.097 151.262Z",
    fill: "#91651F"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M159.844 136.615C159.592 137.12 159.592 137.625 159.592 138.13C159.339 139.393 159.339 140.403 159.339 141.666C159.339 143.433 159.086 145.201 159.339 146.969C159.339 147.726 159.339 148.484 159.339 148.989C159.339 149.242 159.339 149.747 159.339 149.999C159.339 150.252 159.339 150.504 159.087 151.009C159.087 151.262 158.834 151.262 158.834 151.514C158.834 151.514 158.834 151.514 158.834 151.262C158.834 151.009 159.087 150.757 159.087 150.252C159.087 149.999 159.087 149.494 159.087 149.241C159.087 148.484 159.087 147.726 159.087 147.221C159.087 145.454 159.087 143.686 159.087 141.918C159.087 141.666 159.087 141.666 159.087 141.413C159.087 140.908 159.087 140.656 159.087 140.151C159.087 139.646 159.087 139.393 159.087 138.888V138.635V138.383V138.13V137.878V137.625V137.373C159.592 137.12 159.592 136.868 159.844 136.615C159.592 136.615 159.592 136.615 159.844 136.615Z",
    fill: "#855107"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M160.097 151.262C159.845 151.262 159.845 151.262 159.845 151.262C159.845 151.262 159.592 151.262 159.592 151.009C159.34 150.757 159.34 150.504 159.34 150.252C159.34 149.999 159.34 149.494 159.34 149.242C159.34 148.737 159.34 147.979 159.34 147.474C159.34 146.716 159.34 145.959 159.34 145.201C159.34 144.696 159.34 144.191 159.34 143.686C159.34 142.676 159.34 141.918 159.34 140.908C159.34 139.898 159.34 138.888 159.34 137.878C159.34 137.625 159.34 137.373 159.34 136.868C159.34 136.615 159.34 136.615 159.34 136.363C159.34 136.363 159.34 136.363 159.34 136.11C159.34 137.626 159.34 138.888 159.34 140.403C159.34 141.413 159.34 142.171 159.34 143.181C159.34 143.686 159.34 144.191 159.34 144.696C159.34 145.454 159.34 146.211 159.34 146.969C159.34 147.474 159.34 148.232 159.34 148.737C159.34 148.989 159.34 149.494 159.34 149.747C159.34 149.747 159.34 149.747 159.34 149.999V150.252C159.845 151.009 160.097 151.009 160.097 151.262Z",
    fill: "#AA7723"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M154.29 133.333C153.785 133.081 153.28 131.818 153.28 131.818C153.28 131.818 153.785 131.566 154.29 131.313V131.061C153.785 131.061 153.28 131.061 153.28 131.061C153.28 131.061 153.28 129.798 153.785 129.293C153.28 129.04 152.775 128.03 152.775 128.03C152.775 128.03 153.533 127.525 154.29 127.273C154.038 127.273 153.785 127.02 153.785 127.02C153.533 126.515 153.533 125.253 153.533 125.253C153.533 125.253 154.038 125.253 154.29 125.253V125L154.796 125.253H155.048C155.553 125 156.563 125 156.563 125C156.563 125 156.563 125.253 156.563 125.505C156.816 125.505 157.321 126.01 157.573 126.263C158.078 126.01 158.331 125.758 158.331 125.758C158.331 125.758 158.583 126.01 158.583 126.515H158.836L159.089 126.263C159.341 126.263 159.341 126.01 159.594 126.263C159.594 126.515 159.594 126.768 159.594 127.02C159.594 127.02 159.594 127.02 159.846 127.02H160.099C160.099 127.02 160.604 128.283 160.351 128.788C160.351 128.788 160.351 129.04 160.099 129.04C160.099 129.293 160.099 129.798 159.846 130.051C160.351 130.303 160.604 130.556 160.604 130.556C160.604 130.556 160.099 131.061 159.846 131.313C160.099 131.566 160.351 132.576 160.099 132.828V133.081C160.604 133.333 160.856 134.596 160.856 134.596C160.856 134.596 160.604 134.596 160.351 134.848V135.101C160.351 135.354 160.604 135.354 160.604 135.354C160.604 135.606 160.351 135.606 160.099 135.859L159.846 136.111C159.594 136.364 160.099 136.364 160.351 136.364C160.351 136.364 160.099 137.626 159.846 137.879V138.636C159.846 138.889 159.846 139.141 159.846 139.141V139.899H159.594C159.594 140.152 159.341 140.404 159.341 140.404C159.341 140.404 158.078 139.899 157.826 139.394V139.141C157.573 139.394 157.068 139.646 157.068 139.646C157.068 139.646 156.563 139.141 156.563 138.636C156.563 138.636 156.563 138.636 156.311 138.636C155.806 138.889 154.543 138.636 154.543 138.636C154.543 138.636 154.543 138.131 154.796 137.879C154.291 138.131 153.533 138.131 153.533 138.131C153.533 138.131 153.533 136.869 153.785 136.364C153.785 136.364 154.038 136.364 154.038 136.111C153.533 135.859 153.028 134.848 153.028 134.848L153.28 134.596H153.533L153.785 134.343V134.091C153.785 134.091 153.785 134.091 153.533 133.838C153.28 133.586 152.775 132.828 152.775 132.828C152.775 132.828 153.28 132.576 153.785 132.323L154.29 133.333C154.543 133.333 154.543 133.333 154.29 133.333Z",
    fill: "#567601"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M165.4 133.333C165.905 133.081 166.41 131.818 166.41 131.818C166.41 131.818 165.905 131.566 165.4 131.313V131.061C165.905 131.061 166.41 131.061 166.41 131.061C166.41 131.061 166.41 129.798 165.905 129.293C166.41 129.04 166.915 128.03 166.915 128.03C166.915 128.03 166.157 127.525 165.4 127.273C165.652 127.273 165.905 127.02 165.905 127.02C166.157 126.515 166.157 125.253 166.157 125.253C166.157 125.253 165.652 125.253 165.4 125.253V125L164.895 125.253H164.642C164.137 125 163.127 125 163.127 125C163.127 125 163.127 125.253 163.127 125.505C162.874 125.505 162.369 126.01 162.117 126.263C161.612 126.01 161.359 125.758 161.359 125.758C161.359 125.758 161.107 126.01 161.107 126.515H160.854L160.602 126.263C160.349 126.263 160.349 126.01 160.097 126.263C160.097 126.515 160.097 126.768 160.097 127.02C160.097 127.02 160.097 127.02 159.844 127.02H159.592C159.592 127.02 159.086 128.283 159.339 128.788C159.339 128.788 159.339 129.04 159.592 129.04C159.592 129.293 159.592 129.798 159.844 130.051C159.339 130.303 159.087 130.556 159.087 130.556C159.087 130.556 159.592 131.061 159.844 131.313C159.592 131.566 159.339 132.576 159.592 132.828V133.081C159.086 133.333 158.834 134.596 158.834 134.596C158.834 134.596 159.086 134.596 159.339 134.848V135.101C159.339 135.354 159.087 135.354 159.087 135.354C159.087 135.606 159.339 135.606 159.592 135.859L159.844 136.111C160.097 136.364 159.592 136.364 159.339 136.364C159.339 136.364 159.592 137.626 159.844 137.879V138.636C159.844 138.889 159.844 139.141 159.844 139.141V139.899H160.097C160.097 140.152 160.349 140.404 160.349 140.404C160.349 140.404 161.612 139.899 161.864 139.394V139.141C162.117 139.394 162.622 139.646 162.622 139.646C162.622 139.646 163.127 139.141 163.127 138.636C163.127 138.636 163.127 138.636 163.379 138.636C163.884 138.889 165.147 138.636 165.147 138.636C165.147 138.636 165.147 138.131 164.895 137.879C165.4 138.131 166.157 138.131 166.157 138.131C166.157 138.131 166.157 136.869 165.905 136.364C165.905 136.364 165.652 136.364 165.652 136.111C166.157 135.859 166.662 134.848 166.662 134.848L166.41 134.596H166.157L165.905 134.343V134.091C165.905 134.091 165.905 134.091 166.157 133.838C166.41 133.586 166.915 132.828 166.915 132.828C166.915 132.828 166.41 132.576 165.905 132.323L165.4 133.333C165.147 133.333 165.147 133.333 165.4 133.333Z",
    fill: "#638800"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M164.389 124.748L163.884 124.495C163.884 123.99 162.622 122.98 162.622 122.98C162.622 122.98 162.622 123.233 162.369 123.233C162.117 122.727 161.106 121.97 161.106 121.97C161.106 121.97 161.106 122.222 160.854 122.475C160.349 121.97 159.591 121.465 159.591 121.465C159.591 121.465 159.339 121.97 159.086 122.727C159.086 122.475 158.834 122.475 158.834 122.475C158.834 122.475 157.571 122.98 157.319 123.485C157.319 123.485 157.319 123.738 157.319 123.99C156.813 123.99 155.803 123.99 155.803 123.99C155.803 123.99 155.803 124.243 156.056 124.748L155.803 125C155.551 125 155.551 125 155.298 125C154.793 125 153.783 126.263 153.783 126.263C153.783 126.263 154.793 127.273 155.551 127.273H155.803C155.803 127.778 157.066 128.536 157.066 128.536C157.066 128.536 157.319 128.283 157.571 128.03H157.824C158.076 128.536 158.834 129.293 158.834 129.293C158.834 129.293 159.086 129.041 159.339 128.788H159.591C159.591 128.788 159.591 128.788 159.591 129.041C159.844 129.293 160.096 129.293 160.349 129.293C160.854 129.293 161.359 129.293 161.359 129.293C161.359 129.293 161.359 129.041 161.359 128.536C161.611 128.788 162.117 129.041 162.117 129.041C162.117 129.041 162.874 128.283 162.874 127.525H163.127C163.379 127.778 163.884 128.283 163.884 128.283C163.884 128.283 164.642 127.273 164.642 126.768C164.894 126.768 164.894 126.768 165.147 126.768C165.652 126.768 166.662 125.505 166.662 125.505C166.662 125.505 164.894 124.748 164.389 124.748Z",
    fill: "#769C11"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_337_9182",
    x1: 152.415,
    y1: 131.541,
    x2: 140.73,
    y2: 111.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_337_9182",
    x1: 131.145,
    y1: 149.422,
    x2: 148.113,
    y2: 120.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6D6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#DCD5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3911,
    stopColor: "#C2D4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7053,
    stopColor: "#97D1B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#74CFBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_337_9182",
    x1: 148.146,
    y1: 135.452,
    x2: 143.247,
    y2: 113.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_337_9182",
    x1: 145.741,
    y1: 89.3976,
    x2: 145.741,
    y2: 70.9145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_337_9182",
    x1: 147.255,
    y1: 87.0796,
    x2: 144.579,
    y2: 74.9306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_337_9182",
    x1: 145.741,
    y1: 64.2522,
    x2: 145.741,
    y2: 45.7691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_337_9182",
    x1: 147.255,
    y1: 61.9342,
    x2: 144.579,
    y2: 49.7852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_337_9182",
    x1: 144.08,
    y1: 36.6025,
    x2: 143.529,
    y2: 27.3164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_337_9182",
    x1: 134.173,
    y1: 36.3265,
    x2: 145.724,
    y2: 28.1338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00202B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1361,
    stopColor: "#002430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2934,
    stopColor: "#002E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3891,
    stopColor: "#00374A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    stopColor: "#003F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    stopColor: "#00506D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6291,
    stopColor: "#00658A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7357,
    stopColor: "#006990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8766,
    stopColor: "#0075A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_337_9182",
    x1: 135.288,
    y1: 141.48,
    x2: 123.602,
    y2: 121.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_337_9182",
    x1: 114.018,
    y1: 159.362,
    x2: 130.985,
    y2: 129.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6D6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#DCD5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3911,
    stopColor: "#C2D4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7053,
    stopColor: "#97D1B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#74CFBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_337_9182",
    x1: 131.019,
    y1: 145.391,
    x2: 126.119,
    y2: 123.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_337_9182",
    x1: 128.603,
    y1: 99.3347,
    x2: 128.603,
    y2: 80.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_337_9182",
    x1: 130.119,
    y1: 97.0172,
    x2: 127.444,
    y2: 84.8682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_337_9182",
    x1: 128.603,
    y1: 74.1901,
    x2: 128.603,
    y2: 55.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_337_9182",
    x1: 130.119,
    y1: 71.8722,
    x2: 127.444,
    y2: 59.7232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_337_9182",
    x1: 126.95,
    y1: 46.5406,
    x2: 126.4,
    y2: 37.2545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_337_9182",
    x1: 117.047,
    y1: 46.2649,
    x2: 128.599,
    y2: 38.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00202B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1361,
    stopColor: "#002430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2934,
    stopColor: "#002E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3891,
    stopColor: "#00374A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    stopColor: "#003F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    stopColor: "#00506D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6291,
    stopColor: "#00658A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7357,
    stopColor: "#006990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8766,
    stopColor: "#0075A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_337_9182",
    x1: 118.16,
    y1: 151.42,
    x2: 106.475,
    y2: 131.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_337_9182",
    x1: 96.892,
    y1: 169.301,
    x2: 113.859,
    y2: 139.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6D6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#DCD5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3911,
    stopColor: "#C2D4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7053,
    stopColor: "#97D1B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#74CFBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_337_9182",
    x1: 113.893,
    y1: 155.331,
    x2: 108.993,
    y2: 133.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_337_9182",
    x1: 111.48,
    y1: 109.273,
    x2: 111.48,
    y2: 90.7895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_337_9182",
    x1: 112.996,
    y1: 106.955,
    x2: 110.32,
    y2: 94.8057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_337_9182",
    x1: 111.48,
    y1: 84.1267,
    x2: 111.48,
    y2: 65.6436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_337_9182",
    x1: 112.996,
    y1: 81.8087,
    x2: 110.32,
    y2: 69.6597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_337_9182",
    x1: 109.823,
    y1: 56.4791,
    x2: 109.272,
    y2: 47.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_337_9182",
    x1: 99.9197,
    y1: 56.2035,
    x2: 111.471,
    y2: 48.0107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00202B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1361,
    stopColor: "#002430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2934,
    stopColor: "#002E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3891,
    stopColor: "#00374A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    stopColor: "#003F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    stopColor: "#00506D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6291,
    stopColor: "#00658A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7357,
    stopColor: "#006990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8766,
    stopColor: "#0075A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_337_9182",
    x1: 101.03,
    y1: 161.356,
    x2: 89.3453,
    y2: 141.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_337_9182",
    x1: 79.7607,
    y1: 179.237,
    x2: 96.7276,
    y2: 149.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6D6A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#DCD5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3911,
    stopColor: "#C2D4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7053,
    stopColor: "#97D1B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#74CFBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_337_9182",
    x1: 96.7612,
    y1: 165.266,
    x2: 91.8619,
    y2: 143.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_337_9182",
    x1: 94.3555,
    y1: 119.213,
    x2: 94.3555,
    y2: 100.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_337_9182",
    x1: 95.868,
    y1: 116.895,
    x2: 93.1925,
    y2: 104.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_337_9182",
    x1: 94.3555,
    y1: 94.0667,
    x2: 94.3555,
    y2: 75.5836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_337_9182",
    x1: 95.868,
    y1: 91.7487,
    x2: 93.1924,
    y2: 79.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43877E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    stopColor: "#398275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#307D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_337_9182",
    x1: 92.6963,
    y1: 66.4176,
    x2: 92.1455,
    y2: 57.1315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_337_9182",
    x1: 82.7895,
    y1: 66.1419,
    x2: 94.3408,
    y2: 57.9492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00202B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1361,
    stopColor: "#002430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2934,
    stopColor: "#002E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3891,
    stopColor: "#00374A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    stopColor: "#003F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    stopColor: "#00506D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6291,
    stopColor: "#00658A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7357,
    stopColor: "#006990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8766,
    stopColor: "#0075A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_337_9182",
    x1: 38.6971,
    y1: 151.42,
    x2: 50.3822,
    y2: 131.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_337_9182",
    x1: 59.9663,
    y1: 169.301,
    x2: 42.9994,
    y2: 139.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#517D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#477569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#2D615C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#295E5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_337_9182",
    x1: 42.9672,
    y1: 155.331,
    x2: 47.8665,
    y2: 133.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8527,
    stopColor: "#0F2521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#0E2420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_337_9182",
    x1: 45.376,
    y1: 109.272,
    x2: 45.376,
    y2: 90.7891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#517D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#477569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#2D615C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#295E5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_337_9182",
    x1: 43.8645,
    y1: 106.954,
    x2: 46.54,
    y2: 94.8052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8527,
    stopColor: "#0F2521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#0E2420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_337_9182",
    x1: 45.376,
    y1: 84.1287,
    x2: 45.376,
    y2: 65.6456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#517D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#477569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#2D615C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#295E5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_337_9182",
    x1: 43.8645,
    y1: 81.8106,
    x2: 46.54,
    y2: 69.6617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8527,
    stopColor: "#0F2521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#0E2420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_337_9182",
    x1: 47.0328,
    y1: 56.4791,
    x2: 47.5838,
    y2: 47.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#517D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#477569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#2D615C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#295E5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_337_9182",
    x1: 56.9393,
    y1: 56.2044,
    x2: 45.388,
    y2: 48.0117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00202B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1361,
    stopColor: "#002430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2934,
    stopColor: "#002E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3891,
    stopColor: "#00374A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    stopColor: "#003F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    stopColor: "#00506D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6291,
    stopColor: "#00658A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7357,
    stopColor: "#006990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8766,
    stopColor: "#0075A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_337_9182",
    x1: 55.8268,
    y1: 161.356,
    x2: 67.5119,
    y2: 141.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    stopColor: "#96E1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6684,
    stopColor: "#6FD0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#60C9B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_337_9182",
    x1: 77.096,
    y1: 179.238,
    x2: 60.129,
    y2: 149.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#517D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#477569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#2D615C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#295E5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_337_9182",
    x1: 60.0949,
    y1: 165.267,
    x2: 64.9942,
    y2: 143.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8527,
    stopColor: "#0F2521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#0E2420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_337_9182",
    x1: 62.5023,
    y1: 119.213,
    x2: 62.5023,
    y2: 100.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#517D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#477569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#2D615C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#295E5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_337_9182",
    x1: 60.99,
    y1: 116.895,
    x2: 63.6655,
    y2: 104.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8527,
    stopColor: "#0F2521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#0E2420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_337_9182",
    x1: 62.5023,
    y1: 94.0667,
    x2: 62.5023,
    y2: 75.5836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#517D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#477569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#2D615C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#295E5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_337_9182",
    x1: 60.99,
    y1: 91.7487,
    x2: 63.6655,
    y2: 79.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8527,
    stopColor: "#0F2521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#0E2420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_337_9182",
    x1: 64.1605,
    y1: 66.4176,
    x2: 64.7115,
    y2: 57.1315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#517D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#477569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#2D615C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    stopColor: "#295E5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_337_9182",
    x1: 74.0667,
    y1: 66.1419,
    x2: 62.5154,
    y2: 57.9492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00202B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1361,
    stopColor: "#002430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2934,
    stopColor: "#002E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3891,
    stopColor: "#00374A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    stopColor: "#003F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6218,
    stopColor: "#00506D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6291,
    stopColor: "#00658A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7357,
    stopColor: "#006990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8766,
    stopColor: "#0075A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_337_9182",
    x1: 158.193,
    y1: 100.513,
    x2: 158.775,
    y2: 99.5058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1613,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1633,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5593,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5622,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8728,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8739,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_337_9182",
    x1: 165.088,
    y1: 104.513,
    x2: 160.121,
    y2: 95.9093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1613,
    stopColor: "#9A0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1633,
    stopColor: "#BD0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5593,
    stopColor: "#BD0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5622,
    stopColor: "#CA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8728,
    stopColor: "#CA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8739,
    stopColor: "#E10100"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllInclusive);
export default __webpack_public_path__ + "static/media/allInclusive.102a87a409db7a77a0c450957f49b606.svg";
export { ForwardRef as ReactComponent };